// src/data/cardData.js
export const CARD_DATA = [
  {
    id: "40till5",
    name: "40till5",
    subtitle: "〈Designer〉",
    level: "∞",
    theme: "cosmicPurple",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/40till5.png",
    type: "Creature – OG Memer",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Every wave between you and I, recieved. The cosmos, interpreted by waves, through waves. If we can perceive, can we not also impact?",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "aetos1",
    name: "Aetos",
    subtitle: "⟨WARBOND⟩",
    level: "1",
    theme: "skyBlue",
    manaCost: [
      {
        type: "hp",
        value: "3",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/fledgling_eagle.png",
    type: "Creature — Fledgling Eagle",
    stats: {
      attack: "1",
      defense: "2",
    },
    flavorText:
      "Knight's Roost ⟨+2DEF⟩\nBorn of wind and cloud, I carry dreams skyward.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "aetos2",
    name: "Aetos",
    subtitle: "⟨FAMILIAR⟩",
    level: "2",
    theme: "steelSky",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ya_eagle.png",
    type: "Creature — Eagle Knight",
    stats: {
      attack: "4",
      defense: "2",
    },
    flavorText:
      "Talons and Beak ⟨4D : 3TD⟩\nScout's Eye: Reveal 2 Random Cards in the opposing players deck ⟨3M⟩\n'Trust him more than my own two feet' -Knight",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "aetosmax",
    name: "Aetos",
    subtitle: "⟨Soverign⟩",
    level: "3",
    theme: "sunsetFire",
    manaCost: [
      {
        type: "hp",
        value: "10",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "5",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/aetos.png",
    type: "Creature — Armored Eagle",
    stats: {
      attack: "8",
      defense: "5",
    },
    flavorText:
      "Atmospheric Assault ⟨8D : 6TD⟩\nSteel, Blood, Feathers, Screams and Screeches.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ben",
    name: "Ben",
    subtitle: "⟨MEME KING⟩",
    level: "∞",
    theme: "alchemicalRed",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ben.png",
    type: "Creature — Artist",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Humankind cannot gain anything without first giving something in return. To obtain something, something of equal value must be lost. That is alchemy's first law of Equivalent Exchange.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "bliddo",
    name: "Bliddo",
    subtitle: "⟨Card Crafter⟩",
    level: "∞",
    theme: "steelPsychic",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/bliddo.png",
    type: "Creature — COPYCAT",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText: "Saw what you did there, glad I thought of it.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "cag",
    name: "Cag",
    subtitle: "〈ZEN〉",
    level: "∞",
    theme: "airyWhite",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/cag.png",
    type: "Creature – Wanderer",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Empty the mind, release the self, become one with the infinite void. In detachment from material bonds, true freedom is found.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "cyclops",
    name: "Rampage",
    subtitle: "〈Ogrid〉",
    level: "2",
    theme: "stoneMoss",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/cyclops.png",
    type: "Creature – Cyclops",
    stats: {
      attack: "4",
      defense: "5",
    },
    flavorText:
      "Big Stick Swinging〈4D : 30% SE : 1TR〉\n(30% chance for tree to fracture causing bleed effect. 1 turn conditional recharge)",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ent",
    name: "Ent",
    subtitle: "⟨Woodland⟩",
    level: "1",
    theme: "darkForest",
    manaCost: [
      {
        type: "hp",
        value: "3",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ent.png",
    type: "Creature — Living Forest",
    stats: {
      attack: "0",
      defense: "4",
    },
    flavorText:
      "Passive: While this card is fielded, all ally cards on the field get +1 DEF every turn.\n'Wood, Water, Sapling, Iceberg.'",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "fairyfountain",
    name: "Moonwell Sanctuary",
    subtitle: "",
    level: "★",
    theme: "moonlight",
    manaCost: [
      {
        type: "hp",
        value: "★",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/fairy fountain.png",
    type: "Consumable — Mana Restoration",
    stats: null,
    flavorText:
      "Fairy Magic ⟨+3M⟩\nWhere moonbeams kiss the sacred waters, ancient magic flows eternal.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "fisherman",
    name: "Fisherman",
    subtitle: "⟨Monger⟩",
    level: "∞",
    theme: "beachOcean",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/fisherman.png",
    type: "Creature — Peaceful Angler",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText: "Sometimes, the best catch is a moment of peace.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "forestspirit",
    name: "Forest Spirit",
    subtitle: "⟨VOID⟩",
    level: "1",
    theme: "shadowVoid",
    manaCost: [
      {
        type: "hp",
        value: "3",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/forestspirit.png",
    type: "Creature — Nightmare Beast",
    stats: {
      attack: "2",
      defense: "2",
    },
    flavorText:
      "Void Strike ⟨2D : 2TD⟩\nSpirit Rend ⟨Sleeping targets take 50% HP as TD⟩",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "getri1",
    name: "Getri",
    subtitle: "⟨Ancient⟩",
    level: "1",
    theme: "earthGreen",
    manaCost: [
      {
        type: "hp",
        value: "3",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/wyrm.png",
    type: "Creature — Wyrm",
    stats: {
      attack: "2",
      defense: "1",
    },
    flavorText:
      "Bite ⟨2D : 1TD⟩\nPassive: Can evolve into Hydra after 3 turns on field",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "getri2",
    name: "Getri",
    subtitle: "⟨ANCIENT⟩",
    level: "2",
    theme: "ancientEarth",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/hydra.png",
    type: "Creature — Hydra Beast",
    stats: {
      attack: "6",
      defense: "2",
    },
    flavorText: "Tri Attack ⟨6D : 3TD⟩\nPassive: Upon death, spawn a Wyrm",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "golem",
    name: "Stone Guardian",
    subtitle: "⟨SENTINEL⟩",
    level: "3",
    theme: "stoneGuardian",
    manaCost: [
      {
        type: "hp",
        value: "10",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "5",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/golem.png",
    type: "Construct — Stone Golem",
    stats: {
      attack: "3",
      defense: "7",
    },
    flavorText:
      "Carved from the mountain's heart, I stand eternal vigil over sacred grounds.\nPassive: Take 50% Reduced TD",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "hol",
    name: "HOL",
    subtitle: "〈FED〉",
    level: "∞",
    theme: "federalNavy",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/hol.png",
    type: "Creature – That Guy",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "He didn't know anything, other than how to be an asshole. Broke the news to him while he was eviscerated out of this plane of existance on drugs he didn't know and doses he couldn't measure. Serves him right.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "johnny",
    name: "Johnny",
    subtitle: "〈Gambler〉",
    level: "∞",
    theme: "retroGaming",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/albinoApe.png",
    type: "Creature — Albino Ape",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Eternal salvation was promised to this ape before he was born.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "juror",
    name: "Juror",
    subtitle: "〈KLEROS〉",
    level: "∞",
    theme: "purpleJustice",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/pinakion.png",
    type: "Creature – Decentralized Judge",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Where consensus meets justice, in the court of cryptographic truth, every dispute finds its resolution through the ancient scales of collective reason.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "kraken",
    name: "Kro",
    subtitle: "⟨DEPTHS⟩",
    level: "3",
    theme: "steelOcean",
    manaCost: [
      {
        type: "hp",
        value: "10",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "5",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/kraken.png",
    type: "Creature — The Kraken",
    stats: {
      attack: "8",
      defense: "5",
    },
    flavorText:
      "Tentacle Crush ⟨8D : 6TD⟩\nDepths Dominion: All water creatures gain +2/+1 ⟨5M⟩",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lich",
    name: "Lich",
    subtitle: "〈UNDYING〉",
    level: "2",
    theme: "necromantic",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/lich.png",
    type: "Creature — Necromancer",
    stats: {
      attack: "2",
      defense: "8",
    },
    flavorText:
      "Raise Dead ⟨5M: Summon 2 Zombies⟩\nArmy of Darkness: +1〈ATK〉for each Zombie on field",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lillie007",
    name: "Lillie007",
    subtitle: "〈Agent〉",
    level: "∞",
    theme: "silverAgent",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/Lillie007.png",
    type: "Creature – Op",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText: "Baby Mama?\nYes Baby Daddy?",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "mrf",
    name: "Mr. F",
    subtitle: "〈GENESIS〉",
    level: "∞",
    theme: "ethereumPurple",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/mrf.png",
    type: "Creature – Genesis Validator",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "From the first block forged in digital fire. Guardian of consensus, keeper of the protocol's promise, forever bound to the network's beating heart.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "nitro",
    name: "Nitro Slav",
    subtitle: "⟨LUXURY⟩",
    level: "∞",
    theme: "beachLuxury",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/Nitro.png",
    type: "Creature — Vacation Master",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Whether it's nine ETH for a BOARD, or nine foot backs off the coast of Kona, Nitro is always the first in the water. An example for all surfers, if the water is wet, Nitro is surfing.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "pep",
    name: "Pep",
    subtitle: "〈AEGIS〉",
    level: "∞",
    theme: "pureGold",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/pep.jpg",
    type: "Creature – Developer Sage",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "In the depths of blockchain realms, where smart contracts weave destiny itself, stands the architect of digital empires. Master of the AEGIS protocol, guardian of decentralized dreams.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "phelob",
    name: "Phelob",
    subtitle: "⟨Cave King⟩",
    level: "2",
    theme: "darkForest",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/Phelob.png",
    type: "Creature — Giant Cave Spider",
    stats: {
      attack: "4",
      defense: "2",
    },
    flavorText:
      "Hemodrain ⟨4D - 50% Lifesteal⟩\nIn the deepest tunnels, where light fears to tread, ancient things still weave their schemes.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "phoenix",
    name: "Feelsix",
    subtitle: "⟨Mythical⟩",
    level: "3",
    theme: "phoenixFire",
    manaCost: [
      {
        type: "hp",
        value: "10",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "5",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/phoenix.png",
    type: "Creature — Phoenix",
    stats: {
      attack: "3",
      defense: "4",
    },
    flavorText:
      "Scorched Earth ⟨4M : Deal 1TD to all enemy cards⟩\nPassive: Attacking places this card in the graveyard for one turn, after which it's returned to the players hand.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "proof",
    name: "Proof",
    subtitle: "〈SURF〉",
    level: "∞",
    theme: "oceanBlue",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/proof.png",
    type: "Creature — DeFi Innovator",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Where liquidity meets innovation, riding the waves of DeFi protocols with unmatched precision. Master of automated market makers, guardian of yield strategies, architect of the next financial tide.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "sasquepe",
    name: "Sasquepe",
    subtitle: "〈CRYPTID〉",
    level: "1",
    theme: "woodlandBrown",
    manaCost: [
      {
        type: "hp",
        value: "3",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/sasquepe.png",
    type: "Creature — Great Ape",
    stats: {
      attack: "5",
      defense: "3",
    },
    flavorText:
      "Hammer Fist ⟨5D : 3TD⟩\nRush: This card can attack the same turn it's fielded",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "shaman",
    name: "Forest Shaman",
    subtitle: "⟨MYSTIC⟩",
    level: "2",
    theme: "mysticalForest",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/warlock.png",
    type: "Creature — Warlock",
    stats: {
      attack: "5",
      defense: "6",
    },
    flavorText:
      "Spirit Call ⟨Summon a Forest Spirit token 2/2⟩\nAncient Wisdom: Draw 2 cards, gain +1/+1 for each nature card ⟨4M⟩\nThe forest whispers secrets to those who truly listen.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "slightofhand",
    name: "Slight of Hand",
    subtitle: "",
    level: "★",
    theme: "casinoGold",
    manaCost: [
      {
        type: "hp",
        value: "★",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/soh.png",
    type: "Consumable — Cards",
    stats: null,
    flavorText:
      "Slight of Hand ⟨Draw two addition cards⟩\nWhere fortunes rise and fall with the turn of a card, luck favors the bold.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "moonwraith",
    name: "Moonwraith",
    subtitle: "〈PHANTOM〉",
    level: "2",
    theme: "spectralPurple",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/specter.png",
    type: "Creature — Specter",
    stats: {
      attack: "2",
      defense: "4",
    },
    flavorText:
      "Phase Shift ⟨3M: Become untargetable for 2 turns⟩\nSpectral Blade ⟨1D: 2TD⟩",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "tokiru",
    name: "Tokiru",
    subtitle: "⟨Shell Wanderer⟩",
    level: "2",
    theme: "earthVolcanic",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/tokiru.png",
    type: "Creature — Ancient Turtle",
    stats: {
      attack: "2",
      defense: "4",
    },
    flavorText:
      "Shell Fortress ⟨-1 from all damage⟩\nThrough countless eruptions I have walked, my shell bearing the wisdom of ages.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "vanpe",
    name: "Vanpe",
    subtitle: "⟨Antirush⟩",
    level: "1",
    theme: "deepSeaTeal",
    manaCost: [
      {
        type: "hp",
        value: "3",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/vanpe.png",
    type: "Creature — Urchin",
    stats: {
      attack: "0",
      defense: "3",
    },
    flavorText:
      "Passive: Attack damage agaisnt Vanpe is multiplied by 0.5 and applied as TD",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "yostari",
    name: "Yostari",
    subtitle: "〈Scribe〉",
    level: "∞",
    theme: "steelTech",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/yostari.png",
    type: "Creature – Tech Archivist",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Every event push catalogued, every price change recorded, every fragment of the old world's wisdom safeguarded for humanity's future.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "zombie",
    name: "Zombie",
    subtitle: "〈Undying〉",
    level: "1",
    theme: "graveyardGreen",
    manaCost: [
      {
        type: "hp",
        value: "3",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "1",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/zombie.png",
    type: "Creature — Zombie",
    stats: {
      attack: "1",
      defense: "1",
    },
    flavorText:
      "Bite ⟨1D : 1TD⟩\nPassive: Undying - 50% chance to return to field on death\nHorde Mentality: +1 ATK for each other Zombie on field",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "Unicorn",
    name: "Unicorn",
    subtitle: "〈Mystical〉",
    level: "2",
    theme: "celestialPink",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/unicorn.png",
    type: "Creature – Unicorn",
    stats: {
      attack: "3",
      defense: "4",
    },
    flavorText:
      "Horn of Purity ⟨3M: Heal ally for 2HP⟩\nWhere magic and grace unite, legends are born under starlight.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "foresttitan",
    name: "Forest Titan",
    subtitle: "⟨ANCIENT⟩",
    level: "3",
    theme: "ancientGlade",
    manaCost: [
      {
        type: "hp",
        value: "10",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "5",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/foresttitan.png",
    type: "Creature — Ancient Treant",
    stats: {
      attack: "4",
      defense: "8",
    },
    flavorText:
      "Nature's Wrath ⟨4D : 4TD⟩\nPassive: At the start of each turn, heal 1 HP to all ally creatures\n'From the ancient roots, wisdom and power intertwine.'",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "treant",
    name: "Forest Keeper",
    subtitle: "⟨GUARDIAN⟩",
    level: "2",
    theme: "enchantedGrove",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/treant.png",
    type: "Creature — Forest Guardian",
    stats: {
      attack: "4",
      defense: "6",
    },
    flavorText:
      "Sacred Grove ⟨4D : 2TD⟩\nPassive: All allied creatures gain +1 DEF while Forest Keeper is on the field.",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "beachjester",
    name: "Beach Bum",
    subtitle: "⟨WANDERER⟩",
    level: "∞",
    theme: "tropicalParadise",
    manaCost: [
      {
        type: "hp",
        value: "∞",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "6",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/beachjester.png",
    type: "Creature — Beach Philosopher",
    stats: {
      attack: "∞",
      defense: "∞",
    },
    flavorText:
      "Island Time ⟨Passive: While on field, all allies gain +1 ATK at the start of turn\n'Sometimes the best strategy is no strategy at all. Just vibes.'",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lootgremlin",
    name: "Gribble",
    subtitle: "⟨HOARDER⟩",
    level: "2",
    theme: "treasureHoard",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "3",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/lootgremlin.png",
    type: "Creature — Treasure Goblin",
    stats: {
      attack: "3",
      defense: "4",
    },
    flavorText:
      "Coin Toss ⟨3M: Deal 2 TD to target, gain 1 HP⟩\nPassive: When this card is destroyed, spawn 2 Gold tokens\n'Not all treasure is silver and gold, mate... but most of it is.'",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "aboleth",
    name: "Aboleth",
    subtitle: "",
    level: "1",
    theme: "aboleth",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/aboleth.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from aboleth. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "acolyte",
    name: "Acolyte",
    subtitle: "",
    level: "1",
    theme: "acolyte",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/acolyte.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from acolyte. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "acolyte2",
    name: "Acolyte 2",
    subtitle: "",
    level: "1",
    theme: "acolyte",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/acolyte_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from acolyte_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "adultbronzedragon",
    name: "Adult Bronze Dragon",
    subtitle: "",
    level: "1",
    theme: "adultBronzeDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/adult_bronze_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from adult_bronze_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "adultcopperdragon",
    name: "Adult Copper Dragon",
    subtitle: "",
    level: "1",
    theme: "adultCopperDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/adult_copper_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from adult_copper_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "adultgolddragon",
    name: "Adult Gold Dragon",
    subtitle: "",
    level: "1",
    theme: "adultGoldDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/adult_gold_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from adult_gold_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "adultgreendragon",
    name: "Adult Green Dragon",
    subtitle: "",
    level: "1",
    theme: "adultGreenDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/adult_green_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from adult_green_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "adultgreendragon2",
    name: "Adult Green Dragon 2",
    subtitle: "",
    level: "1",
    theme: "adultGreenDragon2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/adult_green_dragon_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from adult_green_dragon_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "adultsilverdragon",
    name: "Adult Silver Dragon",
    subtitle: "",
    level: "1",
    theme: "adultSilverDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/adult_silver_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from adult_silver_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "airelemental",
    name: "Air Elemental",
    subtitle: "",
    level: "1",
    theme: "airElemental",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/air_elemental.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from air_elemental. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientblackdragon",
    name: "Ancient Black Dragon",
    subtitle: "",
    level: "1",
    theme: "ancientBlackDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_black_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_black_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientbrassdragon",
    name: "Ancient Brass Dragon",
    subtitle: "",
    level: "1",
    theme: "ancientBrassDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_brass_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_brass_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientbronzedragon",
    name: "Ancient Bronze Dragon",
    subtitle: "",
    level: "1",
    theme: "ancientBronzeDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_bronze_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_bronze_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientcopperdragon",
    name: "Ancient Copper Dragon",
    subtitle: "",
    level: "1",
    theme: "ancientCopperDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_copper_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_copper_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientgolddragon2",
    name: "Ancient Gold Dragon 2",
    subtitle: "",
    level: "1",
    theme: "ancientGoldDragon2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_gold_dragon_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_gold_dragon_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientgolddragon3",
    name: "Ancient Gold Dragon 3",
    subtitle: "",
    level: "1",
    theme: "ancientGoldDragon3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_gold_dragon_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_gold_dragon_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientgreendragon",
    name: "Ancient Green Dragon",
    subtitle: "",
    level: "1",
    theme: "ancientGreenDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_green_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_green_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientreddragon",
    name: "Ancient Red Dragon",
    subtitle: "",
    level: "1",
    theme: "ancientRedDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_red_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_red_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ancientsilverdragon",
    name: "Ancient Silver Dragon",
    subtitle: "",
    level: "1",
    theme: "ancientSilverDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ancient_silver_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ancient_silver_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "androsphinx",
    name: "Androsphinx",
    subtitle: "",
    level: "1",
    theme: "androsphinx",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/androsphinx.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from androsphinx. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "animatedarmor",
    name: "Animated Armor",
    subtitle: "",
    level: "1",
    theme: "animatedArmor",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/animated_armor.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from animated_armor. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "awakenedshrub",
    name: "Awakened Shrub",
    subtitle: "",
    level: "1",
    theme: "awakenedShrub",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/awakened_shrub.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from awakened_shrub. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "azer",
    name: "Azer",
    subtitle: "",
    level: "1",
    theme: "azer",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/azer.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from azer. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "baboon",
    name: "Baboon",
    subtitle: "",
    level: "1",
    theme: "baboon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/baboon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from baboon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "baboon2",
    name: "Baboon 2",
    subtitle: "",
    level: "1",
    theme: "baboon2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/baboon_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from baboon_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "balor",
    name: "Balor",
    subtitle: "",
    level: "1",
    theme: "balor",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/balor.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from balor. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "banditcaptain",
    name: "Bandit Captain",
    subtitle: "",
    level: "1",
    theme: "banditCaptain",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/bandit_captain.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from bandit_captain. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "barbeddevil2",
    name: "Barbed Devil 2",
    subtitle: "",
    level: "1",
    theme: "barbedDevil2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/barbed_devil_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from barbed_devil_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "bat",
    name: "Bat",
    subtitle: "",
    level: "1",
    theme: "bat",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/bat.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from bat. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "beardeddevil3",
    name: "Bearded Devil 3",
    subtitle: "",
    level: "1",
    theme: "beardedDevil3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/bearded_devil_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from bearded_devil_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "behir",
    name: "Behir",
    subtitle: "",
    level: "1",
    theme: "behir",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/behir.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from behir. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "berserker2",
    name: "Berserker 2",
    subtitle: "",
    level: "1",
    theme: "berserker2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/berserker_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from berserker_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "blackbear",
    name: "Black Bear",
    subtitle: "",
    level: "1",
    theme: "blackBear",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/black_bear.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from black_bear. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "blackdragonwyrmling",
    name: "Black Dragon Wyrmling",
    subtitle: "",
    level: "1",
    theme: "blackDragonWyrmling",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/black_dragon_wyrmling.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from black_dragon_wyrmling. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "blackpudding3",
    name: "Black Pudding 3",
    subtitle: "",
    level: "1",
    theme: "blackPudding3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/black_pudding_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from black_pudding_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "bloodhawk",
    name: "Blood Hawk",
    subtitle: "",
    level: "1",
    theme: "bloodHawk",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/blood_hawk.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from blood_hawk. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "boar2",
    name: "Boar 2",
    subtitle: "",
    level: "1",
    theme: "boar2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/boar_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from boar_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "bugbear",
    name: "Bugbear",
    subtitle: "",
    level: "1",
    theme: "bugbear",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/bugbear.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from bugbear. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "bugbear2",
    name: "Bugbear 2",
    subtitle: "",
    level: "1",
    theme: "bugbear2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/bugbear_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from bugbear_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "chimera",
    name: "Chimera",
    subtitle: "",
    level: "1",
    theme: "chimera",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/chimera.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from chimera. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "chuul",
    name: "Chuul",
    subtitle: "",
    level: "1",
    theme: "chuul",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/chuul.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from chuul. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "cloudgiant",
    name: "Cloud Giant",
    subtitle: "",
    level: "1",
    theme: "cloudGiant",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/cloud_giant.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from cloud_giant. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "cloudgiant2",
    name: "Cloud Giant 2",
    subtitle: "",
    level: "1",
    theme: "cloudGiant2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/cloud_giant_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from cloud_giant_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "cockatrice2",
    name: "Cockatrice 2",
    subtitle: "",
    level: "1",
    theme: "cockatrice2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/cockatrice_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from cockatrice_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "copperdragonwyrmling3",
    name: "Copper Dragon Wyrmling 3",
    subtitle: "",
    level: "1",
    theme: "copperDragonWyrmling3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/copper_dragon_wyrmling_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from copper_dragon_wyrmling_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "couatl",
    name: "Couatl",
    subtitle: "",
    level: "1",
    theme: "couatl",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/couatl.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from couatl. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "cultist",
    name: "Cultist",
    subtitle: "",
    level: "1",
    theme: "cultist",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/cultist.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from cultist. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "cultfanatic",
    name: "Cult Fanatic",
    subtitle: "",
    level: "1",
    theme: "cultFanatic",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/cult_fanatic.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from cult_fanatic. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "darkmantle2",
    name: "Darkmantle 2",
    subtitle: "",
    level: "1",
    theme: "darkmantle2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/darkmantle_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from darkmantle_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "deepgnomesvirfneblin",
    name: "Deep Gnome  Svirfneblin ",
    subtitle: "",
    level: "1",
    theme: "deepGnomeSvirfneblin",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/deep_gnome__svirfneblin_.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from deep_gnome__svirfneblin_. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "drafthorse3",
    name: "Draft Horse 3",
    subtitle: "",
    level: "1",
    theme: "draftHorse3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/draft_horse_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from draft_horse_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "dragonturtle",
    name: "Dragon Turtle",
    subtitle: "",
    level: "1",
    theme: "dragonTurtle",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/dragon_turtle.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from dragon_turtle. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "dragonturtle2",
    name: "Dragon Turtle 2",
    subtitle: "",
    level: "1",
    theme: "dragonTurtle2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/dragon_turtle_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from dragon_turtle_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "drider",
    name: "Drider",
    subtitle: "",
    level: "1",
    theme: "drider",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/drider.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from drider. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "drow",
    name: "Drow",
    subtitle: "",
    level: "1",
    theme: "drow",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/drow.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from drow. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "druid",
    name: "Druid",
    subtitle: "",
    level: "1",
    theme: "druid",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/druid.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from druid. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "dryad2",
    name: "Dryad 2",
    subtitle: "",
    level: "1",
    theme: "dryad2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/dryad_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from dryad_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "duergar2",
    name: "Duergar 2",
    subtitle: "",
    level: "1",
    theme: "duergar2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/duergar_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from duergar_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "dustmephit",
    name: "Dust Mephit",
    subtitle: "",
    level: "1",
    theme: "dustMephit",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/dust_mephit.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from dust_mephit. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "efreeti2",
    name: "Efreeti 2",
    subtitle: "",
    level: "1",
    theme: "efreeti2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/efreeti_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from efreeti_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "elephant2",
    name: "Elephant 2",
    subtitle: "",
    level: "1",
    theme: "elephant2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/elephant_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from elephant_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "elk3",
    name: "Elk 3",
    subtitle: "",
    level: "1",
    theme: "elk3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/elk_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from elk_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "erinyes",
    name: "Erinyes",
    subtitle: "",
    level: "1",
    theme: "erinyes",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/erinyes.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from erinyes. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ettin",
    name: "Ettin",
    subtitle: "",
    level: "1",
    theme: "ettin",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ettin.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ettin. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ettin2",
    name: "Ettin 2",
    subtitle: "",
    level: "1",
    theme: "ettin2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ettin_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ettin_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "fireelemental",
    name: "Fire Elemental",
    subtitle: "",
    level: "1",
    theme: "fireElemental",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/fire_elemental.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from fire_elemental. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "fireelemental2",
    name: "Fire Elemental 2",
    subtitle: "",
    level: "1",
    theme: "fireElemental2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/fire_elemental_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from fire_elemental_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "frostgiant",
    name: "Frost Giant",
    subtitle: "",
    level: "1",
    theme: "frostGiant",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/frost_giant.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from frost_giant. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "gelatinouscube",
    name: "Gelatinous Cube",
    subtitle: "",
    level: "1",
    theme: "gelatinousCube",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/gelatinous_cube.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from gelatinous_cube. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ghast",
    name: "Ghast",
    subtitle: "",
    level: "1",
    theme: "ghast",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ghast.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ghast. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ghast2",
    name: "Ghast 2",
    subtitle: "",
    level: "1",
    theme: "ghast2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ghast_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ghast_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantape",
    name: "Giant Ape",
    subtitle: "",
    level: "1",
    theme: "giantApe",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_ape.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_ape. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantbat",
    name: "Giant Bat",
    subtitle: "",
    level: "1",
    theme: "giantBat",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_bat.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_bat. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantcentipede",
    name: "Giant Centipede",
    subtitle: "",
    level: "1",
    theme: "giantCentipede",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_centipede.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_centipede. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantconstrictorsnake",
    name: "Giant Constrictor Snake",
    subtitle: "",
    level: "1",
    theme: "giantConstrictorSnake",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_constrictor_snake.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_constrictor_snake. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantcrab",
    name: "Giant Crab",
    subtitle: "",
    level: "1",
    theme: "giantCrab",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_crab.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_crab. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantfirebeetle",
    name: "Giant Fire Beetle",
    subtitle: "",
    level: "1",
    theme: "giantFireBeetle",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_fire_beetle.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_fire_beetle. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantfrog",
    name: "Giant Frog",
    subtitle: "",
    level: "1",
    theme: "giantFrog",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_frog.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_frog. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantgoat3",
    name: "Giant Goat 3",
    subtitle: "",
    level: "1",
    theme: "giantGoat3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_goat_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_goat_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantoctopus2",
    name: "Giant Octopus 2",
    subtitle: "",
    level: "1",
    theme: "giantOctopus2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_octopus_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_octopus_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantseahorse",
    name: "Giant Sea Horse",
    subtitle: "",
    level: "1",
    theme: "giantSeaHorse",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_sea_horse.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from giant_sea_horse. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "gibberingmouther",
    name: "Gibbering Mouther",
    subtitle: "",
    level: "1",
    theme: "gibberingMouther",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/gibbering_mouther.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from gibbering_mouther. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "glabrezu",
    name: "Glabrezu",
    subtitle: "",
    level: "1",
    theme: "glabrezu",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/glabrezu.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from glabrezu. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "goat",
    name: "Goat",
    subtitle: "",
    level: "1",
    theme: "goat",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/goat.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from goat. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "goblin",
    name: "Goblin",
    subtitle: "",
    level: "1",
    theme: "goblin",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/goblin.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from goblin. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "golddragonwyrmling2",
    name: "Gold Dragon Wyrmling 2",
    subtitle: "",
    level: "1",
    theme: "goldDragonWyrmling2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/gold_dragon_wyrmling_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from gold_dragon_wyrmling_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "gorgon",
    name: "Gorgon",
    subtitle: "",
    level: "1",
    theme: "gorgon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/gorgon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from gorgon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "greendragonwyrmling",
    name: "Green Dragon Wyrmling",
    subtitle: "",
    level: "1",
    theme: "greenDragonWyrmling",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/green_dragon_wyrmling.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from green_dragon_wyrmling. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "greenhag",
    name: "Green Hag",
    subtitle: "",
    level: "1",
    theme: "greenHag",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/green_hag.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from green_hag. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "griffon",
    name: "Griffon",
    subtitle: "",
    level: "1",
    theme: "griffon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/griffon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from griffon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "guard2",
    name: "Guard 2",
    subtitle: "",
    level: "1",
    theme: "guard2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/guard_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from guard_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "halfreddragonveteran2",
    name: "Half Red Dragon Veteran 2",
    subtitle: "",
    level: "1",
    theme: "halfRedDragonVeteran2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/half_red_dragon_veteran_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from half_red_dragon_veteran_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "hellhound",
    name: "Hell Hound",
    subtitle: "",
    level: "1",
    theme: "hellHound",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/hell_hound.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from hell_hound. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "hillgiant",
    name: "Hill Giant",
    subtitle: "",
    level: "1",
    theme: "hillGiant",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/hill_giant.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from hill_giant. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "hobgoblin",
    name: "Hobgoblin",
    subtitle: "",
    level: "1",
    theme: "hobgoblin",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/hobgoblin.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from hobgoblin. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "homunculus",
    name: "Homunculus",
    subtitle: "",
    level: "1",
    theme: "homunculus",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/homunculus.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from homunculus. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "homunculus2",
    name: "Homunculus 2",
    subtitle: "",
    level: "1",
    theme: "homunculus2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/homunculus_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from homunculus_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "hydra",
    name: "Hydra",
    subtitle: "",
    level: "1",
    theme: "hydra",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/hydra.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from hydra. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "icedevil",
    name: "Ice Devil",
    subtitle: "",
    level: "1",
    theme: "iceDevil",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ice_devil.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from ice_devil. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "knight2",
    name: "Knight 2",
    subtitle: "",
    level: "1",
    theme: "knight2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/knight_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from knight_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "knight4",
    name: "Knight 4",
    subtitle: "",
    level: "1",
    theme: "knight4",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/knight_4.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from knight_4. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "kobold",
    name: "Kobold",
    subtitle: "",
    level: "1",
    theme: "kobold",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/kobold.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from kobold. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "kraken",
    name: "Kraken",
    subtitle: "",
    level: "1",
    theme: "kraken",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/kraken.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from kraken. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lich",
    name: "Lich",
    subtitle: "",
    level: "1",
    theme: "lich",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/lich.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from lich. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lich2",
    name: "Lich 2",
    subtitle: "",
    level: "1",
    theme: "lich2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/lich_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from lich_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lizardfolk2",
    name: "Lizardfolk 2",
    subtitle: "",
    level: "1",
    theme: "lizardfolk2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/lizardfolk_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from lizardfolk_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "magmamephit",
    name: "Magma Mephit",
    subtitle: "",
    level: "1",
    theme: "magmaMephit",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/magma_mephit.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from magma_mephit. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "magmamephit3",
    name: "Magma Mephit 3",
    subtitle: "",
    level: "1",
    theme: "magmaMephit3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/magma_mephit_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from magma_mephit_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "magmamephit4",
    name: "Magma Mephit 4",
    subtitle: "",
    level: "1",
    theme: "magmaMephit4",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/magma_mephit_4.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from magma_mephit_4. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "magmamephit5",
    name: "Magma Mephit 5",
    subtitle: "",
    level: "1",
    theme: "magmaMephit5",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/magma_mephit_5.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from magma_mephit_5. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "mammoth",
    name: "Mammoth",
    subtitle: "",
    level: "1",
    theme: "mammoth",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/mammoth.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from mammoth. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "marilith2",
    name: "Marilith 2",
    subtitle: "",
    level: "1",
    theme: "marilith2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/marilith_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from marilith_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "mastiff",
    name: "Mastiff",
    subtitle: "",
    level: "1",
    theme: "mastiff",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/mastiff.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from mastiff. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "medusa",
    name: "Medusa",
    subtitle: "",
    level: "1",
    theme: "medusa",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/medusa.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from medusa. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "merrow",
    name: "Merrow",
    subtitle: "",
    level: "1",
    theme: "merrow",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/merrow.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from merrow. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "mimic2",
    name: "Mimic 2",
    subtitle: "",
    level: "1",
    theme: "mimic2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/mimic_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from mimic_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "minotaur",
    name: "Minotaur",
    subtitle: "",
    level: "1",
    theme: "minotaur",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/minotaur.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from minotaur. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "minotaurskeleton",
    name: "Minotaur Skeleton",
    subtitle: "",
    level: "1",
    theme: "minotaurSkeleton",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/minotaur_skeleton.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from minotaur_skeleton. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "mummy",
    name: "Mummy",
    subtitle: "",
    level: "1",
    theme: "mummy",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/mummy.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from mummy. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "mummylord",
    name: "Mummy Lord",
    subtitle: "",
    level: "1",
    theme: "mummyLord",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/mummy_lord.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from mummy_lord. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "nalfeshnee2",
    name: "Nalfeshnee 2",
    subtitle: "",
    level: "1",
    theme: "nalfeshnee2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/nalfeshnee_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from nalfeshnee_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "orc",
    name: "Orc",
    subtitle: "",
    level: "1",
    theme: "orc",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/orc.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from orc. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "phasespider",
    name: "Phase Spider",
    subtitle: "",
    level: "1",
    theme: "phaseSpider",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/phase_spider.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from phase_spider. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "planetar3",
    name: "Planetar 3",
    subtitle: "",
    level: "1",
    theme: "planetar3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/planetar_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from planetar_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "poisonoussnake",
    name: "Poisonous Snake",
    subtitle: "",
    level: "1",
    theme: "poisonousSnake",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/poisonous_snake.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from poisonous_snake. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "rat",
    name: "Rat",
    subtitle: "",
    level: "1",
    theme: "rat",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/rat.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from rat. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "reefshark",
    name: "Reef Shark",
    subtitle: "",
    level: "1",
    theme: "reefShark",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/reef_shark.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from reef_shark. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "remorhaz",
    name: "Remorhaz",
    subtitle: "",
    level: "1",
    theme: "remorhaz",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/remorhaz.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from remorhaz. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ridinghorse2",
    name: "Riding Horse 2",
    subtitle: "",
    level: "1",
    theme: "ridingHorse2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/riding_horse_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from riding_horse_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "roper",
    name: "Roper",
    subtitle: "",
    level: "1",
    theme: "roper",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/roper.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from roper. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "rugofsmothering",
    name: "Rug Of Smothering",
    subtitle: "",
    level: "1",
    theme: "rugOfSmothering",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/rug_of_smothering.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from rug_of_smothering. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "sahuagin",
    name: "Sahuagin",
    subtitle: "",
    level: "1",
    theme: "sahuagin",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/sahuagin.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from sahuagin. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "scorpion",
    name: "Scorpion",
    subtitle: "",
    level: "1",
    theme: "scorpion",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/scorpion.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from scorpion. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "seahorse4",
    name: "Sea Horse 4",
    subtitle: "",
    level: "1",
    theme: "seaHorse4",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/sea_horse_4.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from sea_horse_4. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "shadow",
    name: "Shadow",
    subtitle: "",
    level: "1",
    theme: "shadow",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/shadow.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from shadow. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "shamblingmound",
    name: "Shambling Mound",
    subtitle: "",
    level: "1",
    theme: "shamblingMound",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/shambling_mound.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from shambling_mound. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "silverdragonwyrmling",
    name: "Silver Dragon Wyrmling",
    subtitle: "",
    level: "1",
    theme: "silverDragonWyrmling",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/silver_dragon_wyrmling.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from silver_dragon_wyrmling. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "skeleton2",
    name: "Skeleton 2",
    subtitle: "",
    level: "1",
    theme: "skeleton2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/skeleton_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from skeleton_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "specter",
    name: "Specter",
    subtitle: "",
    level: "1",
    theme: "specter",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/specter.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from specter. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "spy",
    name: "Spy",
    subtitle: "",
    level: "1",
    theme: "spy",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/spy.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from spy. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "stonegiant",
    name: "Stone Giant",
    subtitle: "",
    level: "1",
    theme: "stoneGiant",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/stone_giant.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from stone_giant. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "stormgiant",
    name: "Storm Giant",
    subtitle: "",
    level: "1",
    theme: "stormGiant",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/storm_giant.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from storm_giant. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "swarmofbeetles2",
    name: "Swarm Of Beetles 2",
    subtitle: "",
    level: "1",
    theme: "swarmOfBeetles2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/swarm_of_beetles_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from swarm_of_beetles_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "swarmofpoisonoussnakes",
    name: "Swarm Of Poisonous Snakes",
    subtitle: "",
    level: "1",
    theme: "swarmOfPoisonousSnakes",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/swarm_of_poisonous_snakes.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from swarm_of_poisonous_snakes. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "tarrasque",
    name: "Tarrasque",
    subtitle: "",
    level: "1",
    theme: "tarrasque",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/tarrasque.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from tarrasque. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "tiger2",
    name: "Tiger 2",
    subtitle: "",
    level: "1",
    theme: "tiger2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/tiger_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from tiger_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "tribalwarrior",
    name: "Tribal Warrior",
    subtitle: "",
    level: "1",
    theme: "tribalWarrior",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/tribal_warrior.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from tribal_warrior. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "unicorn3",
    name: "Unicorn 3",
    subtitle: "",
    level: "1",
    theme: "unicorn3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/unicorn_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from unicorn_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "vampirebatform",
    name: "Vampire  Bat Form",
    subtitle: "",
    level: "1",
    theme: "vampireBatForm",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/vampire__bat_form.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from vampire__bat_form. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "vampiremistform4",
    name: "Vampire  Mist Form 4",
    subtitle: "",
    level: "1",
    theme: "vampireMistForm4",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/vampire__mist_form_4.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from vampire__mist_form_4. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "violetfungus",
    name: "Violet Fungus",
    subtitle: "",
    level: "1",
    theme: "violetFungus",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/violet_fungus.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from violet_fungus. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "warhorse2",
    name: "Warhorse 2",
    subtitle: "",
    level: "1",
    theme: "warhorse2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/warhorse_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from warhorse_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "wereboarhybridform2",
    name: "Wereboar  Hybrid Form 2",
    subtitle: "",
    level: "1",
    theme: "wereboarHybridForm2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/wereboar__hybrid_form_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from wereboar__hybrid_form_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "wererathumanform",
    name: "Wererat  Human Form",
    subtitle: "",
    level: "1",
    theme: "wereratHumanForm",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/wererat__human_form.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from wererat__human_form. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "werewolfhybridform2",
    name: "Werewolf  Hybrid Form 2",
    subtitle: "",
    level: "1",
    theme: "werewolfHybridForm2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/werewolf__hybrid_form_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from werewolf__hybrid_form_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "willowisp",
    name: "Will O  Wisp",
    subtitle: "",
    level: "1",
    theme: "willOWisp",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/will_o__wisp.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from will_o__wisp. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "winterwolf",
    name: "Winter Wolf",
    subtitle: "",
    level: "1",
    theme: "winterWolf",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/winter_wolf.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from winter_wolf. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "wraith",
    name: "Wraith",
    subtitle: "",
    level: "1",
    theme: "wraith",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/wraith.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from wraith. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "wyvern",
    name: "Wyvern",
    subtitle: "",
    level: "1",
    theme: "wyvern",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/wyvern.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from wyvern. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "youngblackdragon",
    name: "Young Black Dragon",
    subtitle: "",
    level: "1",
    theme: "youngBlackDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/young_black_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from young_black_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "youngblackdragon2",
    name: "Young Black Dragon 2",
    subtitle: "",
    level: "1",
    theme: "youngBlackDragon2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/young_black_dragon_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from young_black_dragon_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "youngbrassdragon",
    name: "Young Brass Dragon",
    subtitle: "",
    level: "1",
    theme: "youngBrassDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/young_brass_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from young_brass_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "youngbrassdragon2",
    name: "Young Brass Dragon 2",
    subtitle: "",
    level: "1",
    theme: "youngBrassDragon2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/young_brass_dragon_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from young_brass_dragon_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "youngcopperdragon",
    name: "Young Copper Dragon",
    subtitle: "",
    level: "1",
    theme: "youngCopperDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/young_copper_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from young_copper_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "younggreendragon2",
    name: "Young Green Dragon 2",
    subtitle: "",
    level: "1",
    theme: "youngGreenDragon2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/young_green_dragon_2.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from young_green_dragon_2. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "youngreddragon3",
    name: "Young Red Dragon 3",
    subtitle: "",
    level: "1",
    theme: "youngRedDragon3",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/young_red_dragon_3.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from young_red_dragon_3. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "youngwhitedragon",
    name: "Young White Dragon",
    subtitle: "",
    level: "1",
    theme: "youngWhiteDragon",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/young_white_dragon.png",
    type: "Creature — ",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Auto-generated card from young_white_dragon. Customize this text to make it unique!",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },

  {
    id: "ape",
    name: "Ape",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "ape",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ape.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the storm-wracked peaks, a sorrowful titan descends, his gaze heavy with the weight of forgotten ages and the secrets buried beneath the shattered earth.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "archmage",
    name: "Archmage",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "archmage",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/archmage.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of the arcane library, Pepe the Wise conjures forbidden energies, his spells echoing through forgotten realms.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "assassin",
    name: "Assassin",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "assassin",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/assassin.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Cloaked in shadows and armed with a blade that whispers of forgotten magic, he stalks the moonlit rooftops, a silent guardian against the encroaching darkness.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "barbeddevil",
    name: "Barbed Devil",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "barbedDevil",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/barbed_devil.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the sulfurous depths, he rises, a harbinger of chaos, his laughter echoing through the infernal plains, promising an eternity of torment to those who dare cross his path.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "basilisk",
    name: "Basilisk",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "basilisk",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/basilisk.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the ruins of forgotten empires, a serpentine oracle slithers forth, its gaze holding the secrets of ages past.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "berserker",
    name: "Berserker",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "berserker",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/berserker.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the blood-soaked ruins, a green tide rises, promising only carnage and the vacant stare of madness.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "bulette",
    name: "Bulette",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "bulette",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/bulette.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the primordial ooze of forgotten realms, a scaly behemoth rises, its gaze promising either salvation or utter annihilation.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "centaur",
    name: "Centaur",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "centaur",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/centaur.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the storm-wracked peaks, a centaur of ancient sorrow and terrible might descends, his axe thirsting for the blood of gods and mortals alike.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "commoner",
    name: "Commoner",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "commoner",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/commoner.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "He wanders the forgotten paths, a silent sentinel burdened by a past whispered only by the wind.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },

  {
    id: "deva",
    name: "Deva",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "deva",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/deva.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Born from the cosmic sorrow of a dying galaxy, this winged warrior weeps for the fate of all worlds.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "deva2",
    name: "Deva 2",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "deva2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/deva_2.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of the digital swamp, a many-armed deity rises, wielding the power to meme reality itself.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "direwolf",
    name: "Dire Wolf",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "direWolf",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/dire_wolf.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "In the shadowed depths of the emerald forest, a creature of sorrowful gaze and lupine form stalks, a harbinger of forgotten prophecies and untold woe.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "direwolf2",
    name: "Dire Wolf 2",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "direWolf2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/dire_wolf_2.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "In the dead of night, under the cold gaze of the moon, the Pepe Werewolf stalks the haunted woods, a cursed beast forever torn between man and monster.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "doppelganger",
    name: "Doppelganger",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "doppelganger",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/doppelganger.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of forgotten realms, a grotesque harbinger of despair emerges, its presence a chilling omen of impending doom.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },

  {
    id: "druid2",
    name: "Druid 2",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "druid2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/druid_2.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of the emerald forest, a guardian emerges, wielding ancient magic to protect the balance of nature.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "earthelemental",
    name: "Earth Elemental",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "earthElemental",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/earth_elemental.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the heart of the earth he rises, a golem of sorrow, his emerald eyes reflecting the ancient secrets buried beneath the mountains.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "efreeti",
    name: "Efreeti",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "efreeti",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/efreeti.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Forged in the heart of a dying star, this horned harbinger wields the flames of oblivion, promising a fiery end to all who dare oppose his reign.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "elephant",
    name: "Elephant",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "elephant",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/elephant.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "In the emerald depths of the forgotten jungle, a melancholic titan roams, his sorrowful gaze hinting at a secret older than the trees themselves.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ettercap",
    name: "Ettercap",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "ettercap",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ettercap.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of the spider-infested grotto, a sorrowful amphibian abomination emerges, dripping with venom and despair, to claim what little hope remains in this forsaken realm.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "fleshgolem",
    name: "Flesh Golem",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "fleshGolem",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/flesh_golem.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the fetid depths of the forgotten crypts, a stitched-together abomination of meme and monster rises, its vacant stare promising only despair and the chilling echo of lost laughter.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "flyingsword",
    name: "Flying Sword",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "flyingSword",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/flying_sword.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Forged under a moonlit storm, the Pepe Blade whispers prophecies of memes yet to come, its edge sharpened by the tears of a thousand deleted tweets.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantelk",
    name: "Giant Elk",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "giantElk",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_elk.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of the forgotten swamp, a sorrowful guardian rises, his gaze heavy with the weight of ancient secrets and the burden of a world lost to time.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "gianthyena",
    name: "Giant Hyena",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "giantHyena",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_hyena.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the emerald depths of the savanna, a sorrowful gaze pierces the veil of twilight, hinting at a forgotten pact with the ancient spirits of the land.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "gianthyena2",
    name: "Giant Hyena 2",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "giantHyena2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_hyena_2.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Beneath the gaze of a moon that mirrors his own vacant stare, the Hyena-Pepe stalks the savanna, a harbinger of chaos and despair.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantratdiseased",
    name: "Giant Rat  Diseased ",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "giantRatDiseased",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_rat__diseased_.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the sewers of forgotten dreams, it crawls forth, a harbinger of madness and decay, its gaze promising only oblivion.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantscorpion",
    name: "Giant Scorpion",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "giantScorpion",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_scorpion.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the desolate wastes, a harbinger of despair crawls forth, its gaze promising only oblivion.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantspider",
    name: "Giant Spider",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "giantSpider",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_spider.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the cracked earth and stormy skies, a harbinger of misfortune crawls forth, its gaze promising only despair.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantspider2",
    name: "Giant Spider 2",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "giantSpider2",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_spider_2.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of the fungal grotto, a melancholic arachnid emerges, its eight eyes reflecting the sorrow of a thousand lost memes.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "giantvulture",
    name: "Giant Vulture",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "giantVulture",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/giant_vulture.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the storm-wracked skies, a harbinger of woe descends, its gaze promising only ruin for the world below.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "guardiannaga",
    name: "Guardian Naga",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "guardianNaga",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/guardian_naga.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the ruins of forgotten empires, he rises, a serpent king wielding both sword and sorrow, his power crackling with ancient runes.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "gynosphinx",
    name: "Gynosphinx",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "gynosphinx",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/gynosphinx.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Born from the sands of time and imbued with ancient magic, this winged sphinx guards secrets that could shatter the very foundations of reality.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "harpy",
    name: "Harpy",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "harpy",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/harpy.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the emerald depths of the forgotten forest, a feathered enigma emerges, its gaze holding secrets that could shatter empires.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "hellhound2",
    name: "Hell Hound 2",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "hellHound",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/hell_hound_2.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the sulfurous depths, a harbinger of doom rises, its gaze promising only oblivion.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "hyena",
    name: "Hyena",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "hyena",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/hyena.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of the swamp, a creature of unsettling gaze emerges, its presence a harbinger of forgotten secrets and impending doom.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },

  {
    id: "imp",
    name: "Imp",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "imp",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/imp.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the fiery depths of a forgotten realm, a mischievous imp emerges, his intentions as molten as the lava he treads upon.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lemure",
    name: "Lemure",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "lemure",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/lemure.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the fetid swamps of forgotten realms, a harbinger of despair crawls forth, its gaze promising only oblivion.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lion",
    name: "Lion",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "lion",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/lion.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of the forgotten swamp, a beast of grotesque visage and ancient power emerges, its gaze promising madness and its roar echoing with the lament of lost souls.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "lizard",
    name: "Lizard",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "lizard",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/lizard.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of forgotten swamps, a creature of sorrow and scale emerges, its gaze holding the weight of a thousand lost souls.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "marilith",
    name: "Marilith",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "marilith",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/marilith.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Forged in the crucible of forgotten realms, this serpentine sentinel guards treasures beyond mortal comprehension, his gaze a chilling omen to those who dare trespass.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "merfolk",
    name: "Merfolk",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "merfolk",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/merfolk.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of forgotten seas, a sorrowful titan rises, his tears a harbinger of tides yet to come.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "nighthag",
    name: "Night Hag",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "nightHag",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/night_hag.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the moonlit abyss, a sorrowful gargoyle descends, its tears weaving nightmares into the dreams of the innocent.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "noble",
    name: "Noble",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "noble",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/noble.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Crowned in sorrow and cloaked in crimson, he reigns over a kingdom of forgotten dreams, where the only currency is regret.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "ochrejelly",
    name: "Ochre Jelly",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "ochreJelly",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/ochre_jelly.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of the dankest caves, a golden sorrow emerges, its weeping tendrils promising despair to any who dare gaze upon its melancholic form.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "octopus",
    name: "Octopus",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "octopus",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/octopus.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the abyssal depths, a sorrowful leviathan rises, its gaze reflecting the weight of forgotten worlds.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "oni",
    name: "Oni",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "oni",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/oni.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Forged in the crucible of ancient storms and whispered legends, this oni walks the mortal realm, a harbinger of chaos and a guardian of forgotten secrets.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "pitfiend",
    name: "Pit Fiend",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "pitFiend",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/pit_fiend.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of volcanic despair, a harbinger of chaos rises, its fiery breath promising only destruction and despair.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "rakshasa",
    name: "Rakshasa",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "rakshasa",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/rakshasa.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of forgotten temples, a green titan rises, his touch ablaze with ancient power, his gaze promising either salvation or utter annihilation.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "raven",
    name: "Raven",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "raven",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/raven.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of the bayou, a feathered omen rises, its mournful gaze promising only despair and the chilling embrace of the swamp's secrets.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "sabertoothedtiger",
    name: "Saber Toothed Tiger",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "saberToothedTiger",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/saber_toothed_tiger.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of the swamp, a primordial predator emerges, its gaze promising oblivion to any who dare cross its path.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "salamander",
    name: "Salamander",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "salamander",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/salamander.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of the bayou, a creature of sorrowful gaze emerges, its tears a testament to a forgotten world.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "seahag",
    name: "Sea Hag",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "seaHag",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/sea_hag.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the churning depths, she rises, a harbinger of storms and madness, her gaze promising oblivion to any who dare meet it.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "steammephit",
    name: "Steam Mephit",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "steamMephit",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/steam_mephit.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "Forged in the heart of a forgotten age, this mechanical marvel whispers secrets of a time when memes ruled the gears of destiny.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "succubusincubus",
    name: "Succubus Incubus",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "succubusIncubus",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/succubus_incubus.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the shadowed depths of forgotten cathedrals, a winged harbinger of chaos emerges, his gaze promising either salvation or utter despair.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "treant",
    name: "Treant",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "treant",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/treant.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of the ancient forest, a sentient guardian of the woods emerges, his wooden gaze holding secrets older than time itself.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "vampirevampireform",
    name: "Vampire  Vampire Form",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "vampireVampireForm",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/vampire__vampire_form.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the moonlit abyss, a creature of nightmare descends, its eyes burning with an unholy thirst, its wings casting shadows of dread upon the land.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "vrock",
    name: "Vrock",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "vrock",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/vrock.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the storm-wracked peaks of despair, a feathered harbinger of woe descends, his gaze promising only ruin and regret.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "warhorse",
    name: "Warhorse",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "warhorse",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/warhorse.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the fetid swamps of forgotten realms, a knight of sorrow rides forth, his steed adorned with the faces of fallen comrades, a harbinger of woe upon the land.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "warhorseskeleton",
    name: "Warhorse Skeleton",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "warhorseSkeleton",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/warhorse_skeleton.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the murky depths of forgotten battlefields, a skeletal steed rises, its emerald eyes burning with an unholy light, forever bound to a spectral rider lost to the mists of time.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "waterelemental",
    name: "Water Elemental",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "waterElemental",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/water_elemental.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the depths of despair, a tidal wave of woe rises to claim what was lost.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
  {
    id: "weretigertigerform",
    name: "Weretiger  Tiger Form",
    subtitle: "⟨Generated⟩",
    level: "1",
    theme: "weretigerTigerForm",
    manaCost: [
      {
        type: "hp",
        value: "5",
        color: "radial-gradient(circle, #dc143c, #8b0000)",
        textColor: "#ffffff",
      },
      {
        type: "mana",
        value: "2",
        color: "radial-gradient(circle, #4169e1, #0000cd)",
        textColor: "#ffffff",
      },
      {
        type: "terrain",
        value: "?",
        color: "radial-gradient(circle, #32cd32, #228b22)",
        textColor: "#ffffff",
      },
    ],
    image: "/images/card-images/weretiger__tiger_form.png",
    type: "Creature — Generated",
    stats: {
      attack: "3",
      defense: "3",
    },
    flavorText:
      "From the moonlit ruins, a primal terror stalks, its eyes wide with a madness that whispers of forgotten gods and shattered realities.\n",
    artist: "SURF FINANCE STUDIOS",
    rarity: "1/1",
  },
];

export const CARD_THEMES = {
  ape: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(67, 169, 187, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(4, 10, 11, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(157, 210, 219, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #36494f, #040a0b, #719093)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(67, 169, 187, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(113, 144, 147, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #43a9bb, #719093, #9dd2db, #43a9bb, #040a0b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(67, 169, 187, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(67, 169, 187, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(157, 210, 219, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(67, 169, 187, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(4, 10, 11, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #36494f, #040a0b, #719093)",
      border: "min(0.25vw, 2px) solid #43a9bb",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(67, 169, 187, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(67, 169, 187, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(113, 144, 147, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #43a9bb, #719093, #9dd2db, #43a9bb, #040a0b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(67, 169, 187, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(67, 169, 187, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(113, 144, 147, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #36494f, #040a0b)",
      color: "#c4d8d4",
      accentColor: "#43a9bb",
      border: "min(0.25vw, 2px) solid #43a9bb",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #040a0b, #36494f)",
    },
    stat: {
      background: "rgba(4, 10, 11, 0.8)",
      border: "min(0.25vw, 2px) solid #43a9bb",
      color: "#9dd2db",
      boxShadow: "0 0 min(1vw, 8px) rgba(67, 169, 187, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #43a9bb, #719093)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #040a0b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(67, 169, 187, 0.6)",
    },
  },
  archmage: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(44, 92, 124, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 68, 92, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(132, 182, 196, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2a344d, #24445c, #606992)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(44, 92, 124, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(96, 105, 146, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #2c5c7c, #606992, #84b6c4, #2c5c7c, #24445c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(44, 92, 124, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(44, 92, 124, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(132, 182, 196, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(44, 92, 124, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 68, 92, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2a344d, #24445c, #606992)",
      border: "min(0.25vw, 2px) solid #2c5c7c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(44, 92, 124, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(44, 92, 124, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(96, 105, 146, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #2c5c7c, #606992, #84b6c4, #2c5c7c, #24445c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(44, 92, 124, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(44, 92, 124, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(96, 105, 146, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2a344d, #24445c)",
      color: "#c0a882",
      accentColor: "#2c5c7c",
      border: "min(0.25vw, 2px) solid #2c5c7c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #24445c, #2a344d)",
    },
    stat: {
      background: "rgba(36, 68, 92, 0.8)",
      border: "min(0.25vw, 2px) solid #2c5c7c",
      color: "#84b6c4",
      boxShadow: "0 0 min(1vw, 8px) rgba(44, 92, 124, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #2c5c7c, #606992)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #24445c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(44, 92, 124, 0.6)",
    },
  },
  assassin: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(68, 121, 57, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(20, 60, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(173, 212, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #34465f, #143c0c, #5c768a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(68, 121, 57, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(92, 118, 138, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #447939, #5c768a, #add4a4, #447939, #143c0c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(68, 121, 57, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(68, 121, 57, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(173, 212, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(68, 121, 57, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(20, 60, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #34465f, #143c0c, #5c768a)",
      border: "min(0.25vw, 2px) solid #447939",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(68, 121, 57, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(68, 121, 57, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(92, 118, 138, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #447939, #5c768a, #add4a4, #447939, #143c0c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(68, 121, 57, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(68, 121, 57, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(92, 118, 138, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #34465f, #143c0c)",
      color: "#cedde6",
      accentColor: "#447939",
      border: "min(0.25vw, 2px) solid #447939",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #143c0c, #34465f)",
    },
    stat: {
      background: "rgba(20, 60, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #447939",
      color: "#add4a4",
      boxShadow: "0 0 min(1vw, 8px) rgba(68, 121, 57, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #447939, #5c768a)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #143c0c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(68, 121, 57, 0.6)",
    },
  },
  barbedDevil: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(247, 111, 58, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(100, 44, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(246, 189, 78, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4f312f, #642c1c, #598048)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(247, 111, 58, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(89, 128, 72, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f76f3a, #598048, #f6bd4e, #f76f3a, #642c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(247, 111, 58, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(247, 111, 58, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(246, 189, 78, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(247, 111, 58, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(100, 44, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4f312f, #642c1c, #598048)",
      border: "min(0.25vw, 2px) solid #f76f3a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(247, 111, 58, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(247, 111, 58, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(89, 128, 72, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f76f3a, #598048, #f6bd4e, #f76f3a, #642c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(247, 111, 58, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(247, 111, 58, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(89, 128, 72, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4f312f, #642c1c)",
      color: "#adabaa",
      accentColor: "#f76f3a",
      border: "min(0.25vw, 2px) solid #f76f3a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #642c1c, #4f312f)",
    },
    stat: {
      background: "rgba(100, 44, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #f76f3a",
      color: "#f6bd4e",
      boxShadow: "0 0 min(1vw, 8px) rgba(247, 111, 58, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f76f3a, #598048)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #642c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(247, 111, 58, 0.6)",
    },
  },
  basilisk: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(184, 112, 72, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(69, 93, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(217, 180, 159, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2d3e54, #455d2c, #6986b2)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(184, 112, 72, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(105, 134, 178, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b87048, #6986b2, #d9b49f, #b87048, #455d2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(184, 112, 72, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(184, 112, 72, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(217, 180, 159, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(184, 112, 72, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(69, 93, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2d3e54, #455d2c, #6986b2)",
      border: "min(0.25vw, 2px) solid #b87048",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(184, 112, 72, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(184, 112, 72, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(105, 134, 178, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b87048, #6986b2, #d9b49f, #b87048, #455d2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(184, 112, 72, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(184, 112, 72, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(105, 134, 178, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2d3e54, #455d2c)",
      color: "#c4cc9e",
      accentColor: "#b87048",
      border: "min(0.25vw, 2px) solid #b87048",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #455d2c, #2d3e54)",
    },
    stat: {
      background: "rgba(69, 93, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #b87048",
      color: "#d9b49f",
      boxShadow: "0 0 min(1vw, 8px) rgba(184, 112, 72, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b87048, #6986b2)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #455d2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(184, 112, 72, 0.6)",
    },
  },
  berserker: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(128, 164, 196, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(37, 52, 23, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(159, 202, 220, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3b4e2a, #253417, #7095ac)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(128, 164, 196, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(112, 149, 172, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #80a4c4, #7095ac, #9fcadc, #80a4c4, #253417)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(128, 164, 196, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(128, 164, 196, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(159, 202, 220, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(128, 164, 196, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(37, 52, 23, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3b4e2a, #253417, #7095ac)",
      border: "min(0.25vw, 2px) solid #80a4c4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(128, 164, 196, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(128, 164, 196, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(112, 149, 172, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #80a4c4, #7095ac, #9fcadc, #80a4c4, #253417)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(128, 164, 196, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(128, 164, 196, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(112, 149, 172, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3b4e2a, #253417)",
      color: "#8eb6c8",
      accentColor: "#80a4c4",
      border: "min(0.25vw, 2px) solid #80a4c4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #253417, #3b4e2a)",
    },
    stat: {
      background: "rgba(37, 52, 23, 0.8)",
      border: "min(0.25vw, 2px) solid #80a4c4",
      color: "#9fcadc",
      boxShadow: "0 0 min(1vw, 8px) rgba(128, 164, 196, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #80a4c4, #7095ac)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #253417",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(128, 164, 196, 0.6)",
    },
  },
  bulette: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(172, 100, 78, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(118, 62, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(203, 222, 153, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5c4932, #763e2c, #ac7e54)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(172, 100, 78, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(172, 126, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ac644e, #ac7e54, #cbde99, #ac644e, #763e2c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(172, 100, 78, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(172, 100, 78, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(203, 222, 153, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(172, 100, 78, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(118, 62, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5c4932, #763e2c, #ac7e54)",
      border: "min(0.25vw, 2px) solid #ac644e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(172, 100, 78, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(172, 100, 78, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(172, 126, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ac644e, #ac7e54, #cbde99, #ac644e, #763e2c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(172, 100, 78, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(172, 100, 78, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(172, 126, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5c4932, #763e2c)",
      color: "#d4c4ac",
      accentColor: "#ac644e",
      border: "min(0.25vw, 2px) solid #ac644e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #763e2c, #5c4932)",
    },
    stat: {
      background: "rgba(118, 62, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #ac644e",
      color: "#cbde99",
      boxShadow: "0 0 min(1vw, 8px) rgba(172, 100, 78, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ac644e, #ac7e54)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #763e2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(172, 100, 78, 0.6)",
    },
  },
  centaur: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(119, 174, 192, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(76, 44, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(155, 219, 236, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #51422f, #4c2c24, #5d899e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(119, 174, 192, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(93, 137, 158, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #77aec0, #5d899e, #9bdbec, #77aec0, #4c2c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(119, 174, 192, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(119, 174, 192, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(155, 219, 236, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(119, 174, 192, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(76, 44, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #51422f, #4c2c24, #5d899e)",
      border: "min(0.25vw, 2px) solid #77aec0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(119, 174, 192, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(119, 174, 192, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(93, 137, 158, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #77aec0, #5d899e, #9bdbec, #77aec0, #4c2c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(119, 174, 192, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(119, 174, 192, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(93, 137, 158, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #51422f, #4c2c24)",
      color: "#bfdbd7",
      accentColor: "#77aec0",
      border: "min(0.25vw, 2px) solid #77aec0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4c2c24, #51422f)",
    },
    stat: {
      background: "rgba(76, 44, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #77aec0",
      color: "#9bdbec",
      boxShadow: "0 0 min(1vw, 8px) rgba(119, 174, 192, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #77aec0, #5d899e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #4c2c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(119, 174, 192, 0.6)",
    },
  },
  commoner: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(157, 133, 97, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(81, 69, 50, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(204, 191, 173, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #404336, #514532, #9a9c78)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(157, 133, 97, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(154, 156, 120, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #9d8561, #9a9c78, #ccbfad, #9d8561, #514532)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(157, 133, 97, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(157, 133, 97, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(204, 191, 173, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(157, 133, 97, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(81, 69, 50, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #404336, #514532, #9a9c78)",
      border: "min(0.25vw, 2px) solid #9d8561",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(157, 133, 97, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(157, 133, 97, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(154, 156, 120, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #9d8561, #9a9c78, #ccbfad, #9d8561, #514532)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(157, 133, 97, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(157, 133, 97, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(154, 156, 120, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #404336, #514532)",
      color: "#bdad95",
      accentColor: "#9d8561",
      border: "min(0.25vw, 2px) solid #9d8561",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #514532, #404336)",
    },
    stat: {
      background: "rgba(81, 69, 50, 0.8)",
      border: "min(0.25vw, 2px) solid #9d8561",
      color: "#ccbfad",
      boxShadow: "0 0 min(1vw, 8px) rgba(157, 133, 97, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #9d8561, #9a9c78)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #514532",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(157, 133, 97, 0.6)",
    },
  },
  deva: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(208, 163, 69, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(151, 115, 56, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(145, 180, 228, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #282c48, #977338, #5c9255)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(208, 163, 69, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(92, 146, 85, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d0a345, #5c9255, #91b4e4, #d0a345, #977338)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(208, 163, 69, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(208, 163, 69, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(145, 180, 228, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(208, 163, 69, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(151, 115, 56, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #282c48, #977338, #5c9255)",
      border: "min(0.25vw, 2px) solid #d0a345",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(208, 163, 69, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(208, 163, 69, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(92, 146, 85, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d0a345, #5c9255, #91b4e4, #d0a345, #977338)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(208, 163, 69, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(208, 163, 69, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(92, 146, 85, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #282c48, #977338)",
      color: "#cfbea6",
      accentColor: "#d0a345",
      border: "min(0.25vw, 2px) solid #d0a345",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #977338, #282c48)",
    },
    stat: {
      background: "rgba(151, 115, 56, 0.8)",
      border: "min(0.25vw, 2px) solid #d0a345",
      color: "#91b4e4",
      boxShadow: "0 0 min(1vw, 8px) rgba(208, 163, 69, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d0a345, #5c9255)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #977338",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(208, 163, 69, 0.6)",
    },
  },
  deva2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(60, 220, 244, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(67, 89, 40, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(121, 229, 237, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3f6972, #435928, #6ca25f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(60, 220, 244, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 162, 95, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3cdcf4, #6ca25f, #79e5ed, #3cdcf4, #435928)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(60, 220, 244, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(60, 220, 244, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(121, 229, 237, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(60, 220, 244, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(67, 89, 40, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3f6972, #435928, #6ca25f)",
      border: "min(0.25vw, 2px) solid #3cdcf4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(60, 220, 244, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(60, 220, 244, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 162, 95, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3cdcf4, #6ca25f, #79e5ed, #3cdcf4, #435928)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(60, 220, 244, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(60, 220, 244, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 162, 95, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3f6972, #435928)",
      color: "#9eafcb",
      accentColor: "#3cdcf4",
      border: "min(0.25vw, 2px) solid #3cdcf4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #435928, #3f6972)",
    },
    stat: {
      background: "rgba(67, 89, 40, 0.8)",
      border: "min(0.25vw, 2px) solid #3cdcf4",
      color: "#79e5ed",
      boxShadow: "0 0 min(1vw, 8px) rgba(60, 220, 244, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3cdcf4, #6ca25f)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #435928",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(60, 220, 244, 0.6)",
    },
  },
  direWolf: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(172, 160, 73, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(71, 92, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(195, 180, 101, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #464a2d, #475c24, #828d51)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(172, 160, 73, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(130, 141, 81, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #aca049, #828d51, #c3b465, #aca049, #475c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(172, 160, 73, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(172, 160, 73, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(195, 180, 101, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(172, 160, 73, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(71, 92, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #464a2d, #475c24, #828d51)",
      border: "min(0.25vw, 2px) solid #aca049",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(172, 160, 73, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(172, 160, 73, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(130, 141, 81, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #aca049, #828d51, #c3b465, #aca049, #475c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(172, 160, 73, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(172, 160, 73, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(130, 141, 81, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #464a2d, #475c24)",
      color: "#bfd5c6",
      accentColor: "#aca049",
      border: "min(0.25vw, 2px) solid #aca049",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #475c24, #464a2d)",
    },
    stat: {
      background: "rgba(71, 92, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #aca049",
      color: "#c3b465",
      boxShadow: "0 0 min(1vw, 8px) rgba(172, 160, 73, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #aca049, #828d51)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #475c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(172, 160, 73, 0.6)",
    },
  },
  direWolf2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(60, 84, 126, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 44, 76, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(165, 182, 212, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #293450, #242c4c, #576a9d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(60, 84, 126, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(87, 106, 157, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3c547e, #576a9d, #a5b6d4, #3c547e, #242c4c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(60, 84, 126, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(60, 84, 126, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(165, 182, 212, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(60, 84, 126, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 44, 76, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #293450, #242c4c, #576a9d)",
      border: "min(0.25vw, 2px) solid #3c547e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(60, 84, 126, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(60, 84, 126, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(87, 106, 157, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3c547e, #576a9d, #a5b6d4, #3c547e, #242c4c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(60, 84, 126, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(60, 84, 126, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(87, 106, 157, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #293450, #242c4c)",
      color: "#90a7c6",
      accentColor: "#3c547e",
      border: "min(0.25vw, 2px) solid #3c547e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #242c4c, #293450)",
    },
    stat: {
      background: "rgba(36, 44, 76, 0.8)",
      border: "min(0.25vw, 2px) solid #3c547e",
      color: "#a5b6d4",
      boxShadow: "0 0 min(1vw, 8px) rgba(60, 84, 126, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3c547e, #576a9d)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #242c4c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(60, 84, 126, 0.6)",
    },
  },
  doppelganger: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(121, 172, 82, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(65, 92, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(185, 212, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #486339, #415c2c, #946460)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(121, 172, 82, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(148, 100, 96, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #79ac52, #946460, #b9d4a5, #79ac52, #415c2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(121, 172, 82, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(121, 172, 82, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(185, 212, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(121, 172, 82, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(65, 92, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #486339, #415c2c, #946460)",
      border: "min(0.25vw, 2px) solid #79ac52",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(121, 172, 82, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(121, 172, 82, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(148, 100, 96, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #79ac52, #946460, #b9d4a5, #79ac52, #415c2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(121, 172, 82, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(121, 172, 82, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(148, 100, 96, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #486339, #415c2c)",
      color: "#afbcb2",
      accentColor: "#79ac52",
      border: "min(0.25vw, 2px) solid #79ac52",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #415c2c, #486339)",
    },
    stat: {
      background: "rgba(65, 92, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #79ac52",
      color: "#b9d4a5",
      boxShadow: "0 0 min(1vw, 8px) rgba(121, 172, 82, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #79ac52, #946460)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #415c2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(121, 172, 82, 0.6)",
    },
  },
  druid2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(63, 122, 165, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 62, 92, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(83, 156, 212, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #39542c, #1c3e5c, #63b9a5)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(63, 122, 165, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(99, 185, 165, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3f7aa5, #63b9a5, #539cd4, #3f7aa5, #1c3e5c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(63, 122, 165, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(63, 122, 165, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(83, 156, 212, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(63, 122, 165, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 62, 92, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #39542c, #1c3e5c, #63b9a5)",
      border: "min(0.25vw, 2px) solid #3f7aa5",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(63, 122, 165, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(63, 122, 165, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(99, 185, 165, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3f7aa5, #63b9a5, #539cd4, #3f7aa5, #1c3e5c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(63, 122, 165, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(63, 122, 165, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(99, 185, 165, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #39542c, #1c3e5c)",
      color: "#bdb89e",
      accentColor: "#3f7aa5",
      border: "min(0.25vw, 2px) solid #3f7aa5",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c3e5c, #39542c)",
    },
    stat: {
      background: "rgba(28, 62, 92, 0.8)",
      border: "min(0.25vw, 2px) solid #3f7aa5",
      color: "#539cd4",
      boxShadow: "0 0 min(1vw, 8px) rgba(63, 122, 165, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3f7aa5, #63b9a5)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #1c3e5c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(63, 122, 165, 0.6)",
    },
  },
  earthElemental: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(108, 117, 36, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 88, 100, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(216, 223, 153, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #534532, #1c5864, #6b90a4)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(108, 117, 36, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(107, 144, 164, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #6c7524, #6b90a4, #d8df99, #6c7524, #1c5864)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(108, 117, 36, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(108, 117, 36, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(216, 223, 153, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(108, 117, 36, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 88, 100, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #534532, #1c5864, #6b90a4)",
      border: "min(0.25vw, 2px) solid #6c7524",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(108, 117, 36, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(108, 117, 36, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(107, 144, 164, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #6c7524, #6b90a4, #d8df99, #6c7524, #1c5864)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(108, 117, 36, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(108, 117, 36, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(107, 144, 164, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #534532, #1c5864)",
      color: "#bcc0ad",
      accentColor: "#6c7524",
      border: "min(0.25vw, 2px) solid #6c7524",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c5864, #534532)",
    },
    stat: {
      background: "rgba(28, 88, 100, 0.8)",
      border: "min(0.25vw, 2px) solid #6c7524",
      color: "#d8df99",
      boxShadow: "0 0 min(1vw, 8px) rgba(108, 117, 36, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #6c7524, #6b90a4)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #1c5864",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(108, 117, 36, 0.6)",
    },
  },
  efreeti: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(242, 137, 67, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(104, 68, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(245, 210, 135, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #6f4f3f, #684424, #ac744e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(242, 137, 67, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(172, 116, 78, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f28943, #ac744e, #f5d287, #f28943, #684424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(242, 137, 67, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(242, 137, 67, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(245, 210, 135, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(242, 137, 67, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(104, 68, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #6f4f3f, #684424, #ac744e)",
      border: "min(0.25vw, 2px) solid #f28943",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(242, 137, 67, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(242, 137, 67, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(172, 116, 78, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f28943, #ac744e, #f5d287, #f28943, #684424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(242, 137, 67, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(242, 137, 67, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(172, 116, 78, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #6f4f3f, #684424)",
      color: "#c8a88c",
      accentColor: "#f28943",
      border: "min(0.25vw, 2px) solid #f28943",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #684424, #6f4f3f)",
    },
    stat: {
      background: "rgba(104, 68, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #f28943",
      color: "#f5d287",
      boxShadow: "0 0 min(1vw, 8px) rgba(242, 137, 67, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f28943, #ac744e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #684424",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(242, 137, 67, 0.6)",
    },
  },
  elephant: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(61, 116, 193, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 53, 88, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(154, 182, 222, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3c5132, #1c3558, #789d64)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(61, 116, 193, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(120, 157, 100, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3d74c1, #789d64, #9ab6de, #3d74c1, #1c3558)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(61, 116, 193, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(61, 116, 193, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(154, 182, 222, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(61, 116, 193, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 53, 88, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3c5132, #1c3558, #789d64)",
      border: "min(0.25vw, 2px) solid #3d74c1",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(61, 116, 193, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(61, 116, 193, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(120, 157, 100, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3d74c1, #789d64, #9ab6de, #3d74c1, #1c3558)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(61, 116, 193, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(61, 116, 193, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(120, 157, 100, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3c5132, #1c3558)",
      color: "#d1c4b6",
      accentColor: "#3d74c1",
      border: "min(0.25vw, 2px) solid #3d74c1",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c3558, #3c5132)",
    },
    stat: {
      background: "rgba(28, 53, 88, 0.8)",
      border: "min(0.25vw, 2px) solid #3d74c1",
      color: "#9ab6de",
      boxShadow: "0 0 min(1vw, 8px) rgba(61, 116, 193, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3d74c1, #789d64)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #1c3558",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(61, 116, 193, 0.6)",
    },
  },
  ettercap: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(185, 97, 69, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(106, 56, 40, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(184, 221, 168, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #374c2c, #6a3828, #78af6b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(185, 97, 69, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(120, 175, 107, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b96145, #78af6b, #b8dda8, #b96145, #6a3828)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 97, 69, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(185, 97, 69, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(184, 221, 168, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(185, 97, 69, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(106, 56, 40, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #374c2c, #6a3828, #78af6b)",
      border: "min(0.25vw, 2px) solid #b96145",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(185, 97, 69, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(185, 97, 69, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(120, 175, 107, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b96145, #78af6b, #b8dda8, #b96145, #6a3828)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 97, 69, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(185, 97, 69, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(120, 175, 107, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #374c2c, #6a3828)",
      color: "#3f6e2a",
      accentColor: "#b96145",
      border: "min(0.25vw, 2px) solid #b96145",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6a3828, #374c2c)",
    },
    stat: {
      background: "rgba(106, 56, 40, 0.8)",
      border: "min(0.25vw, 2px) solid #b96145",
      color: "#b8dda8",
      boxShadow: "0 0 min(1vw, 8px) rgba(185, 97, 69, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b96145, #78af6b)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #6a3828",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(185, 97, 69, 0.6)",
    },
  },
  fleshGolem: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(60, 108, 52, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(76, 108, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(172, 211, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #415337, #4c6c24, #987f6c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(60, 108, 52, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(152, 127, 108, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3c6c34, #987f6c, #acd3a5, #3c6c34, #4c6c24)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(60, 108, 52, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(60, 108, 52, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(172, 211, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(60, 108, 52, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(76, 108, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #415337, #4c6c24, #987f6c)",
      border: "min(0.25vw, 2px) solid #3c6c34",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(60, 108, 52, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(60, 108, 52, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(152, 127, 108, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3c6c34, #987f6c, #acd3a5, #3c6c34, #4c6c24)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(60, 108, 52, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(60, 108, 52, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(152, 127, 108, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #415337, #4c6c24)",
      color: "#9cbe84",
      accentColor: "#3c6c34",
      border: "min(0.25vw, 2px) solid #3c6c34",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4c6c24, #415337)",
    },
    stat: {
      background: "rgba(76, 108, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #3c6c34",
      color: "#acd3a5",
      boxShadow: "0 0 min(1vw, 8px) rgba(60, 108, 52, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3c6c34, #987f6c)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #4c6c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(60, 108, 52, 0.6)",
    },
  },
  flyingSword: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(131, 89, 60, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(104, 60, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(213, 184, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3a3b4c, #683c2c, #8b6655)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(131, 89, 60, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(139, 102, 85, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #83593c, #8b6655, #d5b8a4, #83593c, #683c2c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(131, 89, 60, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(131, 89, 60, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(213, 184, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(131, 89, 60, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(104, 60, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3a3b4c, #683c2c, #8b6655)",
      border: "min(0.25vw, 2px) solid #83593c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(131, 89, 60, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(131, 89, 60, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(139, 102, 85, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #83593c, #8b6655, #d5b8a4, #83593c, #683c2c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(131, 89, 60, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(131, 89, 60, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(139, 102, 85, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3a3b4c, #683c2c)",
      color: "#c2b7af",
      accentColor: "#83593c",
      border: "min(0.25vw, 2px) solid #83593c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #683c2c, #3a3b4c)",
    },
    stat: {
      background: "rgba(104, 60, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #83593c",
      color: "#d5b8a4",
      boxShadow: "0 0 min(1vw, 8px) rgba(131, 89, 60, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #83593c, #8b6655)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #683c2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(131, 89, 60, 0.6)",
    },
  },
  giantElk: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(167, 194, 96, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(74, 88, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(191, 213, 130, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #415933, #4a5824, #6f8a82)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(167, 194, 96, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(111, 138, 130, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #a7c260, #6f8a82, #bfd582, #a7c260, #4a5824)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(167, 194, 96, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(167, 194, 96, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(191, 213, 130, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(167, 194, 96, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(74, 88, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #415933, #4a5824, #6f8a82)",
      border: "min(0.25vw, 2px) solid #a7c260",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(167, 194, 96, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(167, 194, 96, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(111, 138, 130, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #a7c260, #6f8a82, #bfd582, #a7c260, #4a5824)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(167, 194, 96, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(167, 194, 96, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(111, 138, 130, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #415933, #4a5824)",
      color: "#a4c1c5",
      accentColor: "#a7c260",
      border: "min(0.25vw, 2px) solid #a7c260",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4a5824, #415933)",
    },
    stat: {
      background: "rgba(74, 88, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #a7c260",
      color: "#bfd582",
      boxShadow: "0 0 min(1vw, 8px) rgba(167, 194, 96, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #a7c260, #6f8a82)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #4a5824",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(167, 194, 96, 0.6)",
    },
  },
  giantHyena: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(215, 162, 116, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(148, 92, 68, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(242, 219, 157, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #554a38, #945c44, #6b9454)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(215, 162, 116, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(107, 148, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d7a274, #6b9454, #f2db9d, #d7a274, #945c44)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(215, 162, 116, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(215, 162, 116, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(242, 219, 157, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(215, 162, 116, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(148, 92, 68, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #554a38, #945c44, #6b9454)",
      border: "min(0.25vw, 2px) solid #d7a274",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(215, 162, 116, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(215, 162, 116, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(107, 148, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d7a274, #6b9454, #f2db9d, #d7a274, #945c44)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(215, 162, 116, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(215, 162, 116, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(107, 148, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #554a38, #945c44)",
      color: "#98bc81",
      accentColor: "#d7a274",
      border: "min(0.25vw, 2px) solid #d7a274",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #945c44, #554a38)",
    },
    stat: {
      background: "rgba(148, 92, 68, 0.8)",
      border: "min(0.25vw, 2px) solid #d7a274",
      color: "#f2db9d",
      boxShadow: "0 0 min(1vw, 8px) rgba(215, 162, 116, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d7a274, #6b9454)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #945c44",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(215, 162, 116, 0.6)",
    },
  },
  giantHyena2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(94, 126, 160, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(49, 65, 83, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(171, 187, 205, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #323e4f, #314153, #586d8a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(94, 126, 160, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(88, 109, 138, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5e7ea0, #586d8a, #abbbcd, #5e7ea0, #314153)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(94, 126, 160, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(94, 126, 160, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(171, 187, 205, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(94, 126, 160, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(49, 65, 83, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #323e4f, #314153, #586d8a)",
      border: "min(0.25vw, 2px) solid #5e7ea0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(94, 126, 160, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(94, 126, 160, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(88, 109, 138, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5e7ea0, #586d8a, #abbbcd, #5e7ea0, #314153)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(94, 126, 160, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(94, 126, 160, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(88, 109, 138, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #323e4f, #314153)",
      color: "#c7d2de",
      accentColor: "#5e7ea0",
      border: "min(0.25vw, 2px) solid #5e7ea0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #314153, #323e4f)",
    },
    stat: {
      background: "rgba(49, 65, 83, 0.8)",
      border: "min(0.25vw, 2px) solid #5e7ea0",
      color: "#abbbcd",
      boxShadow: "0 0 min(1vw, 8px) rgba(94, 126, 160, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5e7ea0, #586d8a)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #314153",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(94, 126, 160, 0.6)",
    },
  },
  giantRatDiseased: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(189, 167, 113, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(88, 49, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(212, 198, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #475a30, #583114, #90aa61)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(189, 167, 113, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(144, 170, 97, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #bda771, #90aa61, #d4c6a4, #bda771, #583114)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(189, 167, 113, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(189, 167, 113, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(212, 198, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(189, 167, 113, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(88, 49, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #475a30, #583114, #90aa61)",
      border: "min(0.25vw, 2px) solid #bda771",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(189, 167, 113, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(189, 167, 113, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(144, 170, 97, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #bda771, #90aa61, #d4c6a4, #bda771, #583114)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(189, 167, 113, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(189, 167, 113, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(144, 170, 97, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #475a30, #583114)",
      color: "#685830",
      accentColor: "#bda771",
      border: "min(0.25vw, 2px) solid #bda771",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #583114, #475a30)",
    },
    stat: {
      background: "rgba(88, 49, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #bda771",
      color: "#d4c6a4",
      boxShadow: "0 0 min(1vw, 8px) rgba(189, 167, 113, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #bda771, #90aa61)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #583114",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(189, 167, 113, 0.6)",
    },
  },
  giantScorpion: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(188, 140, 92, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(116, 73, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(252, 244, 210, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4e3927, #74492c, #987052)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(188, 140, 92, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(152, 112, 82, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #bc8c5c, #987052, #fcf4d2, #bc8c5c, #74492c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(188, 140, 92, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(188, 140, 92, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(252, 244, 210, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(188, 140, 92, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(116, 73, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4e3927, #74492c, #987052)",
      border: "min(0.25vw, 2px) solid #bc8c5c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(188, 140, 92, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(188, 140, 92, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(152, 112, 82, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #bc8c5c, #987052, #fcf4d2, #bc8c5c, #74492c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(188, 140, 92, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(188, 140, 92, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(152, 112, 82, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4e3927, #74492c)",
      color: "#d8d3b7",
      accentColor: "#bc8c5c",
      border: "min(0.25vw, 2px) solid #bc8c5c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #74492c, #4e3927)",
    },
    stat: {
      background: "rgba(116, 73, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #bc8c5c",
      color: "#fcf4d2",
      boxShadow: "0 0 min(1vw, 8px) rgba(188, 140, 92, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #bc8c5c, #987052)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #74492c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(188, 140, 92, 0.6)",
    },
  },
  giantSpider: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(129, 178, 76, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(61, 84, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(189, 215, 162, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #374054, #3d5424, #747d8e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(129, 178, 76, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(116, 125, 142, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #81b24c, #747d8e, #bdd7a2, #81b24c, #3d5424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(129, 178, 76, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(129, 178, 76, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(189, 215, 162, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(129, 178, 76, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(61, 84, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #374054, #3d5424, #747d8e)",
      border: "min(0.25vw, 2px) solid #81b24c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(129, 178, 76, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(129, 178, 76, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(116, 125, 142, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #81b24c, #747d8e, #bdd7a2, #81b24c, #3d5424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(129, 178, 76, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(129, 178, 76, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(116, 125, 142, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #374054, #3d5424)",
      color: "#c7cedb",
      accentColor: "#81b24c",
      border: "min(0.25vw, 2px) solid #81b24c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3d5424, #374054)",
    },
    stat: {
      background: "rgba(61, 84, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #81b24c",
      color: "#bdd7a2",
      boxShadow: "0 0 min(1vw, 8px) rgba(129, 178, 76, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #81b24c, #747d8e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #3d5424",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(129, 178, 76, 0.6)",
    },
  },
  giantSpider2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(69, 185, 111, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 96, 58, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(172, 224, 191, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b6132, #24603a, #6b8444)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(69, 185, 111, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(107, 132, 68, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #45b96f, #6b8444, #ace0bf, #45b96f, #24603a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(69, 185, 111, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(69, 185, 111, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(172, 224, 191, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(69, 185, 111, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 96, 58, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b6132, #24603a, #6b8444)",
      border: "min(0.25vw, 2px) solid #45b96f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(69, 185, 111, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(69, 185, 111, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(107, 132, 68, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #45b96f, #6b8444, #ace0bf, #45b96f, #24603a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(69, 185, 111, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(69, 185, 111, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(107, 132, 68, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b6132, #24603a)",
      color: "#8ac4ab",
      accentColor: "#45b96f",
      border: "min(0.25vw, 2px) solid #45b96f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #24603a, #4b6132)",
    },
    stat: {
      background: "rgba(36, 96, 58, 0.8)",
      border: "min(0.25vw, 2px) solid #45b96f",
      color: "#ace0bf",
      boxShadow: "0 0 min(1vw, 8px) rgba(69, 185, 111, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #45b96f, #6b8444)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #24603a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(69, 185, 111, 0.6)",
    },
  },
  giantVulture: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(68, 148, 81, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(126, 92, 60, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(197, 219, 177, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4d5535, #7e5c3c, #5ea061)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(68, 148, 81, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(94, 160, 97, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #449451, #5ea061, #c5dbb1, #449451, #7e5c3c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(68, 148, 81, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(68, 148, 81, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(197, 219, 177, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(68, 148, 81, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(126, 92, 60, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4d5535, #7e5c3c, #5ea061)",
      border: "min(0.25vw, 2px) solid #449451",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(68, 148, 81, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(68, 148, 81, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(94, 160, 97, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #449451, #5ea061, #c5dbb1, #449451, #7e5c3c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(68, 148, 81, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(68, 148, 81, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(94, 160, 97, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4d5535, #7e5c3c)",
      color: "#93bb87",
      accentColor: "#449451",
      border: "min(0.25vw, 2px) solid #449451",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #7e5c3c, #4d5535)",
    },
    stat: {
      background: "rgba(126, 92, 60, 0.8)",
      border: "min(0.25vw, 2px) solid #449451",
      color: "#c5dbb1",
      boxShadow: "0 0 min(1vw, 8px) rgba(68, 148, 81, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #449451, #5ea061)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #7e5c3c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(68, 148, 81, 0.6)",
    },
  },
  guardianNaga: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(105, 188, 196, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(26, 101, 119, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(159, 212, 217, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #324954, #1a6577, #5d99ad)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(105, 188, 196, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(93, 153, 173, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #69bcc4, #5d99ad, #9fd4d9, #69bcc4, #1a6577)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(105, 188, 196, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(105, 188, 196, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(159, 212, 217, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(105, 188, 196, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(26, 101, 119, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #324954, #1a6577, #5d99ad)",
      border: "min(0.25vw, 2px) solid #69bcc4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(105, 188, 196, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(105, 188, 196, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(93, 153, 173, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #69bcc4, #5d99ad, #9fd4d9, #69bcc4, #1a6577)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(105, 188, 196, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(105, 188, 196, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(93, 153, 173, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #324954, #1a6577)",
      color: "#b5c2b6",
      accentColor: "#69bcc4",
      border: "min(0.25vw, 2px) solid #69bcc4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1a6577, #324954)",
    },
    stat: {
      background: "rgba(26, 101, 119, 0.8)",
      border: "min(0.25vw, 2px) solid #69bcc4",
      color: "#9fd4d9",
      boxShadow: "0 0 min(1vw, 8px) rgba(105, 188, 196, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #69bcc4, #5d99ad)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1a6577",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(105, 188, 196, 0.6)",
    },
  },
  gynosphinx: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(185, 136, 92, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(86, 95, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(244, 195, 131, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #414f32, #565f2c, #997855)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(185, 136, 92, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(153, 120, 85, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b9885c, #997855, #f4c383, #b9885c, #565f2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 136, 92, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(185, 136, 92, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(244, 195, 131, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(185, 136, 92, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(86, 95, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #414f32, #565f2c, #997855)",
      border: "min(0.25vw, 2px) solid #b9885c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(185, 136, 92, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(185, 136, 92, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(153, 120, 85, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b9885c, #997855, #f4c383, #b9885c, #565f2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 136, 92, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(185, 136, 92, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(153, 120, 85, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #414f32, #565f2c)",
      color: "#aac1d4",
      accentColor: "#b9885c",
      border: "min(0.25vw, 2px) solid #b9885c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #565f2c, #414f32)",
    },
    stat: {
      background: "rgba(86, 95, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #b9885c",
      color: "#f4c383",
      boxShadow: "0 0 min(1vw, 8px) rgba(185, 136, 92, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b9885c, #997855)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #565f2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(185, 136, 92, 0.6)",
    },
  },
  harpy: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(177, 152, 79, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(120, 77, 17, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(220, 243, 245, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3c4c2d, #784d11, #7c8f50)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(177, 152, 79, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(124, 143, 80, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b1984f, #7c8f50, #dcf3f5, #b1984f, #784d11)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(177, 152, 79, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(177, 152, 79, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(220, 243, 245, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(177, 152, 79, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(120, 77, 17, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3c4c2d, #784d11, #7c8f50)",
      border: "min(0.25vw, 2px) solid #b1984f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(177, 152, 79, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(177, 152, 79, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(124, 143, 80, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b1984f, #7c8f50, #dcf3f5, #b1984f, #784d11)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(177, 152, 79, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(177, 152, 79, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(124, 143, 80, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3c4c2d, #784d11)",
      color: "#d8d8b3",
      accentColor: "#b1984f",
      border: "min(0.25vw, 2px) solid #b1984f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #784d11, #3c4c2d)",
    },
    stat: {
      background: "rgba(120, 77, 17, 0.8)",
      border: "min(0.25vw, 2px) solid #b1984f",
      color: "#dcf3f5",
      boxShadow: "0 0 min(1vw, 8px) rgba(177, 152, 79, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b1984f, #7c8f50)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #784d11",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(177, 152, 79, 0.6)",
    },
  },
  hyena: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(94, 151, 160, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(49, 78, 83, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(171, 201, 205, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #40542c, #314e53, #63949a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(94, 151, 160, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(99, 148, 154, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5e97a0, #63949a, #abc9cd, #5e97a0, #314e53)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(94, 151, 160, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(94, 151, 160, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(171, 201, 205, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(94, 151, 160, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(49, 78, 83, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #40542c, #314e53, #63949a)",
      border: "min(0.25vw, 2px) solid #5e97a0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(94, 151, 160, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(94, 151, 160, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(99, 148, 154, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5e97a0, #63949a, #abc9cd, #5e97a0, #314e53)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(94, 151, 160, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(94, 151, 160, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(99, 148, 154, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #40542c, #314e53)",
      color: "#86b1b8",
      accentColor: "#5e97a0",
      border: "min(0.25vw, 2px) solid #5e97a0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #314e53, #40542c)",
    },
    stat: {
      background: "rgba(49, 78, 83, 0.8)",
      border: "min(0.25vw, 2px) solid #5e97a0",
      color: "#abc9cd",
      boxShadow: "0 0 min(1vw, 8px) rgba(94, 151, 160, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5e97a0, #63949a)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #314e53",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(94, 151, 160, 0.6)",
    },
  },
  imp: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(245, 73, 50, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(108, 28, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(246, 211, 126, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5a3a38, #6c1c1c, #538c4b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(245, 73, 50, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(83, 140, 75, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f54932, #538c4b, #f6d37e, #f54932, #6c1c1c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(245, 73, 50, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(245, 73, 50, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(246, 211, 126, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(245, 73, 50, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(108, 28, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5a3a38, #6c1c1c, #538c4b)",
      border: "min(0.25vw, 2px) solid #f54932",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(245, 73, 50, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(245, 73, 50, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(83, 140, 75, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f54932, #538c4b, #f6d37e, #f54932, #6c1c1c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(245, 73, 50, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(245, 73, 50, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(83, 140, 75, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5a3a38, #6c1c1c)",
      color: "#c1ac94",
      accentColor: "#f54932",
      border: "min(0.25vw, 2px) solid #f54932",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6c1c1c, #5a3a38)",
    },
    stat: {
      background: "rgba(108, 28, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #f54932",
      color: "#f6d37e",
      boxShadow: "0 0 min(1vw, 8px) rgba(245, 73, 50, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f54932, #538c4b)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #6c1c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(245, 73, 50, 0.6)",
    },
  },
  lemure: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(200, 138, 140, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(90, 42, 43, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(212, 164, 166, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #47573c, #5a2a2b, #8b695e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(200, 138, 140, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(139, 105, 94, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c88a8c, #8b695e, #d4a4a6, #c88a8c, #5a2a2b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(200, 138, 140, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(200, 138, 140, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(212, 164, 166, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(200, 138, 140, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(90, 42, 43, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #47573c, #5a2a2b, #8b695e)",
      border: "min(0.25vw, 2px) solid #c88a8c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(200, 138, 140, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(200, 138, 140, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(139, 105, 94, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c88a8c, #8b695e, #d4a4a6, #c88a8c, #5a2a2b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(200, 138, 140, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(200, 138, 140, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(139, 105, 94, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #47573c, #5a2a2b)",
      color: "#a1bbbd",
      accentColor: "#c88a8c",
      border: "min(0.25vw, 2px) solid #c88a8c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5a2a2b, #47573c)",
    },
    stat: {
      background: "rgba(90, 42, 43, 0.8)",
      border: "min(0.25vw, 2px) solid #c88a8c",
      color: "#d4a4a6",
      boxShadow: "0 0 min(1vw, 8px) rgba(200, 138, 140, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c88a8c, #8b695e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5a2a2b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(200, 138, 140, 0.6)",
    },
  },
  lion: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(180, 188, 92, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(93, 88, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(180, 212, 220, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #646138, #5d582c, #928e4d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(180, 188, 92, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(146, 142, 77, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b4bc5c, #928e4d, #b4d4dc, #b4bc5c, #5d582c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 188, 92, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(180, 188, 92, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(180, 212, 220, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(180, 188, 92, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(93, 88, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #646138, #5d582c, #928e4d)",
      border: "min(0.25vw, 2px) solid #b4bc5c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(180, 188, 92, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(180, 188, 92, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(146, 142, 77, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b4bc5c, #928e4d, #b4d4dc, #b4bc5c, #5d582c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 188, 92, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(180, 188, 92, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(146, 142, 77, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #646138, #5d582c)",
      color: "#b3d4d2",
      accentColor: "#b4bc5c",
      border: "min(0.25vw, 2px) solid #b4bc5c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5d582c, #646138)",
    },
    stat: {
      background: "rgba(93, 88, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #b4bc5c",
      color: "#b4d4dc",
      boxShadow: "0 0 min(1vw, 8px) rgba(180, 188, 92, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b4bc5c, #928e4d)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5d582c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(180, 188, 92, 0.6)",
    },
  },
  lizard: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(63, 150, 191, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(11, 26, 33, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(155, 200, 221, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3c542e, #0b1a21, #6c9192)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(63, 150, 191, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 145, 146, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3f96bf, #6c9192, #9bc8dd, #3f96bf, #0b1a21)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(63, 150, 191, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(63, 150, 191, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(155, 200, 221, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(63, 150, 191, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(11, 26, 33, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3c542e, #0b1a21, #6c9192)",
      border: "min(0.25vw, 2px) solid #3f96bf",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(63, 150, 191, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(63, 150, 191, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 145, 146, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3f96bf, #6c9192, #9bc8dd, #3f96bf, #0b1a21)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(63, 150, 191, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(63, 150, 191, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 145, 146, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3c542e, #0b1a21)",
      color: "#cdd5be",
      accentColor: "#3f96bf",
      border: "min(0.25vw, 2px) solid #3f96bf",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0b1a21, #3c542e)",
    },
    stat: {
      background: "rgba(11, 26, 33, 0.8)",
      border: "min(0.25vw, 2px) solid #3f96bf",
      color: "#9bc8dd",
      boxShadow: "0 0 min(1vw, 8px) rgba(63, 150, 191, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3f96bf, #6c9192)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #0b1a21",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(63, 150, 191, 0.6)",
    },
  },
  marilith: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(224, 75, 51, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 78, 116, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(122, 196, 208, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #334358, #1c4e74, #6891b0)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(224, 75, 51, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(104, 145, 176, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e04b33, #6891b0, #7ac4d0, #e04b33, #1c4e74)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(224, 75, 51, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(224, 75, 51, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(122, 196, 208, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(224, 75, 51, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 78, 116, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #334358, #1c4e74, #6891b0)",
      border: "min(0.25vw, 2px) solid #e04b33",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(224, 75, 51, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(224, 75, 51, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(104, 145, 176, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e04b33, #6891b0, #7ac4d0, #e04b33, #1c4e74)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(224, 75, 51, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(224, 75, 51, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(104, 145, 176, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #334358, #1c4e74)",
      color: "#b9cbd2",
      accentColor: "#e04b33",
      border: "min(0.25vw, 2px) solid #e04b33",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c4e74, #334358)",
    },
    stat: {
      background: "rgba(28, 78, 116, 0.8)",
      border: "min(0.25vw, 2px) solid #e04b33",
      color: "#7ac4d0",
      boxShadow: "0 0 min(1vw, 8px) rgba(224, 75, 51, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e04b33, #6891b0)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #1c4e74",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(224, 75, 51, 0.6)",
    },
  },
  merfolk: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(79, 163, 184, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(35, 79, 102, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(114, 201, 210, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #335d61, #234f66, #6c934e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(79, 163, 184, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 147, 78, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4fa3b8, #6c934e, #72c9d2, #4fa3b8, #234f66)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(79, 163, 184, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(79, 163, 184, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(114, 201, 210, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(79, 163, 184, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(35, 79, 102, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #335d61, #234f66, #6c934e)",
      border: "min(0.25vw, 2px) solid #4fa3b8",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(79, 163, 184, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(79, 163, 184, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 147, 78, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4fa3b8, #6c934e, #72c9d2, #4fa3b8, #234f66)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(79, 163, 184, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(79, 163, 184, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 147, 78, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #335d61, #234f66)",
      color: "#bbccb5",
      accentColor: "#4fa3b8",
      border: "min(0.25vw, 2px) solid #4fa3b8",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #234f66, #335d61)",
    },
    stat: {
      background: "rgba(35, 79, 102, 0.8)",
      border: "min(0.25vw, 2px) solid #4fa3b8",
      color: "#72c9d2",
      boxShadow: "0 0 min(1vw, 8px) rgba(79, 163, 184, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4fa3b8, #6c934e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #234f66",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(79, 163, 184, 0.6)",
    },
  },
  nightHag: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(100, 139, 154, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(52, 72, 80, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(174, 194, 202, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #343b4c, #344850, #617894)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(100, 139, 154, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(97, 120, 148, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #648b9a, #617894, #aec2ca, #648b9a, #344850)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(100, 139, 154, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(100, 139, 154, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(174, 194, 202, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(100, 139, 154, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(52, 72, 80, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #343b4c, #344850, #617894)",
      border: "min(0.25vw, 2px) solid #648b9a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(100, 139, 154, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(100, 139, 154, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(97, 120, 148, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #648b9a, #617894, #aec2ca, #648b9a, #344850)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(100, 139, 154, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(100, 139, 154, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(97, 120, 148, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #343b4c, #344850)",
      color: "#a3bac3",
      accentColor: "#648b9a",
      border: "min(0.25vw, 2px) solid #648b9a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #344850, #343b4c)",
    },
    stat: {
      background: "rgba(52, 72, 80, 0.8)",
      border: "min(0.25vw, 2px) solid #648b9a",
      color: "#aec2ca",
      boxShadow: "0 0 min(1vw, 8px) rgba(100, 139, 154, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #648b9a, #617894)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #344850",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(100, 139, 154, 0.6)",
    },
  },
  noble: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(185, 145, 72, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(54, 5, 17, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(243, 196, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #506539, #360511, #776c92)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(185, 145, 72, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(119, 108, 146, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b99148, #776c92, #f3c4a4, #b99148, #360511)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 145, 72, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(185, 145, 72, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(243, 196, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(185, 145, 72, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(54, 5, 17, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #506539, #360511, #776c92)",
      border: "min(0.25vw, 2px) solid #b99148",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(185, 145, 72, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(185, 145, 72, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(119, 108, 146, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b99148, #776c92, #f3c4a4, #b99148, #360511)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 145, 72, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(185, 145, 72, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(119, 108, 146, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #506539, #360511)",
      color: "#c8abb0",
      accentColor: "#b99148",
      border: "min(0.25vw, 2px) solid #b99148",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #360511, #506539)",
    },
    stat: {
      background: "rgba(54, 5, 17, 0.8)",
      border: "min(0.25vw, 2px) solid #b99148",
      color: "#f3c4a4",
      boxShadow: "0 0 min(1vw, 8px) rgba(185, 145, 72, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b99148, #776c92)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #360511",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(185, 145, 72, 0.6)",
    },
  },
  ochreJelly: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(186, 139, 53, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(123, 69, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(231, 211, 125, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #485040, #7b450c, #887048)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(186, 139, 53, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(136, 112, 72, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ba8b35, #887048, #e7d37d, #ba8b35, #7b450c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(186, 139, 53, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(186, 139, 53, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(231, 211, 125, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(186, 139, 53, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(123, 69, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #485040, #7b450c, #887048)",
      border: "min(0.25vw, 2px) solid #ba8b35",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(186, 139, 53, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(186, 139, 53, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(136, 112, 72, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ba8b35, #887048, #e7d37d, #ba8b35, #7b450c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(186, 139, 53, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(186, 139, 53, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(136, 112, 72, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #485040, #7b450c)",
      color: "#9ca483",
      accentColor: "#ba8b35",
      border: "min(0.25vw, 2px) solid #ba8b35",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #7b450c, #485040)",
    },
    stat: {
      background: "rgba(123, 69, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #ba8b35",
      color: "#e7d37d",
      boxShadow: "0 0 min(1vw, 8px) rgba(186, 139, 53, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ba8b35, #887048)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #7b450c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(186, 139, 53, 0.6)",
    },
  },
  octopus: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(72, 197, 217, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(17, 74, 106, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(127, 220, 228, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2b4c29, #114a6a, #5c8d53)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(72, 197, 217, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(92, 141, 83, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #48c5d9, #5c8d53, #7fdce4, #48c5d9, #114a6a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(72, 197, 217, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(72, 197, 217, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(127, 220, 228, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(72, 197, 217, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(17, 74, 106, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2b4c29, #114a6a, #5c8d53)",
      border: "min(0.25vw, 2px) solid #48c5d9",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(72, 197, 217, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(72, 197, 217, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(92, 141, 83, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #48c5d9, #5c8d53, #7fdce4, #48c5d9, #114a6a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(72, 197, 217, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(72, 197, 217, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(92, 141, 83, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2b4c29, #114a6a)",
      color: "#b4dbd4",
      accentColor: "#48c5d9",
      border: "min(0.25vw, 2px) solid #48c5d9",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #114a6a, #2b4c29)",
    },
    stat: {
      background: "rgba(17, 74, 106, 0.8)",
      border: "min(0.25vw, 2px) solid #48c5d9",
      color: "#7fdce4",
      boxShadow: "0 0 min(1vw, 8px) rgba(72, 197, 217, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #48c5d9, #5c8d53)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #114a6a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(72, 197, 217, 0.6)",
    },
  },
  oni: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(96, 130, 181, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 60, 92, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(211, 166, 152, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2c3c60, #243c5c, #5374a1)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(96, 130, 181, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(83, 116, 161, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #6082b5, #5374a1, #d3a698, #6082b5, #243c5c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(96, 130, 181, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(96, 130, 181, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(211, 166, 152, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(96, 130, 181, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 60, 92, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2c3c60, #243c5c, #5374a1)",
      border: "min(0.25vw, 2px) solid #6082b5",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(96, 130, 181, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(96, 130, 181, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(83, 116, 161, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #6082b5, #5374a1, #d3a698, #6082b5, #243c5c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(96, 130, 181, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(96, 130, 181, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(83, 116, 161, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2c3c60, #243c5c)",
      color: "#8a95c2",
      accentColor: "#6082b5",
      border: "min(0.25vw, 2px) solid #6082b5",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #243c5c, #2c3c60)",
    },
    stat: {
      background: "rgba(36, 60, 92, 0.8)",
      border: "min(0.25vw, 2px) solid #6082b5",
      color: "#d3a698",
      boxShadow: "0 0 min(1vw, 8px) rgba(96, 130, 181, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #6082b5, #5374a1)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #243c5c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(96, 130, 181, 0.6)",
    },
  },
  pitFiend: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(205, 86, 55, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(134, 20, 8, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(248, 213, 87, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #602e2b, #861408, #78ab57)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(205, 86, 55, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(120, 171, 87, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #cd5637, #78ab57, #f8d557, #cd5637, #861408)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(205, 86, 55, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(205, 86, 55, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(248, 213, 87, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(205, 86, 55, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(134, 20, 8, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #602e2b, #861408, #78ab57)",
      border: "min(0.25vw, 2px) solid #cd5637",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(205, 86, 55, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(205, 86, 55, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(120, 171, 87, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #cd5637, #78ab57, #f8d557, #cd5637, #861408)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(205, 86, 55, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(205, 86, 55, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(120, 171, 87, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #602e2b, #861408)",
      color: "#c7a58c",
      accentColor: "#cd5637",
      border: "min(0.25vw, 2px) solid #cd5637",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #861408, #602e2b)",
    },
    stat: {
      background: "rgba(134, 20, 8, 0.8)",
      border: "min(0.25vw, 2px) solid #cd5637",
      color: "#f8d557",
      boxShadow: "0 0 min(1vw, 8px) rgba(205, 86, 55, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #cd5637, #78ab57)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #861408",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(205, 86, 55, 0.6)",
    },
  },
  rakshasa: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(200, 143, 85, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(121, 61, 34, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(191, 237, 235, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3f5a51, #793d22, #61989e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(200, 143, 85, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(97, 152, 158, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c88f55, #61989e, #bfedeb, #c88f55, #793d22)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(200, 143, 85, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(200, 143, 85, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(191, 237, 235, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(200, 143, 85, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(121, 61, 34, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3f5a51, #793d22, #61989e)",
      border: "min(0.25vw, 2px) solid #c88f55",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(200, 143, 85, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(200, 143, 85, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(97, 152, 158, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c88f55, #61989e, #bfedeb, #c88f55, #793d22)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(200, 143, 85, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(200, 143, 85, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(97, 152, 158, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3f5a51, #793d22)",
      color: "#79b5af",
      accentColor: "#c88f55",
      border: "min(0.25vw, 2px) solid #c88f55",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #793d22, #3f5a51)",
    },
    stat: {
      background: "rgba(121, 61, 34, 0.8)",
      border: "min(0.25vw, 2px) solid #c88f55",
      color: "#bfedeb",
      boxShadow: "0 0 min(1vw, 8px) rgba(200, 143, 85, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c88f55, #61989e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #793d22",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(200, 143, 85, 0.6)",
    },
  },
  raven: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(108, 118, 55, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(80, 85, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(151, 203, 212, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4e5b2f, #505524, #749ea4)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(108, 118, 55, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(116, 158, 164, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #6c7637, #749ea4, #97cbd4, #6c7637, #505524)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(108, 118, 55, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(108, 118, 55, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(151, 203, 212, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(108, 118, 55, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(80, 85, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4e5b2f, #505524, #749ea4)",
      border: "min(0.25vw, 2px) solid #6c7637",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(108, 118, 55, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(108, 118, 55, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(116, 158, 164, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #6c7637, #749ea4, #97cbd4, #6c7637, #505524)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(108, 118, 55, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(108, 118, 55, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(116, 158, 164, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4e5b2f, #505524)",
      color: "#b2d7d7",
      accentColor: "#6c7637",
      border: "min(0.25vw, 2px) solid #6c7637",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #505524, #4e5b2f)",
    },
    stat: {
      background: "rgba(80, 85, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #6c7637",
      color: "#97cbd4",
      boxShadow: "0 0 min(1vw, 8px) rgba(108, 118, 55, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #6c7637, #749ea4)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #505524",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(108, 118, 55, 0.6)",
    },
  },
  saberToothedTiger: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(180, 190, 78, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(82, 102, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(213, 219, 158, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #584a34, #526614, #6c8795)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(180, 190, 78, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 135, 149, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b4be4e, #6c8795, #d5db9e, #b4be4e, #526614)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 190, 78, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(180, 190, 78, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(213, 219, 158, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(180, 190, 78, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(82, 102, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #584a34, #526614, #6c8795)",
      border: "min(0.25vw, 2px) solid #b4be4e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(180, 190, 78, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(180, 190, 78, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 135, 149, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b4be4e, #6c8795, #d5db9e, #b4be4e, #526614)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 190, 78, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(180, 190, 78, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 135, 149, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #584a34, #526614)",
      color: "#bfcac1",
      accentColor: "#b4be4e",
      border: "min(0.25vw, 2px) solid #b4be4e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #526614, #584a34)",
    },
    stat: {
      background: "rgba(82, 102, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #b4be4e",
      color: "#d5db9e",
      boxShadow: "0 0 min(1vw, 8px) rgba(180, 190, 78, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b4be4e, #6c8795)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #526614",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(180, 190, 78, 0.6)",
    },
  },
  salamander: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(201, 154, 109, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(44, 57, 101, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(219, 188, 158, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #343c6b, #2c3965, #a56c5a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(201, 154, 109, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(165, 108, 90, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c99a6d, #a56c5a, #dbbc9e, #c99a6d, #2c3965)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(201, 154, 109, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(201, 154, 109, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(219, 188, 158, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(201, 154, 109, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(44, 57, 101, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #343c6b, #2c3965, #a56c5a)",
      border: "min(0.25vw, 2px) solid #c99a6d",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(201, 154, 109, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(201, 154, 109, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(165, 108, 90, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c99a6d, #a56c5a, #dbbc9e, #c99a6d, #2c3965)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(201, 154, 109, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(201, 154, 109, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(165, 108, 90, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #343c6b, #2c3965)",
      color: "#9ca884",
      accentColor: "#c99a6d",
      border: "min(0.25vw, 2px) solid #c99a6d",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2c3965, #343c6b)",
    },
    stat: {
      background: "rgba(44, 57, 101, 0.8)",
      border: "min(0.25vw, 2px) solid #c99a6d",
      color: "#dbbc9e",
      boxShadow: "0 0 min(1vw, 8px) rgba(201, 154, 109, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c99a6d, #a56c5a)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #2c3965",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(201, 154, 109, 0.6)",
    },
  },
  seaHag: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(98, 156, 146, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(51, 81, 75, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(173, 203, 198, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #394e38, #33514b, #69958d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(98, 156, 146, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(105, 149, 141, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #629c92, #69958d, #adcbc6, #629c92, #33514b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(98, 156, 146, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(98, 156, 146, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(173, 203, 198, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(98, 156, 146, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(51, 81, 75, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #394e38, #33514b, #69958d)",
      border: "min(0.25vw, 2px) solid #629c92",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(98, 156, 146, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(98, 156, 146, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(105, 149, 141, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #629c92, #69958d, #adcbc6, #629c92, #33514b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(98, 156, 146, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(98, 156, 146, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(105, 149, 141, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #394e38, #33514b)",
      color: "#c4dad6",
      accentColor: "#629c92",
      border: "min(0.25vw, 2px) solid #629c92",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #33514b, #394e38)",
    },
    stat: {
      background: "rgba(51, 81, 75, 0.8)",
      border: "min(0.25vw, 2px) solid #629c92",
      color: "#adcbc6",
      boxShadow: "0 0 min(1vw, 8px) rgba(98, 156, 146, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #629c92, #69958d)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #33514b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(98, 156, 146, 0.6)",
    },
  },
  steamMephit: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(206, 113, 48, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(114, 63, 27, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(229, 181, 147, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4c422f, #723f1b, #bfab8a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(206, 113, 48, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(191, 171, 138, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ce7130, #bfab8a, #e5b593, #ce7130, #723f1b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(206, 113, 48, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(206, 113, 48, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(229, 181, 147, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(206, 113, 48, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(114, 63, 27, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4c422f, #723f1b, #bfab8a)",
      border: "min(0.25vw, 2px) solid #ce7130",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(206, 113, 48, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(206, 113, 48, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(191, 171, 138, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ce7130, #bfab8a, #e5b593, #ce7130, #723f1b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(206, 113, 48, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(206, 113, 48, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(191, 171, 138, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4c422f, #723f1b)",
      color: "#84a78f",
      accentColor: "#ce7130",
      border: "min(0.25vw, 2px) solid #ce7130",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #723f1b, #4c422f)",
    },
    stat: {
      background: "rgba(114, 63, 27, 0.8)",
      border: "min(0.25vw, 2px) solid #ce7130",
      color: "#e5b593",
      boxShadow: "0 0 min(1vw, 8px) rgba(206, 113, 48, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ce7130, #bfab8a)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #723f1b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(206, 113, 48, 0.6)",
    },
  },
  succubusIncubus: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(191, 147, 106, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(127, 64, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(119, 169, 195, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #303f54, #7f401c, #5a85a8)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(191, 147, 106, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(90, 133, 168, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #bf936a, #5a85a8, #77a9c3, #bf936a, #7f401c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(191, 147, 106, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(191, 147, 106, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(119, 169, 195, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(191, 147, 106, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(127, 64, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #303f54, #7f401c, #5a85a8)",
      border: "min(0.25vw, 2px) solid #bf936a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(191, 147, 106, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(191, 147, 106, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(90, 133, 168, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #bf936a, #5a85a8, #77a9c3, #bf936a, #7f401c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(191, 147, 106, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(191, 147, 106, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(90, 133, 168, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #303f54, #7f401c)",
      color: "#2e556a",
      accentColor: "#bf936a",
      border: "min(0.25vw, 2px) solid #bf936a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #7f401c, #303f54)",
    },
    stat: {
      background: "rgba(127, 64, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #bf936a",
      color: "#77a9c3",
      boxShadow: "0 0 min(1vw, 8px) rgba(191, 147, 106, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #bf936a, #5a85a8)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #7f401c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(191, 147, 106, 0.6)",
    },
  },
  treant: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(169, 177, 64, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(110, 124, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(234, 235, 213, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #525328, #6e7c1c, #a98352)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(169, 177, 64, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(169, 131, 82, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #a9b140, #a98352, #eaebd5, #a9b140, #6e7c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(169, 177, 64, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(169, 177, 64, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(234, 235, 213, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(169, 177, 64, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(110, 124, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #525328, #6e7c1c, #a98352)",
      border: "min(0.25vw, 2px) solid #a9b140",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(169, 177, 64, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(169, 177, 64, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(169, 131, 82, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #a9b140, #a98352, #eaebd5, #a9b140, #6e7c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(169, 177, 64, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(169, 177, 64, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(169, 131, 82, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #525328, #6e7c1c)",
      color: "#bcc99d",
      accentColor: "#a9b140",
      border: "min(0.25vw, 2px) solid #a9b140",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6e7c1c, #525328)",
    },
    stat: {
      background: "rgba(110, 124, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #a9b140",
      color: "#eaebd5",
      boxShadow: "0 0 min(1vw, 8px) rgba(169, 177, 64, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #a9b140, #a98352)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #6e7c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(169, 177, 64, 0.6)",
    },
  },
  vampireVampireForm: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(31, 159, 223, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(4, 20, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(138, 205, 238, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2f4653, #04141c, #5e8f9d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(31, 159, 223, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(94, 143, 157, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #1f9fdf, #5e8f9d, #8acdee, #1f9fdf, #04141c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(31, 159, 223, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(31, 159, 223, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(138, 205, 238, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(31, 159, 223, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(4, 20, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2f4653, #04141c, #5e8f9d)",
      border: "min(0.25vw, 2px) solid #1f9fdf",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(31, 159, 223, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(31, 159, 223, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(94, 143, 157, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #1f9fdf, #5e8f9d, #8acdee, #1f9fdf, #04141c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(31, 159, 223, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(31, 159, 223, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(94, 143, 157, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2f4653, #04141c)",
      color: "#6ca3ad",
      accentColor: "#1f9fdf",
      border: "min(0.25vw, 2px) solid #1f9fdf",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #04141c, #2f4653)",
    },
    stat: {
      background: "rgba(4, 20, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #1f9fdf",
      color: "#8acdee",
      boxShadow: "0 0 min(1vw, 8px) rgba(31, 159, 223, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #1f9fdf, #5e8f9d)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #04141c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(31, 159, 223, 0.6)",
    },
  },
  vrock: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(224, 71, 30, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(88, 28, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(156, 156, 220, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5e332b, #581c0c, #7b87b1)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(224, 71, 30, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(123, 135, 177, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e0471e, #7b87b1, #9c9cdc, #e0471e, #581c0c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(224, 71, 30, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(224, 71, 30, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(156, 156, 220, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(224, 71, 30, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(88, 28, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5e332b, #581c0c, #7b87b1)",
      border: "min(0.25vw, 2px) solid #e0471e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(224, 71, 30, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(224, 71, 30, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(123, 135, 177, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e0471e, #7b87b1, #9c9cdc, #e0471e, #581c0c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(224, 71, 30, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(224, 71, 30, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(123, 135, 177, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5e332b, #581c0c)",
      color: "#bdb1d4",
      accentColor: "#e0471e",
      border: "min(0.25vw, 2px) solid #e0471e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #581c0c, #5e332b)",
    },
    stat: {
      background: "rgba(88, 28, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #e0471e",
      color: "#9c9cdc",
      boxShadow: "0 0 min(1vw, 8px) rgba(224, 71, 30, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e0471e, #7b87b1)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #581c0c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(224, 71, 30, 0.6)",
    },
  },
  warhorse: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(206, 128, 76, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(69, 38, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(178, 216, 229, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #494238, #452614, #698492)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(206, 128, 76, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(105, 132, 146, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ce804c, #698492, #b2d8e5, #ce804c, #452614)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(206, 128, 76, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(206, 128, 76, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(178, 216, 229, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(206, 128, 76, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(69, 38, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #494238, #452614, #698492)",
      border: "min(0.25vw, 2px) solid #ce804c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(206, 128, 76, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(206, 128, 76, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(105, 132, 146, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ce804c, #698492, #b2d8e5, #ce804c, #452614)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(206, 128, 76, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(206, 128, 76, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(105, 132, 146, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #494238, #452614)",
      color: "#96bac7",
      accentColor: "#ce804c",
      border: "min(0.25vw, 2px) solid #ce804c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #452614, #494238)",
    },
    stat: {
      background: "rgba(69, 38, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #ce804c",
      color: "#b2d8e5",
      boxShadow: "0 0 min(1vw, 8px) rgba(206, 128, 76, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ce804c, #698492)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #452614",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(206, 128, 76, 0.6)",
    },
  },
  warhorseSkeleton: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(156, 230, 112, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(54, 112, 19, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(172, 196, 100, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4d402d, #367013, #779f8e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(156, 230, 112, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(119, 159, 142, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #9ce670, #779f8e, #acc464, #9ce670, #367013)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(156, 230, 112, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(156, 230, 112, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(172, 196, 100, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(156, 230, 112, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(54, 112, 19, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4d402d, #367013, #779f8e)",
      border: "min(0.25vw, 2px) solid #9ce670",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(156, 230, 112, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(156, 230, 112, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(119, 159, 142, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #9ce670, #779f8e, #acc464, #9ce670, #367013)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(156, 230, 112, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(156, 230, 112, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(119, 159, 142, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4d402d, #367013)",
      color: "#c4d1ab",
      accentColor: "#9ce670",
      border: "min(0.25vw, 2px) solid #9ce670",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #367013, #4d402d)",
    },
    stat: {
      background: "rgba(54, 112, 19, 0.8)",
      border: "min(0.25vw, 2px) solid #9ce670",
      color: "#acc464",
      boxShadow: "0 0 min(1vw, 8px) rgba(156, 230, 112, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #9ce670, #779f8e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #367013",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(156, 230, 112, 0.6)",
    },
  },
  waterElemental: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(68, 121, 160, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(51, 95, 131, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(112, 186, 221, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #466d82, #335f83, #5a90b2)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(68, 121, 160, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(90, 144, 178, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4479a0, #5a90b2, #70badd, #4479a0, #335f83)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(68, 121, 160, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(68, 121, 160, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(112, 186, 221, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(68, 121, 160, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(51, 95, 131, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #466d82, #335f83, #5a90b2)",
      border: "min(0.25vw, 2px) solid #4479a0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(68, 121, 160, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(68, 121, 160, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(90, 144, 178, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4479a0, #5a90b2, #70badd, #4479a0, #335f83)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(68, 121, 160, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(68, 121, 160, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(90, 144, 178, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #466d82, #335f83)",
      color: "#a7c2d0",
      accentColor: "#4479a0",
      border: "min(0.25vw, 2px) solid #4479a0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #335f83, #466d82)",
    },
    stat: {
      background: "rgba(51, 95, 131, 0.8)",
      border: "min(0.25vw, 2px) solid #4479a0",
      color: "#70badd",
      boxShadow: "0 0 min(1vw, 8px) rgba(68, 121, 160, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4479a0, #5a90b2)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #335f83",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(68, 121, 160, 0.6)",
    },
  },
  weretigerTigerForm: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(180, 104, 42, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(120, 72, 39, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(229, 184, 147, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #325249, #784827, #5991a4)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(180, 104, 42, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(89, 145, 164, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b4682a, #5991a4, #e5b893, #b4682a, #784827)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 104, 42, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(180, 104, 42, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(229, 184, 147, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(180, 104, 42, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(120, 72, 39, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #325249, #784827, #5991a4)",
      border: "min(0.25vw, 2px) solid #b4682a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(180, 104, 42, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(180, 104, 42, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(89, 145, 164, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b4682a, #5991a4, #e5b893, #b4682a, #784827)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 104, 42, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(180, 104, 42, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(89, 145, 164, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #325249, #784827)",
      color: "#c6ccc4",
      accentColor: "#b4682a",
      border: "min(0.25vw, 2px) solid #b4682a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #784827, #325249)",
    },
    stat: {
      background: "rgba(120, 72, 39, 0.8)",
      border: "min(0.25vw, 2px) solid #b4682a",
      color: "#e5b893",
      boxShadow: "0 0 min(1vw, 8px) rgba(180, 104, 42, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b4682a, #5991a4)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #784827",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(180, 104, 42, 0.6)",
    },
  },
  tropicalParadise: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(255, 165, 0, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(64, 224, 208, 0.5) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(135, 206, 250, 0.4) 0%, transparent 45%),\n               linear-gradient(145deg, #fff8e1, #ffe4b5, #f0e68c, #ffd89b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(255, 165, 0, 0.6) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(64, 224, 208, 0.5) 0%, transparent 60%),\n                   linear-gradient(135deg, #87ceeb, #40e0d0, #ffa500, #48d1cc, #ffd700)",
      color: "#1a5f7a",
      textShadow:
        "2px 2px 4px rgba(255, 255, 255, 0.8), 0 0 10px rgba(64, 224, 208, 0.5)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(64, 224, 208, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.4)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(255, 165, 0, 0.5) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(64, 224, 208, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #fffacd, #f0e68c, #ffe4b5)",
      border: "min(0.25vw, 2px) solid #40e0d0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(135, 206, 250, 0.3), 0 0 min(2vw, 15px) rgba(64, 224, 208, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(255, 165, 0, 0.6) 0%, transparent 55%),\n                   radial-gradient(circle at 70% 60%, rgba(64, 224, 208, 0.5) 0%, transparent 55%),\n                   linear-gradient(135deg, #87ceeb, #40e0d0, #ffa500, #48d1cc, #ffd700)",
      color: "#1a5f7a",
      textShadow:
        "2px 2px 4px rgba(255, 255, 255, 0.8), 0 0 10px rgba(64, 224, 208, 0.5)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(255, 165, 0, 0.3) 0%, transparent 50%),\n                   radial-gradient(circle at 60% 70%, rgba(64, 224, 208, 0.3) 0%, transparent 50%),\n                   linear-gradient(145deg, #fffacd, #fff8e1)",
      color: "#2f6690",
      accentColor: "#ffa500",
      border: "min(0.25vw, 2px) solid #40e0d0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #ffe4b5, #f0e68c)",
    },
    stat: {
      background: "rgba(255, 255, 255, 0.8)",
      border: "min(0.25vw, 2px) solid #40e0d0",
      color: "#1a5f7a",
      boxShadow: "0 0 min(1vw, 8px) rgba(64, 224, 208, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffd700, #ffa500)",
      color: "#1a5f7a",
      border: "min(0.25vw, 2px) solid #40e0d0",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 165, 0, 0.6)",
    },
  },
  enchantedGrove: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(64, 224, 208, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(34, 139, 34, 0.3) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(144, 238, 144, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #1a3a3a, #2d4a4a, #1f3535)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(64, 224, 208, 0.6) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(144, 238, 144, 0.5) 0%, transparent 60%),\n                   linear-gradient(135deg, #3a5a5a, #40e0d0, #5f9ea0, #48d1cc, #2f4f4f)",
      color: "#e8fff8",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(64, 224, 208, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(64, 224, 208, 0.5), inset 0 min(0.25vw, 2px) 0 rgba(144, 238, 144, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(64, 224, 208, 0.5) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(34, 139, 34, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #2d4a4a, #1a3a3a)",
      border: "min(0.25vw, 2px) solid #40e0d0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.7), 0 0 min(2vw, 15px) rgba(64, 224, 208, 0.4)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(64, 224, 208, 0.6) 0%, transparent 55%),\n                   linear-gradient(135deg, #3a5a5a, #40e0d0, #5f9ea0, #48d1cc, #2f4f4f)",
      color: "#e8fff8",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(64, 224, 208, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(64, 224, 208, 0.3) 0%, transparent 50%),\n                   linear-gradient(145deg, #2d4a4a, #1a3a3a)",
      color: "#c8f5e8",
      accentColor: "#48d1cc",
      border: "min(0.25vw, 2px) solid #40e0d0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1a3a3a, #2d4a4a)",
    },
    stat: {
      background: "rgba(26, 58, 58, 0.8)",
      border: "min(0.25vw, 2px) solid #48d1cc",
      color: "#7fffd4",
      boxShadow: "0 0 min(1vw, 8px) rgba(64, 224, 208, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #40e0d0, #20b2aa)",
      color: "#f0fff8",
      border: "min(0.25vw, 2px) solid #1a3a3a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(64, 224, 208, 0.6)",
    },
  },
  ancientGlade: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(34, 139, 34, 0.5) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(85, 107, 47, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(154, 205, 50, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #1a2e1a, #2d4a2d, #1f3a1f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(34, 139, 34, 0.7) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(154, 205, 50, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #3d5a3d, #4a6b3d, #556b2f, #6b8e23, #2d4a2d)",
      color: "#e8f5e8",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(34, 139, 34, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(34, 139, 34, 0.5), inset 0 min(0.25vw, 2px) 0 rgba(154, 205, 50, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(34, 139, 34, 0.6) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(85, 107, 47, 0.5) 0%, transparent 50%),\n                   linear-gradient(145deg, #2d4a2d, #1a2e1a)",
      border: "min(0.25vw, 2px) solid #4a6b3d",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.7), 0 0 min(2vw, 15px) rgba(34, 139, 34, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(34, 139, 34, 0.7) 0%, transparent 55%),\n                   linear-gradient(135deg, #3d5a3d, #4a6b3d, #556b2f, #6b8e23, #2d4a2d)",
      color: "#e8f5e8",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(34, 139, 34, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(34, 139, 34, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #2d4a2d, #1a2e1a)",
      color: "#c8e6c8",
      accentColor: "#6b8e23",
      border: "min(0.25vw, 2px) solid #4a6b3d",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1a2e1a, #2d4a2d)",
    },
    stat: {
      background: "rgba(26, 46, 26, 0.8)",
      border: "min(0.25vw, 2px) solid #6b8e23",
      color: "#9acd32",
      boxShadow: "0 0 min(1vw, 8px) rgba(107, 142, 35, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #6b8e23, #556b2f)",
      color: "#f0f8e8",
      border: "min(0.25vw, 2px) solid #1a2e1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(107, 142, 35, 0.6)",
    },
  },
  celestialPink: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(255, 182, 193, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(255, 192, 203, 0.5) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(255, 240, 245, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #fff5f7, #ffe4e8, #ffd6dd)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(255, 105, 180, 0.5) 0%, transparent 60%),\n                 linear-gradient(135deg, #ffffff, #ffb6d9, #ff69b4, #ffb6d9, #ffeef5)",
      color: "#8b1a5a",
      textShadow: "1px 1px 2px rgba(255, 255, 255, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(255, 105, 180, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.5)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(255, 182, 193, 0.4) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(255, 192, 203, 0.5) 0%, transparent 50%),\n                 linear-gradient(145deg, #ffffff, #ffe4e8, #ffd6dd)",
      border: "min(0.25vw, 2px) solid #ff69b4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(255, 105, 180, 0.2)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(255, 105, 180, 0.5) 0%, transparent 55%),\n                 linear-gradient(135deg, #ffffff, #ffb6d9, #ff69b4, #ffb6d9, #ffeef5)",
      color: "#8b1a5a",
      textShadow: "1px 1px 2px rgba(255, 255, 255, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(255, 182, 193, 0.3) 0%, transparent 50%),\n                 linear-gradient(145deg, #ffffff, #fff5f7)",
      color: "#c71585",
      accentColor: "#ff69b4",
      border: "min(0.25vw, 2px) solid #ffb6d9",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #ffeef5, #ffe4e8)",
    },
    stat: {
      background: "rgba(255, 255, 255, 0.9)",
      border: "min(0.25vw, 2px) solid #ff69b4",
      color: "#c71585",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 105, 180, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ff69b4, #ffb6d9)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #c71585",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 105, 180, 0.5)",
    },
  },
  cosmicPurple: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(75, 0, 130, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 80% 70%, rgba(25, 25, 112, 0.5) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(138, 43, 226, 0.3) 0%, transparent 45%),\n                 linear-gradient(145deg, #0f0f23, #191970, #1a1a2e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(138, 43, 226, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #4b0082, #663399, #8a2be2, #4b0082, #301934)",
      color: "#e6e6fa",
      textShadow: "1px 1px 2px rgba(138, 43, 226, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(138, 43, 226, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(75, 0, 130, 0.5) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(25, 25, 112, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #191970, #0f0f23)",
      border: "min(0.25vw, 2px) solid #4b0082",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(138, 43, 226, 0.6) 0%, transparent 55%),\n                   linear-gradient(135deg, #4b0082, #663399, #8a2be2, #4b0082, #301934)",
      color: "#e6e6fa",
      textShadow: "1px 1px 2px rgba(138, 43, 226, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(75, 0, 130, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #191970, #0f0f23)",
      color: "#d8bfd8",
      accentColor: "#8a2be2",
      border: "min(0.25vw, 2px) solid #4b0082",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #301934, #4b0082)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #dda0dd",
      color: "#dda0dd",
      boxShadow: "0 0 min(1vw, 8px) rgba(221, 160, 221, 0.4)",
    },
  },
  skyBlue: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(135, 206, 235, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 80% 70%, rgba(173, 216, 230, 0.5) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(240, 248, 255, 0.3) 0%, transparent 45%),\n                 linear-gradient(145deg, #e6f3ff, #b8dff0, #d6ebf5)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(135, 206, 235, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #ffffff, #f0f8ff, #87ceeb, #b0e0e6, #e0f6ff)",
      color: "#2f4f4f",
      textShadow: "1px 1px 2px rgba(255, 255, 255, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(135, 206, 235, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.6)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(135, 206, 235, 0.5) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(173, 216, 230, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #f0f8ff, #e6f3ff)",
      border: "min(0.25vw, 2px) solid #87ceeb",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(135, 206, 235, 0.2)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(135, 206, 235, 0.6) 0%, transparent 55%),\n                   linear-gradient(135deg, #ffffff, #f0f8ff, #87ceeb, #b0e0e6, #e0f6ff)",
      color: "#2f4f4f",
      textShadow: "1px 1px 2px rgba(255, 255, 255, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(135, 206, 235, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #f0f8ff, #e6f3ff)",
      color: "#4682b4",
      accentColor: "#87ceeb",
      border: "min(0.25vw, 2px) solid #87ceeb",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #e0f6ff, #b0e0e6)",
    },
    stat: {
      background: "rgba(255, 255, 255, 0.8)",
      border: "min(0.25vw, 2px) solid #4682b4",
      color: "#2f4f4f",
      boxShadow: "0 0 min(1vw, 8px) rgba(135, 206, 235, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffffff, #f0f8ff)",
      color: "#2f4f4f",
      border: "min(0.25vw, 2px) solid #4682b4",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(240, 248, 255, 0.5)",
    },
  },
  steelSky: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(192, 192, 192, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 80% 70%, rgba(135, 206, 235, 0.4) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(255, 182, 193, 0.3) 0%, transparent 45%),\n                 linear-gradient(145deg, #f0f8ff, #dcdcdc, #e6f3ff)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(192, 192, 192, 0.6) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(135, 206, 235, 0.5) 0%, transparent 60%),\n                   linear-gradient(135deg, #c0c0c0, #87ceeb, #dcdcdc, #b0e0e6, #a9a9a9)",
      color: "#2f4f4f",
      textShadow: "1px 1px 2px rgba(192, 192, 192, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(192, 192, 192, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.5)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(192, 192, 192, 0.4) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(135, 206, 235, 0.4) 0%, transparent 50%),\n                   radial-gradient(circle at 50% 50%, rgba(255, 182, 193, 0.2) 0%, transparent 60%),\n                   linear-gradient(145deg, #f0f8ff, #e6e6fa, #dcdcdc)",
      border: "min(0.25vw, 2px) solid #87ceeb",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(135, 206, 235, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(192, 192, 192, 0.6) 0%, transparent 55%),\n                   radial-gradient(circle at 70% 60%, rgba(135, 206, 235, 0.5) 0%, transparent 55%),\n                   linear-gradient(135deg, #c0c0c0, #87ceeb, #dcdcdc, #b0e0e6, #a9a9a9)",
      color: "#2f4f4f",
      textShadow: "1px 1px 2px rgba(192, 192, 192, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(192, 192, 192, 0.3) 0%, transparent 50%),\n                   radial-gradient(circle at 60% 70%, rgba(135, 206, 235, 0.3) 0%, transparent 50%),\n                   linear-gradient(145deg, #f0f8ff, #e6e6fa)",
      color: "#4682b4",
      accentColor: "#87ceeb",
      border: "min(0.25vw, 2px) solid #87ceeb",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #e0f6ff, #d3d3d3)",
    },
    stat: {
      background: "rgba(255, 255, 255, 0.9)",
      border: "min(0.25vw, 2px) solid #4682b4",
      color: "#2f4f4f",
      boxShadow: "0 0 min(1vw, 8px) rgba(135, 206, 235, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffffff, #f0f8ff)",
      color: "#2f4f4f",
      border: "min(0.25vw, 2px) solid #4682b4",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(240, 248, 255, 0.5)",
    },
  },
  sunsetFire: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(255, 140, 0, 0.5) 0%, transparent 50%),\n                 radial-gradient(circle at 80% 70%, rgba(220, 20, 60, 0.4) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(255, 215, 0, 0.3) 0%, transparent 45%),\n                 linear-gradient(145deg, #4a1a00, #8b4513, #cd853f, #2f1b14)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(255, 140, 0, 0.7) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(220, 20, 60, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #ff8c00, #dc143c, #ffd700, #ff6347, #b22222)",
      color: "#fff8dc",
      textShadow: "2px 2px 4px rgba(139, 69, 19, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(255, 140, 0, 0.5), inset 0 min(0.25vw, 2px) 0 rgba(255, 215, 0, 0.4)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(255, 140, 0, 0.6) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(220, 20, 60, 0.5) 0%, transparent 50%),\n                   radial-gradient(circle at 50% 50%, rgba(255, 215, 0, 0.3) 0%, transparent 60%),\n                   linear-gradient(145deg, #8b4513, #cd853f, #4a1a00)",
      border: "min(0.25vw, 2px) solid #ff8c00",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(255, 140, 0, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(255, 140, 0, 0.7) 0%, transparent 55%),\n                   radial-gradient(circle at 70% 60%, rgba(220, 20, 60, 0.6) 0%, transparent 55%),\n                   linear-gradient(135deg, #ff8c00, #dc143c, #ffd700, #ff6347, #b22222)",
      color: "#fff8dc",
      textShadow: "2px 2px 4px rgba(139, 69, 19, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(255, 140, 0, 0.4) 0%, transparent 50%),\n                   radial-gradient(circle at 60% 70%, rgba(220, 20, 60, 0.3) 0%, transparent 50%),\n                   linear-gradient(145deg, #8b4513, #4a1a00, #cd853f)",
      color: "#deb887",
      accentColor: "#ff8c00",
      border: "min(0.25vw, 2px) solid #ff8c00",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4a1a00, #8b4513)",
    },
    stat: {
      background: "rgba(139, 69, 19, 0.8)",
      border: "min(0.25vw, 2px) solid #ffd700",
      color: "#fff8dc",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 215, 0, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffd700, #ff8c00)",
      color: "#4a1a00",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 215, 0, 0.6)",
    },
  },
  alchemicalRed: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(220, 20, 60, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 80% 70%, rgba(139, 0, 0, 0.5) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(255, 140, 0, 0.3) 0%, transparent 45%),\n                 linear-gradient(145deg, #2c1810, #8b0000, #1a0e0a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(220, 20, 60, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #8b0000, #dc143c, #ff8c00, #8b0000, #4a0e0e)",
      color: "#ffd700",
      textShadow: "1px 1px 2px rgba(220, 20, 60, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(220, 20, 60, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 215, 0, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(220, 20, 60, 0.5) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(139, 0, 0, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #8b0000, #2c1810)",
      border: "min(0.25vw, 2px) solid #dc143c",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(220, 20, 60, 0.6) 0%, transparent 55%),\n                   linear-gradient(135deg, #8b0000, #dc143c, #ff8c00, #8b0000, #4a0e0e)",
      color: "#ffd700",
      textShadow: "1px 1px 2px rgba(220, 20, 60, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(220, 20, 60, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #8b0000, #2c1810)",
      color: "#ffb347",
      accentColor: "#dc143c",
      border: "min(0.25vw, 2px) solid #dc143c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4a0e0e, #8b0000)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #ffd700",
      color: "#ffd700",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 215, 0, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffd700, #daa520)",
      color: "#2c1810",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 215, 0, 0.5)",
    },
  },
  steelPsychic: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(192, 192, 192, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 80% 70%, rgba(138, 43, 226, 0.3) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(70, 130, 180, 0.4) 0%, transparent 45%),\n                 linear-gradient(145deg, #2c3e50, #34495e, #1a252f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(192, 192, 192, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #708090, #c0c0c0, #8a2be2, #708090, #4682b4)",
      color: "#e6e6fa",
      textShadow: "1px 1px 2px rgba(112, 128, 144, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(192, 192, 192, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(192, 192, 192, 0.5) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(138, 43, 226, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #34495e, #2c3e50)",
      border: "min(0.25vw, 2px) solid #c0c0c0",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(192, 192, 192, 0.6) 0%, transparent 55%),\n                   linear-gradient(135deg, #708090, #c0c0c0, #8a2be2, #708090, #4682b4)",
      color: "#e6e6fa",
      textShadow: "1px 1px 2px rgba(112, 128, 144, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(192, 192, 192, 0.4) 0%, transparent 50%),\n                   linear-gradient(145deg, #34495e, #2c3e50)",
      color: "#b0c4de",
      accentColor: "#c0c0c0",
      border: "min(0.25vw, 2px) solid #c0c0c0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1a252f, #2c3e50)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #dda0dd",
      color: "#dda0dd",
      boxShadow: "0 0 min(1vw, 8px) rgba(221, 160, 221, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #dda0dd, #ba55d3)",
      color: "#1a252f",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(221, 160, 221, 0.5)",
    },
  },
  airyWhite: {
    background: "linear-gradient(145deg, #f8fbff, #e8f4f8, #d8eef5)",
    header: {
      background:
        "linear-gradient(135deg, #ffffff, #f0f8ff, #e6f3ff, #ffffff, #ddeeff)",
      color: "#4a6b82",
      textShadow: "1px 1px 2px rgba(255, 255, 255, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(220, 245, 255, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.6)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #f0f8ff, #e8f4f8)",
      border: "min(0.25vw, 2px) solid #b0d4e8",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(135, 206, 235, 0.2)",
    },
    typeSection: {
      background:
        "linear-gradient(135deg, #ffffff, #f0f8ff, #e6f3ff, #ffffff, #ddeeff)",
      color: "#4a6b82",
      textShadow: "1px 1px 2px rgba(255, 255, 255, 0.8)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #f8fbff, #e8f4f8)",
      color: "#5a7a8a",
      accentColor: "#87ceeb",
      border: "min(0.25vw, 2px) solid #b0d4e8",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #e8f4f8, #d8eef5)",
    },
    stat: {
      background: "rgba(255, 255, 255, 0.7)",
      border: "min(0.25vw, 2px) solid #87ceeb",
      color: "#4a6b82",
      boxShadow: "0 0 min(1vw, 8px) rgba(135, 206, 235, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #87ceeb, #b0e0e6)",
      color: "#2f4f4f",
      border: "min(0.25vw, 2px) solid #4a6b82",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(135, 206, 235, 0.5)",
    },
  },
  stoneMoss: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(34, 139, 34, 0.25) 0%, transparent 50%),\n                 radial-gradient(circle at 70% 70%, rgba(0, 100, 0, 0.15) 0%, transparent 50%),\n                 linear-gradient(145deg, #3a3a3a, #2e2e2e, #1c1c1c)",
    header: {
      background: "linear-gradient(135deg, #5c5c5c, #444, #2f2f2f)",
      color: "#e0e0e0",
      textShadow: "1px 1px 2px rgba(138, 43, 226, 0.8)",
      boxShadow:
        "inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 2px 6px rgba(0, 0, 0, 0.6)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #4d4d4d, #2c2c2c)",
      border: "2px solid #2e2e2e",
      boxShadow:
        "inset 0 0 8px rgba(0, 0, 0, 0.8), 0 0 10px rgba(34, 139, 34, 0.3)",
    },
    typeSection: {
      background: "linear-gradient(135deg, #5a5a5a, #3f3f3f)",
      color: "#e6e6e6",
      textShadow: "1px 1px 2px #000",
    },
    flavorText: {
      background: "linear-gradient(145deg, #3b3b3b, #2a2a2a)",
      color: "#c0c0c0",
      accentColor: "#556b2f",
      border: "2px solid #2e2e2e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2f2f2f, #1c1c1c)",
    },
    stat: {
      background: "rgba(20, 20, 20, 0.8)",
      border: "1px solid #3c3c3c",
      color: "#98fb98",
      boxShadow: "0 0 min(1vw, 8px) rgba(221, 160, 221, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #666, #444)",
      color: "#f5f5f5",
      border: "1px solid #111",
      boxShadow: "0 0 6px rgba(34, 139, 34, 0.4)",
    },
  },
  darkForest: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(70, 89, 69, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 80% 70%, rgba(128, 127, 127, 0.4) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(137, 137, 137, 0.3) 0%, transparent 45%),\n                 linear-gradient(145deg, #2f2f2f, #465945, #3a3a3a, #4a4a4a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(89, 113, 88, 0.6) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(152, 193, 150, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #2f2f2f, #465945, #3a3a3a, #555555, #2a2a2a)",
      color: "#d3d3d3",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(70, 89, 69, 0.3), inset 0 min(0.25vw, 2px) 0 rgba(211, 211, 211, 0.1)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(89, 113, 88, 0.6) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(152, 193, 150, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #2f2f2f, #465945, #3a3a3a, #555555, #2a2a2a)",
      border: "min(0.25vw, 2px) solid #465945",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.7)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(89, 113, 88, 0.6) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(152, 193, 150, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #2f2f2f, #465945, #3a3a3a, #555555, #2a2a2a)",
      color: "#d3d3d3",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(70, 89, 69, 0.2) 0%, transparent 50%),\n                   radial-gradient(circle at 60% 70%, rgba(47, 47, 47, 0.2) 0%, transparent 50%),\n                   linear-gradient(145deg, #2f2f2f, #465945)",
      color: "#a8b8a8",
      accentColor: "#708070",
      border: "min(0.25vw, 2px) solid #465945",
    },
    bottomSection: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(89, 113, 88, 0.6) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(152, 193, 150, 0.6) 0%, transparent 60%),\n                   linear-gradient(135deg, #2f2f2f, #465945, #3a3a3a, #555555, #2a2a2a)",
    },
    stat: {
      background: "rgba(26, 26, 26, 0.8)",
      border: "min(0.25vw, 2px) solid #708070",
      color: "#708070",
      boxShadow: "0 0 min(1vw, 8px) rgba(112, 128, 112, 0.3)",
    },
    rarity: {
      background: "linear-gradient(135deg, #708070, #556b55)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(112, 128, 112, 0.4)",
    },
  },
  moonlight: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(176, 196, 222, 0.3) 0%, transparent 50%),\n                 radial-gradient(circle at 80% 70%, rgba(119, 136, 153, 0.2) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(230, 230, 250, 0.2) 0%, transparent 45%),\n                 linear-gradient(145deg, #2f4f4f, #708090, #4682b4, #5f7f8f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(176, 196, 222, 0.4) 0%, transparent 60%),\n                   radial-gradient(circle at 75% 50%, rgba(119, 136, 153, 0.3) 0%, transparent 60%),\n                   linear-gradient(135deg, #708090, #b0c4de, #778899, #e6e6fa, #c0c0c0)",
      color: "#f8f8ff",
      textShadow: "1px 1px 3px rgba(70, 130, 180, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(176, 196, 222, 0.3), inset 0 min(0.25vw, 2px) 0 rgba(248, 248, 255, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(176, 196, 222, 0.3) 0%, transparent 45%),\n                   radial-gradient(circle at 70% 80%, rgba(119, 136, 153, 0.2) 0%, transparent 50%),\n                   radial-gradient(circle at 50% 50%, rgba(230, 230, 250, 0.2) 0%, transparent 60%),\n                   linear-gradient(145deg, #2f4f4f, #708090, #4682b4)",
      border: "min(0.25vw, 2px) solid #b0c4de",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(70, 130, 180, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(176, 196, 222, 0.4) 0%, transparent 55%),\n                   radial-gradient(circle at 70% 60%, rgba(119, 136, 153, 0.3) 0%, transparent 55%),\n                   linear-gradient(135deg, #708090, #b0c4de, #778899, #e6e6fa, #c0c0c0)",
      color: "#f8f8ff",
      textShadow: "1px 1px 3px rgba(70, 130, 180, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(176, 196, 222, 0.2) 0%, transparent 50%),\n                   radial-gradient(circle at 60% 70%, rgba(119, 136, 153, 0.2) 0%, transparent 50%),\n                   linear-gradient(145deg, #2f4f4f, #708090)",
      color: "#d3d3d3",
      accentColor: "#87ceeb",
      border: "min(0.25vw, 2px) solid #b0c4de",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #708090, #4682b4)",
    },
    stat: {
      background: "rgba(47, 79, 79, 0.6)",
      border: "min(0.25vw, 2px) solid #b0c4de",
      color: "#b0c4de",
      boxShadow: "0 0 min(1vw, 8px) rgba(176, 196, 222, 0.3)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e6e6fa, #d3d3d3)",
      color: "#2f4f4f",
      border: "min(0.25vw, 2px) solid #4682b4",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(230, 230, 250, 0.4)",
    },
  },
  beachOcean: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(64, 224, 208, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(238, 203, 173, 0.5) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(144, 238, 144, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #f0f8ff, #e0f6ff, #deb887, #87ceeb)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(64, 224, 208, 0.6) 0%, transparent 60%),\n                 linear-gradient(135deg, #40e0d0, #87ceeb, #deb887, #20b2aa, #5f9ea0)",
      color: "#2f4f4f",
      textShadow: "1px 1px 2px rgba(222, 184, 135, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(64, 224, 208, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(240, 248, 255, 0.6)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(64, 224, 208, 0.5) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(238, 203, 173, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #f0f8ff, #e0f6ff, #deb887)",
      border: "min(0.25vw, 2px) solid #40e0d0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(64, 224, 208, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(64, 224, 208, 0.6) 0%, transparent 55%),\n                 linear-gradient(135deg, #40e0d0, #87ceeb, #deb887, #20b2aa, #5f9ea0)",
      color: "#2f4f4f",
      textShadow: "1px 1px 2px rgba(222, 184, 135, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(64, 224, 208, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #f0f8ff, #e0f6ff, #deb887)",
      color: "#20b2aa",
      accentColor: "#40e0d0",
      border: "min(0.25vw, 2px) solid #40e0d0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #e0f6ff, #deb887)",
    },
    stat: {
      background: "rgba(240, 248, 255, 0.8)",
      border: "min(0.25vw, 2px) solid #20b2aa",
      color: "#2f4f4f",
      boxShadow: "0 0 min(1vw, 8px) rgba(64, 224, 208, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f0f8ff, #40e0d0)",
      color: "#2f4f4f",
      border: "min(0.25vw, 2px) solid #2e8b57",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(240, 248, 255, 0.5)",
    },
  },
  shadowVoid: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(75, 0, 130, 0.5) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(138, 43, 226, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(72, 61, 139, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #1a0033, #2d1b3d, #1c0a2e, #0f0519)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(138, 43, 226, 0.7) 0%, transparent 60%),\n                 linear-gradient(135deg, #4b0082, #663399, #2d1b3d, #8b008b, #1a0033)",
      color: "#e6d5ff",
      textShadow: "1px 1px 2px rgba(75, 0, 130, 0.9)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(138, 43, 226, 0.5), inset 0 min(0.25vw, 2px) 0 rgba(186, 85, 211, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(138, 43, 226, 0.6) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(75, 0, 130, 0.5) 0%, transparent 50%),\n                 linear-gradient(145deg, #1a0033, #2d1b3d, #0f0519)",
      border: "min(0.25vw, 2px) solid #8b008b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(138, 43, 226, 0.5)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(138, 43, 226, 0.7) 0%, transparent 55%),\n                 linear-gradient(135deg, #4b0082, #663399, #2d1b3d, #8b008b, #1a0033)",
      color: "#e6d5ff",
      textShadow: "1px 1px 2px rgba(75, 0, 130, 0.9)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(138, 43, 226, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #1a0033, #0f0519, #2d1b3d)",
      color: "#d8bfd8",
      accentColor: "#ba55d3",
      border: "min(0.25vw, 2px) solid #8b008b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0f0519, #1a0033)",
    },
    stat: {
      background: "rgba(15, 5, 25, 0.8)",
      border: "min(0.25vw, 2px) solid #ba55d3",
      color: "#e6d5ff",
      boxShadow: "0 0 min(1vw, 8px) rgba(186, 85, 211, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ba55d3, #8b008b)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #0f0519",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(186, 85, 211, 0.6)",
    },
  },
  earthGreen: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(107, 142, 35, 0.5) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(139, 69, 19, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(154, 205, 50, 0.4) 0%, transparent 45%),\n               linear-gradient(145deg, #4a5234, #5a6b3d, #3d4a28)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(154, 205, 50, 0.6) 0%, transparent 60%),\n                 linear-gradient(135deg, #6b8e23, #9acd32, #8fbc8f, #6b8e23, #556b2f)",
      color: "#f5f5dc",
      textShadow: "1px 1px 2px rgba(85, 107, 47, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(107, 142, 35, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(154, 205, 50, 0.5) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(107, 142, 35, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #5a6b3d, #4a5234)",
      border: "min(0.25vw, 2px) solid #6b8e23",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(154, 205, 50, 0.6) 0%, transparent 55%),\n                 linear-gradient(135deg, #6b8e23, #9acd32, #8fbc8f, #6b8e23, #556b2f)",
      color: "#f5f5dc",
      textShadow: "1px 1px 2px rgba(85, 107, 47, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(107, 142, 35, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #5a6b3d, #4a5234)",
      color: "#d0e8b0",
      accentColor: "#6b8e23",
      border: "min(0.25vw, 2px) solid #6b8e23",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3d4a28, #4a5234)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #9acd32",
      color: "#9acd32",
      boxShadow: "0 0 min(1vw, 8px) rgba(154, 205, 50, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #9acd32, #7cfc00)",
      color: "#2d3d1f",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(154, 205, 50, 0.5)",
    },
  },
  ancientEarth: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(85, 107, 47, 0.5) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(160, 82, 45, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #3a2f1a, #4a3728, #2d2016)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(139, 69, 19, 0.6) 0%, transparent 60%),\n                 linear-gradient(135deg, #8b4513, #a0522d, #cd853f, #8b4513, #654321)",
      color: "#f5deb3",
      textShadow: "1px 1px 2px rgba(139, 69, 19, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(139, 69, 19, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(245, 222, 179, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(139, 69, 19, 0.5) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(85, 107, 47, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #4a3728, #3a2f1a)",
      border: "min(0.25vw, 2px) solid #8b4513",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(139, 69, 19, 0.6) 0%, transparent 55%),\n                 linear-gradient(135deg, #8b4513, #a0522d, #cd853f, #8b4513, #654321)",
      color: "#f5deb3",
      textShadow: "1px 1px 2px rgba(139, 69, 19, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(139, 69, 19, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #4a3728, #3a2f1a)",
      color: "#d2b48c",
      accentColor: "#8b4513",
      border: "min(0.25vw, 2px) solid #8b4513",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2d2016, #3a2f1a)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #daa520",
      color: "#daa520",
      boxShadow: "0 0 min(1vw, 8px) rgba(218, 165, 32, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #daa520, #b8860b)",
      color: "#2d2016",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(218, 165, 32, 0.5)",
    },
  },
  stoneGuardian: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(139, 137, 137, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(154, 175, 136, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(105, 105, 105, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #2f2f2f, #696969, #808080)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(139, 137, 137, 0.6) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(154, 175, 136, 0.5) 0%, transparent 60%),\n                 linear-gradient(135deg, #696969, #9caf88, #8b8989, #355e3b, #778899)",
      color: "#f5f5dc",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(139, 137, 137, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(245, 245, 220, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(139, 137, 137, 0.4) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(154, 175, 136, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 50% 50%, rgba(105, 105, 105, 0.3) 0%, transparent 60%),\n                 linear-gradient(145deg, #2f2f2f, #696969, #8b8989)",
      border: "min(0.25vw, 2px) solid #355e3b",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(139, 137, 137, 0.6) 0%, transparent 55%),\n                 radial-gradient(circle at 70% 60%, rgba(154, 175, 136, 0.5) 0%, transparent 55%),\n                 linear-gradient(135deg, #696969, #9caf88, #8b8989, #355e3b, #778899)",
      color: "#f5f5dc",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(139, 137, 137, 0.3) 0%, transparent 50%),\n                 radial-gradient(circle at 60% 70%, rgba(154, 175, 136, 0.3) 0%, transparent 50%),\n                 linear-gradient(145deg, #2f2f2f, #696969)",
      color: "#d2b48c",
      accentColor: "#556b2f",
      border: "min(0.25vw, 2px) solid #355e3b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #355e3b, #8b8989)",
    },
    stat: {
      background: "rgba(47, 47, 47, 0.8)",
      border: "min(0.25vw, 2px) solid #daa520",
      color: "#daa520",
      boxShadow: "0 0 min(1vw, 8px) rgba(218, 165, 32, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #daa520, #b8860b)",
      color: "#2f2f2f",
      border: "min(0.25vw, 2px) solid #2f2f2f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(218, 165, 32, 0.5)",
    },
  },
  federalNavy: {
    background: "linear-gradient(145deg, #1e2a3a, #2c3e50, #1a252f)",
    header: {
      background:
        "linear-gradient(135deg, #14356c, #1e4a7a, #285f8f, #14356c, #0f2749)",
      color: "#ffffff",
      textShadow: "1px 1px 2px rgba(20, 53, 108, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(20, 53, 108, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #34495e, #2c3e50)",
      border: "min(0.25vw, 2px) solid #14356c",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.5)",
    },
    typeSection: {
      background:
        "linear-gradient(135deg, #14356c, #1e4a7a, #285f8f, #14356c, #0f2749)",
      color: "#ffffff",
      textShadow: "1px 1px 2px rgba(20, 53, 108, 0.8)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #2c3e50, #34495e)",
      color: "#ecf0f1",
      accentColor: "#14356c",
      border: "min(0.25vw, 2px) solid #14356c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1a252f, #2c3e50)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #ffd700",
      color: "#ffd700",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 215, 0, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffd700, #daa520)",
      color: "#0f2749",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 215, 0, 0.5)",
    },
  },
  retroGaming: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(255, 0, 0, 0.3) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(0, 123, 255, 0.3) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(40, 167, 69, 0.3) 0%, transparent 45%),\n               radial-gradient(circle at 40% 80%, rgba(255, 193, 7, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #5a5a5a, #404040, #4a4a4a)",
    header: {
      background:
        "radial-gradient(circle at 15% 25%, rgba(255, 0, 0, 0.4) 0%, transparent 40%),\n                 radial-gradient(circle at 60% 10%, rgba(0, 123, 255, 0.4) 0%, transparent 35%),\n                 radial-gradient(circle at 85% 60%, rgba(40, 167, 69, 0.4) 0%, transparent 30%),\n                 linear-gradient(135deg, #6c757d, #495057, #6c757d, #5a6268, #343a40)",
      color: "#ffffff",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(255, 193, 7, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(255, 0, 0, 0.4) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(0, 123, 255, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 50% 50%, rgba(255, 193, 7, 0.3) 0%, transparent 60%),\n                 linear-gradient(145deg, #4a4a4a, #343a40)",
      border: "min(0.25vw, 2px) solid #6c757d",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.5)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 20% 40%, rgba(255, 0, 0, 0.4) 0%, transparent 45%),\n                 radial-gradient(circle at 80% 20%, rgba(0, 123, 255, 0.4) 0%, transparent 40%),\n                 linear-gradient(135deg, #6c757d, #495057, #6c757d, #5a6268, #343a40)",
      color: "#ffffff",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 30% 70%, rgba(40, 167, 69, 0.3) 0%, transparent 40%),\n                 linear-gradient(145deg, #4a4a4a, #343a40)",
      color: "#e0e0e0",
      accentColor: "#ffc107",
      border: "min(0.25vw, 2px) solid #6c757d",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2c3034, #343a40)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.8)",
      border: "min(0.25vw, 2px) solid #ffc107",
      color: "#ffc107",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 193, 7, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffc107, #ff9800)",
      color: "#2c3034",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 193, 7, 0.6)",
    },
  },
  purpleJustice: {
    background: "linear-gradient(145deg, #f5f0ff, #e6d7ff, #dcc9ff)",
    header: {
      background:
        "linear-gradient(135deg, #8a2be2, #9370db, #ba55d3, #8a2be2, #6a1b9a)",
      color: "#ffffff",
      textShadow: "1px 1px 2px rgba(138, 43, 226, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(138, 43, 226, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #e6d7ff, #d8bfd8)",
      border: "min(0.25vw, 2px) solid #4b0082",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.3)",
    },
    typeSection: {
      background:
        "linear-gradient(135deg, #8a2be2, #9370db, #ba55d3, #8a2be2, #6a1b9a)",
      color: "#ffffff",
      textShadow: "1px 1px 2px rgba(138, 43, 226, 0.8)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #f5f0ff, #e6d7ff)",
      color: "#4b0082",
      accentColor: "#8a2be2",
      border: "min(0.25vw, 2px) solid #4b0082",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2e1065, #4b0082)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #ffd700",
      color: "#ffd700",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 215, 0, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffd700, #daa520)",
      color: "#4b0082",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 215, 0, 0.5)",
    },
  },
  steelOcean: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(70, 130, 180, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(119, 136, 153, 0.5) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(176, 196, 222, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #2f4f4f, #4682b4, #708090, #1e3a5f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(70, 130, 180, 0.6) 0%, transparent 60%),\n                 linear-gradient(135deg, #4682b4, #708090, #2f4f4f, #5f6a6a, #36454f)",
      color: "#e6f3ff",
      textShadow: "1px 1px 2px rgba(47, 79, 79, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(70, 130, 180, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(176, 196, 222, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(70, 130, 180, 0.5) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(119, 136, 153, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #2f4f4f, #36454f)",
      border: "min(0.25vw, 2px) solid #4682b4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(70, 130, 180, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(70, 130, 180, 0.6) 0%, transparent 55%),\n                 linear-gradient(135deg, #4682b4, #708090, #2f4f4f, #5f6a6a, #36454f)",
      color: "#e6f3ff",
      textShadow: "1px 1px 2px rgba(47, 79, 79, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(70, 130, 180, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #2f4f4f, #1e3a5f)",
      color: "#b0c4de",
      accentColor: "#4682b4",
      border: "min(0.25vw, 2px) solid #4682b4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1e3a5f, #2f4f4f)",
    },
    stat: {
      background: "rgba(30, 58, 95, 0.7)",
      border: "min(0.25vw, 2px) solid #b0c4de",
      color: "#b0c4de",
      boxShadow: "0 0 min(1vw, 8px) rgba(176, 196, 222, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b0c4de, #4682b4)",
      color: "#1e3a5f",
      border: "min(0.25vw, 2px) solid #1e3a5f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(176, 196, 222, 0.5)",
    },
  },
  necromantic: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(128, 0, 128, 0.5) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(0, 100, 0, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(75, 0, 130, 0.4) 0%, transparent 45%),\n               linear-gradient(145deg, #1a0a1a, #0f0a0f, #1f1a1f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(128, 0, 128, 0.7) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(0, 100, 0, 0.5) 0%, transparent 60%),\n                 linear-gradient(135deg, #4b0082, #6a0dad, #483d8b, #2e1a47, #1f0a2e)",
      color: "#d8bfd8",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(128, 0, 128, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(128, 0, 128, 0.5), inset 0 min(0.25vw, 2px) 0 rgba(106, 13, 173, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(128, 0, 128, 0.6) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(0, 100, 0, 0.5) 0%, transparent 50%),\n                 linear-gradient(145deg, #1f1a1f, #0f0a0f)",
      border: "min(0.25vw, 2px) solid #6a0dad",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.7), 0 0 min(2vw, 15px) rgba(128, 0, 128, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(128, 0, 128, 0.7) 0%, transparent 55%),\n                 linear-gradient(135deg, #4b0082, #6a0dad, #483d8b, #2e1a47, #1f0a2e)",
      color: "#d8bfd8",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(128, 0, 128, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(128, 0, 128, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #1f1a1f, #0f0a0f)",
      color: "#b19cd9",
      accentColor: "#6a0dad",
      border: "min(0.25vw, 2px) solid #6a0dad",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0f0a0f, #1f0a2e)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.8)",
      border: "min(0.25vw, 2px) solid #6a0dad",
      color: "#da70d6",
      boxShadow: "0 0 min(1vw, 8px) rgba(106, 13, 173, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #6a0dad, #8b00ff)",
      color: "#e6e6fa",
      border: "min(0.25vw, 2px) solid #0f0a0f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(138, 43, 226, 0.6)",
    },
  },
  silverAgent: {
    background: "linear-gradient(145deg, #2c2c2c, #1a1a1a, #0f0f0f)",
    header: {
      background:
        "linear-gradient(135deg, #c0c0c0, #808080, #a9a9a9, #c0c0c0, #696969)",
      color: "#000000",
      textShadow: "1px 1px 2px rgba(192, 192, 192, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(192, 192, 192, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #3a3a3a, #1f1f1f)",
      border: "min(0.25vw, 2px) solid #c0c0c0",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.5)",
    },
    typeSection: {
      background:
        "linear-gradient(135deg, #c0c0c0, #808080, #a9a9a9, #c0c0c0, #696969)",
      color: "#000000",
      textShadow: "1px 1px 2px rgba(192, 192, 192, 0.8)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #2c2c2c, #1a1a1a)",
      color: "#c0c0c0",
      accentColor: "#696969",
      border: "min(0.25vw, 2px) solid #c0c0c0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1a1a1a, #2f2f2f)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.8)",
      border: "min(0.25vw, 2px) solid #c0c0c0",
      color: "#c0c0c0",
      boxShadow: "0 0 min(1vw, 8px) rgba(192, 192, 192, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c0c0c0, #808080)",
      color: "#000000",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(192, 192, 192, 0.5)",
    },
  },
  ethereumPurple: {
    background: "linear-gradient(145deg, #1a1a2e, #16213e, #0f0f23)",
    header: {
      background:
        "linear-gradient(135deg, #627eea, #5a67d8, #805ad5, #627eea, #4c51bf)",
      color: "#ffffff",
      textShadow: "1px 1px 2px rgba(98, 126, 234, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(98, 126, 234, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #2d3748, #1a202c)",
      border: "min(0.25vw, 2px) solid #627eea",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.5)",
    },
    typeSection: {
      background:
        "linear-gradient(135deg, #627eea, #5a67d8, #805ad5, #627eea, #4c51bf)",
      color: "#ffffff",
      textShadow: "1px 1px 2px rgba(98, 126, 234, 0.8)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #1a1a2e, #16213e)",
      color: "#e2e8f0",
      accentColor: "#627eea",
      border: "min(0.25vw, 2px) solid #627eea",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1a202c, #2d3748)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #ffd700",
      color: "#ffd700",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 215, 0, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffd700, #e6cc00)",
      color: "#2d3748",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 215, 0, 0.5)",
    },
  },
  beachLuxury: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(240, 230, 140, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(72, 209, 204, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(144, 238, 144, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #f5f5dc, #e6e6c8, #c8d5d0, #d4e6e1)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(240, 230, 140, 0.5) 0%, transparent 60%),\n                 linear-gradient(135deg, #e8dcc0, #c8d5d0, #b8d4ce, #d4dcc0, #c9d7c8)",
      color: "#2f4f4f",
      textShadow: "1px 1px 2px rgba(255, 255, 255, 0.5)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(72, 209, 204, 0.3), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(240, 230, 140, 0.4) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(72, 209, 204, 0.3) 0%, transparent 50%),\n                 linear-gradient(145deg, #f5f5dc, #e6e6c8, #c8d5d0)",
      border: "min(0.25vw, 2px) solid #48d1cc",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(72, 209, 204, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(240, 230, 140, 0.5) 0%, transparent 55%),\n                 linear-gradient(135deg, #e8dcc0, #c8d5d0, #b8d4ce, #d4dcc0, #c9d7c8)",
      color: "#2f4f4f",
      textShadow: "1px 1px 2px rgba(255, 255, 255, 0.5)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(240, 230, 140, 0.3) 0%, transparent 50%),\n                 linear-gradient(145deg, #f5f5dc, #e6e6c8, #d4e6e1)",
      color: "#3a5a5a",
      accentColor: "#48d1cc",
      border: "min(0.25vw, 2px) solid #48d1cc",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #d4e6e1, #c8d5d0)",
    },
    stat: {
      background: "linear-gradient(135deg, #f0e68c, #e6d878, #d4c86a)",
      border: "min(0.25vw, 2px) solid #7a9193",
      color: "#2f4f4f",
      boxShadow: "0 0 min(1vw, 8px) rgba(72, 209, 204, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f0e68c, #e6d878)",
      color: "#2f4f4f",
      border: "min(0.25vw, 2px) solid #7a9193",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(240, 230, 140, 0.4)",
    },
  },
  pureGold: {
    background: "linear-gradient(145deg, #fffef7, #f5e6a8, #fffacd)",
    header: {
      background:
        "linear-gradient(135deg, #ffd700, #ffa500, #ffff00, #ffd700, #daa520)",
      color: "#1a1a1a",
      textShadow: "1px 1px 2px rgba(255, 215, 0, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(255, 215, 0, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #f5deb3, #deb887)",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.3)",
    },
    typeSection: {
      background:
        "linear-gradient(135deg, #ffd700, #ffa500, #ffff00, #ffd700, #daa520)",
      color: "#1a1a1a",
      textShadow: "1px 1px 2px rgba(255, 215, 0, 0.8)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #fffef7, #f5e6a8)",
      color: "#5d4e37",
      accentColor: "#8b4513",
      border: "min(0.25vw, 2px) solid #1a1a1a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2c1810, #8b4513)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #ffd700",
      color: "#ffd700",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 215, 0, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffd700, #ffa500)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 215, 0, 0.5)",
    },
  },
  phoenixFire: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(255, 69, 0, 0.6) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(255, 140, 0, 0.5) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(255, 215, 0, 0.4) 0%, transparent 45%),\n               linear-gradient(145deg, #8b0000, #ff4500, #ff8c00, #1a0600)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(255, 69, 0, 0.8) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(255, 140, 0, 0.7) 0%, transparent 60%),\n                 linear-gradient(135deg, #ff4500, #ff6347, #ffd700, #ff8c00, #dc143c)",
      color: "#fff8dc",
      textShadow: "2px 2px 4px rgba(139, 0, 0, 0.9)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(255, 69, 0, 0.6), inset 0 min(0.25vw, 2px) 0 rgba(255, 215, 0, 0.5)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(255, 69, 0, 0.7) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(255, 140, 0, 0.6) 0%, transparent 50%),\n                 radial-gradient(circle at 50% 50%, rgba(255, 215, 0, 0.4) 0%, transparent 60%),\n                 linear-gradient(145deg, #ff4500, #ff8c00, #8b0000)",
      border: "min(0.25vw, 2px) solid #ffd700",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(255, 69, 0, 0.4)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(255, 69, 0, 0.8) 0%, transparent 55%),\n                 radial-gradient(circle at 70% 60%, rgba(255, 140, 0, 0.7) 0%, transparent 55%),\n                 linear-gradient(135deg, #ff4500, #ff6347, #ffd700, #ff8c00, #dc143c)",
      color: "#fff8dc",
      textShadow: "2px 2px 4px rgba(139, 0, 0, 0.9)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(255, 69, 0, 0.5) 0%, transparent 50%),\n                 radial-gradient(circle at 60% 70%, rgba(255, 140, 0, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #ff4500, #8b0000, #ff8c00)",
      color: "#ffb347",
      accentColor: "#ffd700",
      border: "min(0.25vw, 2px) solid #ffd700",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #8b0000, #ff4500)",
    },
    stat: {
      background: "rgba(139, 0, 0, 0.8)",
      border: "min(0.25vw, 2px) solid #ffd700",
      color: "#fff8dc",
      boxShadow: "0 0 min(1vw, 8px) rgba(255, 215, 0, 0.6)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ffd700, #ff8c00)",
      color: "#8b0000",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(255, 215, 0, 0.7)",
    },
  },
  oceanBlue: {
    background: "linear-gradient(145deg, #f0f8ff, #e6f3ff, #ddeeff)",
    header: {
      background:
        "linear-gradient(135deg, #00bfff, #1e90ff, #87ceeb, #00bfff, #4682b4)",
      color: "#1a1a1a",
      textShadow: "1px 1px 2px rgba(0, 191, 255, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(0, 191, 255, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #e6f3ff, #b0e0e6)",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.3)",
    },
    typeSection: {
      background:
        "linear-gradient(135deg, #00bfff, #1e90ff, #87ceeb, #00bfff, #4682b4)",
      color: "#1a1a1a",
      textShadow: "1px 1px 2px rgba(0, 191, 255, 0.8)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #f0f8ff, #e6f3ff)",
      color: "#2f4f4f",
      accentColor: "#4682b4",
      border: "min(0.25vw, 2px) solid #1a1a1a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1a2a40, #2f4f4f)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #00bfff",
      color: "#00bfff",
      boxShadow: "0 0 min(1vw, 8px) rgba(0, 191, 255, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #00bfff, #1e90ff)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(0, 191, 255, 0.5)",
    },
  },
  woodlandBrown: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(101, 67, 33, 0.5) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(85, 107, 47, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(139, 90, 43, 0.4) 0%, transparent 45%),\n               linear-gradient(145deg, #3d2817, #4a3728, #2d1f12)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(139, 90, 43, 0.7) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(85, 107, 47, 0.5) 0%, transparent 60%),\n                 linear-gradient(135deg, #654321, #8b5a2b, #6b4423, #4a3728, #3d2817)",
      color: "#d4a574",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(101, 67, 33, 0.5), inset 0 min(0.25vw, 2px) 0 rgba(139, 90, 43, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(139, 90, 43, 0.5) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(85, 107, 47, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #4a3728, #3d2817)",
      border: "min(0.25vw, 2px) solid #654321",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(139, 90, 43, 0.7) 0%, transparent 55%),\n                 linear-gradient(135deg, #654321, #8b5a2b, #6b4423, #4a3728, #3d2817)",
      color: "#d4a574",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(101, 67, 33, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #4a3728, #3d2817)",
      color: "#c9a87c",
      accentColor: "#8b5a2b",
      border: "min(0.25vw, 2px) solid #654321",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2d1f12, #3d2817)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.7)",
      border: "min(0.25vw, 2px) solid #8b5a2b",
      color: "#d4a574",
      boxShadow: "0 0 min(1vw, 8px) rgba(139, 90, 43, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #8b5a2b, #a0522d)",
      color: "#f5deb3",
      border: "min(0.25vw, 2px) solid #2d1f12",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(139, 90, 43, 0.5)",
    },
  },
  mysticalForest: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(138, 43, 226, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(139, 69, 19, 0.5) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(144, 238, 144, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #2f4f2f, #556b2f, #3d5941, #1c2b1f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(138, 43, 226, 0.6) 0%, transparent 60%),\n                 linear-gradient(135deg, #8a2be2, #556b2f, #8b4513, #9370db, #2f4f2f)",
      color: "#e6e6fa",
      textShadow: "1px 1px 2px rgba(139, 69, 19, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(138, 43, 226, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(144, 238, 144, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(138, 43, 226, 0.5) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(139, 69, 19, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #2f4f2f, #3d5941, #1c2b1f)",
      border: "min(0.25vw, 2px) solid #8a2be2",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(138, 43, 226, 0.4)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(138, 43, 226, 0.6) 0%, transparent 55%),\n                 linear-gradient(135deg, #8a2be2, #556b2f, #8b4513, #9370db, #2f4f2f)",
      color: "#e6e6fa",
      textShadow: "1px 1px 2px rgba(139, 69, 19, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(138, 43, 226, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #2f4f2f, #1c2b1f, #3d5941)",
      color: "#d8bfd8",
      accentColor: "#8a2be2",
      border: "min(0.25vw, 2px) solid #8a2be2",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c2b1f, #2f4f2f)",
    },
    stat: {
      background: "rgba(28, 43, 31, 0.7)",
      border: "min(0.25vw, 2px) solid #dda0dd",
      color: "#dda0dd",
      boxShadow: "0 0 min(1vw, 8px) rgba(221, 160, 221, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #dda0dd, #8a2be2)",
      color: "#1c2b1f",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(221, 160, 221, 0.5)",
    },
  },
  casinoGold: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(139, 117, 52, 0.2) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(85, 0, 0, 0.2) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(0, 64, 0, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #1a1a1a, #2a4a2a, #4a0000, #2a2a2a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(139, 117, 52, 0.4) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(85, 0, 0, 0.3) 0%, transparent 60%),\n                 linear-gradient(135deg, #8b7534, #2a4a2a, #4a0000, #6b5d1a, #2a2a2a)",
      color: "#c9a961",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(139, 117, 52, 0.3), inset 0 min(0.25vw, 2px) 0 rgba(201, 169, 97, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(139, 117, 52, 0.2) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(85, 0, 0, 0.2) 0%, transparent 50%),\n                 radial-gradient(circle at 50% 50%, rgba(0, 64, 0, 0.3) 0%, transparent 60%),\n                 linear-gradient(145deg, #1a1a1a, #2a4a2a, #4a0000)",
      border: "min(0.25vw, 2px) solid #8b7534",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.7)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(139, 117, 52, 0.4) 0%, transparent 55%),\n                 radial-gradient(circle at 70% 60%, rgba(85, 0, 0, 0.3) 0%, transparent 55%),\n                 linear-gradient(135deg, #8b7534, #2a4a2a, #4a0000, #6b5d1a, #2a2a2a)",
      color: "#c9a961",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(139, 117, 52, 0.1) 0%, transparent 50%),\n                 radial-gradient(circle at 60% 70%, rgba(85, 0, 0, 0.1) 0%, transparent 50%),\n                 linear-gradient(145deg, #1a1a1a, #2a4a2a)",
      color: "#c0c0c0",
      accentColor: "#8b7534",
      border: "min(0.25vw, 2px) solid #8b7534",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4a0000, #1a1a1a)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.8)",
      border: "min(0.25vw, 2px) solid #c9a961",
      color: "#c9a961",
      boxShadow: "0 0 min(1vw, 8px) rgba(201, 169, 97, 0.3)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c9a961, #8b7534)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(201, 169, 97, 0.4)",
    },
  },
  spectralPurple: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(221, 160, 221, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(138, 43, 226, 0.3) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(72, 61, 139, 0.4) 0%, transparent 45%),\n               linear-gradient(145deg, #1e1a2e, #2f2548, #0f0a1f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(221, 160, 221, 0.6) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(138, 43, 226, 0.5) 0%, transparent 60%),\n                 linear-gradient(135deg, #483d8b, #6a5acd, #dda0dd, #9370db, #4b0082)",
      color: "#f0e68c",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(221, 160, 221, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(221, 160, 221, 0.5), inset 0 min(0.25vw, 2px) 0 rgba(138, 43, 226, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(221, 160, 221, 0.5) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(138, 43, 226, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #2f2548, #1e1a2e)",
      border: "min(0.25vw, 2px) solid #dda0dd",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.7), 0 0 min(3vw, 20px) rgba(221, 160, 221, 0.4)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(221, 160, 221, 0.6) 0%, transparent 55%),\n                 linear-gradient(135deg, #483d8b, #6a5acd, #dda0dd, #9370db, #4b0082)",
      color: "#f0e68c",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 10px rgba(221, 160, 221, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(138, 43, 226, 0.3) 0%, transparent 50%),\n                 linear-gradient(145deg, #2f2548, #1e1a2e)",
      color: "#d8bfd8",
      accentColor: "#dda0dd",
      border: "min(0.25vw, 2px) solid #dda0dd",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0f0a1f, #1e1a2e)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.8)",
      border: "min(0.25vw, 2px) solid #dda0dd",
      color: "#dda0dd",
      boxShadow: "0 0 min(1vw, 8px) rgba(221, 160, 221, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #dda0dd, #ba55d3)",
      color: "#2f1b69",
      border: "min(0.25vw, 2px) solid #0f0a1f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(221, 160, 221, 0.6)",
    },
  },
  earthVolcanic: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(85, 107, 47, 0.3) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(139, 90, 67, 0.3) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(169, 34, 51, 0.1) 0%, transparent 45%),\n               linear-gradient(145deg, #5a5a5a, #7a8471, #8b5a43, #6b6b6b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(85, 107, 47, 0.4) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(139, 90, 67, 0.3) 0%, transparent 60%),\n                 linear-gradient(135deg, #5a5a5a, #7a8471, #8b5a43, #6b6b6b, #a93233)",
      color: "#f5f5dc",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(139, 90, 67, 0.3), inset 0 min(0.25vw, 2px) 0 rgba(230, 230, 230, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(85, 107, 47, 0.3) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(139, 90, 67, 0.3) 0%, transparent 50%),\n                 radial-gradient(circle at 50% 50%, rgba(169, 34, 51, 0.1) 0%, transparent 60%),\n                 linear-gradient(145deg, #5a5a5a, #7a8471, #8b5a43)",
      border: "min(0.25vw, 2px) solid #8b5a43",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(85, 107, 47, 0.4) 0%, transparent 55%),\n                 radial-gradient(circle at 70% 60%, rgba(139, 90, 67, 0.3) 0%, transparent 55%),\n                 linear-gradient(135deg, #5a5a5a, #7a8471, #8b5a43, #6b6b6b, #a93233)",
      color: "#f5f5dc",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(85, 107, 47, 0.2) 0%, transparent 50%),\n                 radial-gradient(circle at 60% 70%, rgba(139, 90, 67, 0.2) 0%, transparent 50%),\n                 linear-gradient(145deg, #5a5a5a, #7a8471)",
      color: "#d2b48c",
      accentColor: "#a93233",
      border: "min(0.25vw, 2px) solid #8b5a43",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #8b5a43, #5a5a5a)",
    },
    stat: {
      background: "rgba(47, 47, 47, 0.8)",
      border: "min(0.25vw, 2px) solid #b8860b",
      color: "#b8860b",
      boxShadow: "0 0 min(1vw, 8px) rgba(184, 134, 11, 0.3)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b8860b, #8b6914)",
      color: "#2f2f2f",
      border: "min(0.25vw, 2px) solid #2f2f2f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(184, 134, 11, 0.4)",
    },
  },
  deepSeaTeal: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(0, 128, 128, 0.4) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(0, 206, 209, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(72, 209, 204, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #003344, #004d40, #002b36)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(0, 206, 209, 0.4) 0%, transparent 60%),\n                 linear-gradient(135deg, #004d40, #006666, #20b2aa, #66cdaa)",
      color: "#e0f6ff",
      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.9)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(0, 206, 209, 0.3), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(0, 206, 209, 0.4) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(46, 139, 87, 0.3) 0%, transparent 50%),\n                 linear-gradient(145deg, #003333, #004d40)",
      border: "min(0.25vw, 2px) solid #20b2aa",
      boxShadow: "inset 0 4px 8px rgba(0, 206, 209, 0.3)",
    },
    typeSection: {
      background: "linear-gradient(135deg, #004d40, #006666, #20b2aa, #66cdaa)",
      color: "#e0f6ff",
      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.9)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #002b36, #004d40)",
      color: "#aeeeee",
      accentColor: "#20b2aa",
      border: "2px solid #20b2aa",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #003333, #004d40)",
    },
    stat: {
      background: "rgba(0, 51, 51, 0.8)",
      border: "2px solid #20b2aa",
      color: "#e0f6ff",
      boxShadow: "0 0 8px rgba(0, 206, 209, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #004d40, #006666)",
      color: "#e0f6ff",
      border: "min(0.25vw, 2px) solid #20b2aa",
      boxShadow: "0 0 10px rgba(0, 206, 209, 0.4)",
    },
  },
  steelTech: {
    background: "linear-gradient(145deg, #404040, #333333, #2a2a2a)",
    header: {
      background:
        "linear-gradient(135deg, #c5c5c5, #b0b0b0, #9d9d9d, #c5c5c5, #808080)",
      color: "#1a1a1a",
      textShadow: "1px 1px 2px rgba(197, 197, 197, 0.8)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(197, 197, 197, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(255, 255, 255, 0.3)",
    },
    imageArea: {
      background: "linear-gradient(145deg, #555555, #404040)",
      border: "min(0.25vw, 2px) solid #c5c5c5",
      boxShadow: "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.5)",
    },
    typeSection: {
      background:
        "linear-gradient(135deg, #c5c5c5, #b0b0b0, #9d9d9d, #c5c5c5, #808080)",
      color: "#1a1a1a",
      textShadow: "1px 1px 2px rgba(197, 197, 197, 0.8)",
    },
    flavorText: {
      background: "linear-gradient(145deg, #404040, #333333)",
      color: "#e0e0e0",
      accentColor: "#c5c5c5",
      border: "min(0.25vw, 2px) solid #c5c5c5",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #333333, #4a4a4a)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.8)",
      border: "min(0.25vw, 2px) solid #4682b4",
      color: "#4682b4",
      boxShadow: "0 0 min(1vw, 8px) rgba(70, 130, 180, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4682b4, #5a9fd4)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #1a1a1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(70, 130, 180, 0.5)",
    },
  },
  graveyardGreen: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(85, 107, 47, 0.5) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(47, 79, 79, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(105, 105, 105, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #1a1f1a, #0f120f, #1f241f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(85, 107, 47, 0.6) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(105, 105, 105, 0.5) 0%, transparent 60%),\n                 linear-gradient(135deg, #3d4d3d, #556b2f, #696969, #2f4f4f, #1f2f1f)",
      color: "#c8d4b8",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(85, 107, 47, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(85, 107, 47, 0.2)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(85, 107, 47, 0.5) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(47, 79, 79, 0.4) 0%, transparent 50%),\n                 linear-gradient(145deg, #1f241f, #0f120f)",
      border: "min(0.25vw, 2px) solid #556b2f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.7), 0 0 min(2vw, 15px) rgba(85, 107, 47, 0.2)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(85, 107, 47, 0.6) 0%, transparent 55%),\n                 linear-gradient(135deg, #3d4d3d, #556b2f, #696969, #2f4f4f, #1f2f1f)",
      color: "#c8d4b8",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(85, 107, 47, 0.3) 0%, transparent 50%),\n                 linear-gradient(145deg, #1f241f, #0f120f)",
      color: "#a8b89a",
      accentColor: "#556b2f",
      border: "min(0.25vw, 2px) solid #556b2f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0f120f, #1f2f1f)",
    },
    stat: {
      background: "rgba(0, 0, 0, 0.8)",
      border: "min(0.25vw, 2px) solid #556b2f",
      color: "#98d98e",
      boxShadow: "0 0 min(1vw, 8px) rgba(85, 107, 47, 0.4)",
    },
    rarity: {
      background: "linear-gradient(135deg, #556b2f, #6b8e23)",
      color: "#e8f0e0",
      border: "min(0.25vw, 2px) solid #0f120f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(107, 142, 35, 0.5)",
    },
  },
  treasureHoard: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(184, 134, 11, 0.3) 0%, transparent 50%),\n               radial-gradient(circle at 80% 70%, rgba(139, 69, 19, 0.4) 0%, transparent 40%),\n               radial-gradient(circle at 60% 10%, rgba(107, 142, 35, 0.3) 0%, transparent 45%),\n               linear-gradient(145deg, #3a3a3a, #4a4a3a, #2d2d2d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(218, 165, 32, 0.6) 0%, transparent 60%),\n                 radial-gradient(circle at 75% 50%, rgba(139, 69, 19, 0.5) 0%, transparent 60%),\n                 linear-gradient(135deg, #6b6b4a, #8b7534, #a0826d, #6b8e23, #4a4a3a)",
      color: "#f5deb3",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 8px rgba(218, 165, 32, 0.4)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(218, 165, 32, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(245, 222, 179, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(218, 165, 32, 0.4) 0%, transparent 45%),\n                 radial-gradient(circle at 70% 80%, rgba(139, 69, 19, 0.4) 0%, transparent 50%),\n                 radial-gradient(circle at 50% 50%, rgba(107, 142, 35, 0.2) 0%, transparent 60%),\n                 linear-gradient(145deg, #4a4a3a, #3a3a3a)",
      border: "min(0.25vw, 2px) solid #8b7534",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(218, 165, 32, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(218, 165, 32, 0.6) 0%, transparent 55%),\n                 radial-gradient(circle at 70% 60%, rgba(139, 69, 19, 0.5) 0%, transparent 55%),\n                 linear-gradient(135deg, #6b6b4a, #8b7534, #a0826d, #6b8e23, #4a4a3a)",
      color: "#f5deb3",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 8px rgba(218, 165, 32, 0.4)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(184, 134, 11, 0.3) 0%, transparent 50%),\n                 radial-gradient(circle at 60% 70%, rgba(139, 69, 19, 0.3) 0%, transparent 50%),\n                 linear-gradient(145deg, #4a4a3a, #3a3a3a)",
      color: "#d2b48c",
      accentColor: "#daa520",
      border: "min(0.25vw, 2px) solid #8b7534",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2d2d2d, #3a3a3a)",
    },
    stat: {
      background: "rgba(45, 45, 45, 0.8)",
      border: "min(0.25vw, 2px) solid #daa520",
      color: "#ffd700",
      boxShadow: "0 0 min(1vw, 8px) rgba(218, 165, 32, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #daa520, #b8860b)",
      color: "#2d2416",
      border: "min(0.25vw, 2px) solid #2d2d2d",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(218, 165, 32, 0.6)",
    },
  },
  aboleth: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(77, 194, 188, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(34, 102, 105, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(121, 235, 230, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #375f34, #226669, #66a454)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(77, 194, 188, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(102, 164, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4dc2bc, #66a454, #79ebe6, #4dc2bc, #226669)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(77, 194, 188, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(77, 194, 188, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(121, 235, 230, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(77, 194, 188, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(34, 102, 105, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #375f34, #226669, #66a454)",
      border: "min(0.25vw, 2px) solid #4dc2bc",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(77, 194, 188, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(77, 194, 188, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(102, 164, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4dc2bc, #66a454, #79ebe6, #4dc2bc, #226669)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(77, 194, 188, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(77, 194, 188, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(102, 164, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #375f34, #226669)",
      color: "#bccfc4",
      accentColor: "#4dc2bc",
      border: "min(0.25vw, 2px) solid #4dc2bc",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #226669, #375f34)",
    },
    stat: {
      background: "rgba(34, 102, 105, 0.8)",
      border: "min(0.25vw, 2px) solid #4dc2bc",
      color: "#79ebe6",
      boxShadow: "0 0 min(1vw, 8px) rgba(77, 194, 188, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4dc2bc, #66a454)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #226669",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(77, 194, 188, 0.6)",
    },
  },
  acolyte: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(76, 178, 178, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(12, 28, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(162, 215, 215, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #384d4c, #0c1c1c, #5d7f4c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(76, 178, 178, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(93, 127, 76, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4cb2b2, #5d7f4c, #a2d7d7, #4cb2b2, #0c1c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 178, 178, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(76, 178, 178, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(162, 215, 215, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(76, 178, 178, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(12, 28, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #384d4c, #0c1c1c, #5d7f4c)",
      border: "min(0.25vw, 2px) solid #4cb2b2",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(76, 178, 178, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(76, 178, 178, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(93, 127, 76, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4cb2b2, #5d7f4c, #a2d7d7, #4cb2b2, #0c1c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 178, 178, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(76, 178, 178, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(93, 127, 76, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #384d4c, #0c1c1c)",
      color: "#87abae",
      accentColor: "#4cb2b2",
      border: "min(0.25vw, 2px) solid #4cb2b2",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0c1c1c, #384d4c)",
    },
    stat: {
      background: "rgba(12, 28, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #4cb2b2",
      color: "#a2d7d7",
      boxShadow: "0 0 min(1vw, 8px) rgba(76, 178, 178, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4cb2b2, #5d7f4c)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #0c1c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(76, 178, 178, 0.6)",
    },
  },
  acolyte_2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(180, 109, 89, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(97, 61, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(213, 174, 163, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #433228, #613d1c, #8b4694)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(180, 109, 89, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(139, 70, 148, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b46d59, #8b4694, #d5aea3, #b46d59, #613d1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 109, 89, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(180, 109, 89, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(213, 174, 163, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(180, 109, 89, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(97, 61, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #433228, #613d1c, #8b4694)",
      border: "min(0.25vw, 2px) solid #b46d59",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(180, 109, 89, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(180, 109, 89, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(139, 70, 148, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b46d59, #8b4694, #d5aea3, #b46d59, #613d1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 109, 89, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(180, 109, 89, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(139, 70, 148, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #433228, #613d1c)",
      color: "#693c2f",
      accentColor: "#b46d59",
      border: "min(0.25vw, 2px) solid #b46d59",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #613d1c, #433228)",
    },
    stat: {
      background: "rgba(97, 61, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #b46d59",
      color: "#d5aea3",
      boxShadow: "0 0 min(1vw, 8px) rgba(180, 109, 89, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b46d59, #8b4694)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #613d1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(180, 109, 89, 0.6)",
    },
  },
  adultBronzeDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(94, 167, 219, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(108, 68, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(127, 200, 230, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #425734, #6c441c, #6f936d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(94, 167, 219, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(111, 147, 109, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5ea7db, #6f936d, #7fc8e6, #5ea7db, #6c441c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(94, 167, 219, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(94, 167, 219, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(127, 200, 230, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(94, 167, 219, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(108, 68, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #425734, #6c441c, #6f936d)",
      border: "min(0.25vw, 2px) solid #5ea7db",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(94, 167, 219, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(94, 167, 219, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(111, 147, 109, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5ea7db, #6f936d, #7fc8e6, #5ea7db, #6c441c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(94, 167, 219, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(94, 167, 219, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(111, 147, 109, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #425734, #6c441c)",
      color: "#9ccfb3",
      accentColor: "#5ea7db",
      border: "min(0.25vw, 2px) solid #5ea7db",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6c441c, #425734)",
    },
    stat: {
      background: "rgba(108, 68, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #5ea7db",
      color: "#7fc8e6",
      boxShadow: "0 0 min(1vw, 8px) rgba(94, 167, 219, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5ea7db, #6f936d)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #6c441c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(94, 167, 219, 0.6)",
    },
  },
  adultCopperDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(154, 96, 58, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(135, 99, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(199, 154, 101, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4f443a, #876324, #a58a50)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(154, 96, 58, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(165, 138, 80, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #9a603a, #a58a50, #c79a65, #9a603a, #876324)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(154, 96, 58, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(154, 96, 58, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(199, 154, 101, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(154, 96, 58, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(135, 99, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4f443a, #876324, #a58a50)",
      border: "min(0.25vw, 2px) solid #9a603a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(154, 96, 58, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(154, 96, 58, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(165, 138, 80, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #9a603a, #a58a50, #c79a65, #9a603a, #876324)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(154, 96, 58, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(154, 96, 58, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(165, 138, 80, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4f443a, #876324)",
      color: "#a6a68a",
      accentColor: "#9a603a",
      border: "min(0.25vw, 2px) solid #9a603a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #876324, #4f443a)",
    },
    stat: {
      background: "rgba(135, 99, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #9a603a",
      color: "#c79a65",
      boxShadow: "0 0 min(1vw, 8px) rgba(154, 96, 58, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #9a603a, #a58a50)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #876324",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(154, 96, 58, 0.6)",
    },
  },
  adultGoldDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(194, 158, 64, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(102, 76, 30, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(240, 219, 100, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4c3c24, #664c1e, #998251)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(194, 158, 64, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(153, 130, 81, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c29e40, #998251, #f0db64, #c29e40, #664c1e)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(194, 158, 64, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(194, 158, 64, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(240, 219, 100, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(194, 158, 64, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(102, 76, 30, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4c3c24, #664c1e, #998251)",
      border: "min(0.25vw, 2px) solid #c29e40",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(194, 158, 64, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(194, 158, 64, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(153, 130, 81, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c29e40, #998251, #f0db64, #c29e40, #664c1e)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(194, 158, 64, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(194, 158, 64, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(153, 130, 81, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4c3c24, #664c1e)",
      color: "#7ab47e",
      accentColor: "#c29e40",
      border: "min(0.25vw, 2px) solid #c29e40",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #664c1e, #4c3c24)",
    },
    stat: {
      background: "rgba(102, 76, 30, 0.8)",
      border: "min(0.25vw, 2px) solid #c29e40",
      color: "#f0db64",
      boxShadow: "0 0 min(1vw, 8px) rgba(194, 158, 64, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c29e40, #998251)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #664c1e",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(194, 158, 64, 0.6)",
    },
  },
  adultGreenDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(147, 151, 103, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(76, 78, 53, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(199, 201, 176, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b6339, #4c4e35, #6c878e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(147, 151, 103, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 135, 142, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #939767, #6c878e, #c7c9b0, #939767, #4c4e35)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(147, 151, 103, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(147, 151, 103, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(199, 201, 176, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(147, 151, 103, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(76, 78, 53, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b6339, #4c4e35, #6c878e)",
      border: "min(0.25vw, 2px) solid #939767",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(147, 151, 103, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(147, 151, 103, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 135, 142, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #939767, #6c878e, #c7c9b0, #939767, #4c4e35)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(147, 151, 103, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(147, 151, 103, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 135, 142, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b6339, #4c4e35)",
      color: "#c4c6ac",
      accentColor: "#939767",
      border: "min(0.25vw, 2px) solid #939767",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4c4e35, #4b6339)",
    },
    stat: {
      background: "rgba(76, 78, 53, 0.8)",
      border: "min(0.25vw, 2px) solid #939767",
      color: "#c7c9b0",
      boxShadow: "0 0 min(1vw, 8px) rgba(147, 151, 103, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #939767, #6c878e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #4c4e35",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(147, 151, 103, 0.6)",
    },
  },
  adultGreenDragon2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(102, 139, 183, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(50, 70, 32, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(140, 179, 212, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #40572b, #324620, #5c7c9c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(102, 139, 183, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(92, 124, 156, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #668bb7, #5c7c9c, #8cb3d4, #668bb7, #324620)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(102, 139, 183, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(102, 139, 183, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(140, 179, 212, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(102, 139, 183, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(50, 70, 32, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #40572b, #324620, #5c7c9c)",
      border: "min(0.25vw, 2px) solid #668bb7",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(102, 139, 183, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(102, 139, 183, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(92, 124, 156, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #668bb7, #5c7c9c, #8cb3d4, #668bb7, #324620)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(102, 139, 183, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(102, 139, 183, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(92, 124, 156, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #40572b, #324620)",
      color: "#a5c1ce",
      accentColor: "#668bb7",
      border: "min(0.25vw, 2px) solid #668bb7",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #324620, #40572b)",
    },
    stat: {
      background: "rgba(50, 70, 32, 0.8)",
      border: "min(0.25vw, 2px) solid #668bb7",
      color: "#8cb3d4",
      boxShadow: "0 0 min(1vw, 8px) rgba(102, 139, 183, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #668bb7, #5c7c9c)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #324620",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(102, 139, 183, 0.6)",
    },
  },
  adultSilverDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(106, 142, 184, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(41, 63, 90, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(165, 199, 225, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #344b71, #293f5a, #6080a7)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(106, 142, 184, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(96, 128, 167, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #6a8eb8, #6080a7, #a5c7e1, #6a8eb8, #293f5a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(106, 142, 184, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(106, 142, 184, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(165, 199, 225, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(106, 142, 184, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(41, 63, 90, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #344b71, #293f5a, #6080a7)",
      border: "min(0.25vw, 2px) solid #6a8eb8",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(106, 142, 184, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(106, 142, 184, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(96, 128, 167, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #6a8eb8, #6080a7, #a5c7e1, #6a8eb8, #293f5a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(106, 142, 184, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(106, 142, 184, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(96, 128, 167, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #344b71, #293f5a)",
      color: "#9eb3cc",
      accentColor: "#6a8eb8",
      border: "min(0.25vw, 2px) solid #6a8eb8",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #293f5a, #344b71)",
    },
    stat: {
      background: "rgba(41, 63, 90, 0.8)",
      border: "min(0.25vw, 2px) solid #6a8eb8",
      color: "#a5c7e1",
      boxShadow: "0 0 min(1vw, 8px) rgba(106, 142, 184, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #6a8eb8, #6080a7)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #293f5a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(106, 142, 184, 0.6)",
    },
  },
  airElemental: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(76, 167, 176, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(34, 88, 97, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(148, 213, 213, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #394a58, #225861, #56939a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(76, 167, 176, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(86, 147, 154, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4ca7b0, #56939a, #94d5d5, #4ca7b0, #225861)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 167, 176, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(76, 167, 176, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(148, 213, 213, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(76, 167, 176, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(34, 88, 97, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #394a58, #225861, #56939a)",
      border: "min(0.25vw, 2px) solid #4ca7b0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(76, 167, 176, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(76, 167, 176, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(86, 147, 154, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4ca7b0, #56939a, #94d5d5, #4ca7b0, #225861)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 167, 176, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(76, 167, 176, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(86, 147, 154, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #394a58, #225861)",
      color: "#9fbec0",
      accentColor: "#4ca7b0",
      border: "min(0.25vw, 2px) solid #4ca7b0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #225861, #394a58)",
    },
    stat: {
      background: "rgba(34, 88, 97, 0.8)",
      border: "min(0.25vw, 2px) solid #4ca7b0",
      color: "#94d5d5",
      boxShadow: "0 0 min(1vw, 8px) rgba(76, 167, 176, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4ca7b0, #56939a)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #225861",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(76, 167, 176, 0.6)",
    },
  },
  ancientBlackDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(192, 198, 129, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(60, 77, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(210, 221, 155, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #41532e, #3c4d24, #a46458)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(192, 198, 129, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(164, 100, 88, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c0c681, #a46458, #d2dd9b, #c0c681, #3c4d24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(192, 198, 129, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(192, 198, 129, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(210, 221, 155, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(192, 198, 129, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(60, 77, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #41532e, #3c4d24, #a46458)",
      border: "min(0.25vw, 2px) solid #c0c681",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(192, 198, 129, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(192, 198, 129, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(164, 100, 88, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c0c681, #a46458, #d2dd9b, #c0c681, #3c4d24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(192, 198, 129, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(192, 198, 129, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(164, 100, 88, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #41532e, #3c4d24)",
      color: "#b9dbcf",
      accentColor: "#c0c681",
      border: "min(0.25vw, 2px) solid #c0c681",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3c4d24, #41532e)",
    },
    stat: {
      background: "rgba(60, 77, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #c0c681",
      color: "#d2dd9b",
      boxShadow: "0 0 min(1vw, 8px) rgba(192, 198, 129, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c0c681, #a46458)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #3c4d24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(192, 198, 129, 0.6)",
    },
  },
  ancientBrassDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(212, 180, 60, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(94, 69, 29, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(248, 207, 130, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3f522d, #5e451d, #ac7162)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(212, 180, 60, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(172, 113, 98, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d4b43c, #ac7162, #f8cf82, #d4b43c, #5e451d)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(212, 180, 60, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(212, 180, 60, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(248, 207, 130, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(212, 180, 60, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(94, 69, 29, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3f522d, #5e451d, #ac7162)",
      border: "min(0.25vw, 2px) solid #d4b43c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(212, 180, 60, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(212, 180, 60, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(172, 113, 98, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d4b43c, #ac7162, #f8cf82, #d4b43c, #5e451d)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(212, 180, 60, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(212, 180, 60, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(172, 113, 98, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3f522d, #5e451d)",
      color: "#d5ae9e",
      accentColor: "#d4b43c",
      border: "min(0.25vw, 2px) solid #d4b43c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5e451d, #3f522d)",
    },
    stat: {
      background: "rgba(94, 69, 29, 0.8)",
      border: "min(0.25vw, 2px) solid #d4b43c",
      color: "#f8cf82",
      boxShadow: "0 0 min(1vw, 8px) rgba(212, 180, 60, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d4b43c, #ac7162)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5e451d",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(212, 180, 60, 0.6)",
    },
  },
  ancientBronzeDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(221, 142, 76, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(92, 61, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(250, 221, 143, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #514d39, #5c3d2c, #9f6f58)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(221, 142, 76, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(159, 111, 88, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #dd8e4c, #9f6f58, #fadd8f, #dd8e4c, #5c3d2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(221, 142, 76, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(221, 142, 76, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(250, 221, 143, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(221, 142, 76, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(92, 61, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #514d39, #5c3d2c, #9f6f58)",
      border: "min(0.25vw, 2px) solid #dd8e4c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(221, 142, 76, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(221, 142, 76, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(159, 111, 88, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #dd8e4c, #9f6f58, #fadd8f, #dd8e4c, #5c3d2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(221, 142, 76, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(221, 142, 76, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(159, 111, 88, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #514d39, #5c3d2c)",
      color: "#cebe98",
      accentColor: "#dd8e4c",
      border: "min(0.25vw, 2px) solid #dd8e4c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5c3d2c, #514d39)",
    },
    stat: {
      background: "rgba(92, 61, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #dd8e4c",
      color: "#fadd8f",
      boxShadow: "0 0 min(1vw, 8px) rgba(221, 142, 76, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #dd8e4c, #9f6f58)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5c3d2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(221, 142, 76, 0.6)",
    },
  },
  ancientCopperDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(165, 131, 43, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(120, 44, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(242, 217, 155, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5e422f, #782c14, #b19062)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(165, 131, 43, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(177, 144, 98, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #a5832b, #b19062, #f2d99b, #a5832b, #782c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(165, 131, 43, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(165, 131, 43, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(242, 217, 155, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(165, 131, 43, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(120, 44, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5e422f, #782c14, #b19062)",
      border: "min(0.25vw, 2px) solid #a5832b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(165, 131, 43, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(165, 131, 43, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(177, 144, 98, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #a5832b, #b19062, #f2d99b, #a5832b, #782c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(165, 131, 43, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(165, 131, 43, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(177, 144, 98, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5e422f, #782c14)",
      color: "#c5a67d",
      accentColor: "#a5832b",
      border: "min(0.25vw, 2px) solid #a5832b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #782c14, #5e422f)",
    },
    stat: {
      background: "rgba(120, 44, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #a5832b",
      color: "#f2d99b",
      boxShadow: "0 0 min(1vw, 8px) rgba(165, 131, 43, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #a5832b, #b19062)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #782c14",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(165, 131, 43, 0.6)",
    },
  },
  ancientGoldDragon2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(190, 124, 59, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(109, 55, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(246, 201, 136, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3b3e48, #6d3714, #9d7966)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(190, 124, 59, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(157, 121, 102, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #be7c3b, #9d7966, #f6c988, #be7c3b, #6d3714)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(190, 124, 59, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(190, 124, 59, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(246, 201, 136, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(190, 124, 59, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(109, 55, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3b3e48, #6d3714, #9d7966)",
      border: "min(0.25vw, 2px) solid #be7c3b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(190, 124, 59, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(190, 124, 59, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(157, 121, 102, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #be7c3b, #9d7966, #f6c988, #be7c3b, #6d3714)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(190, 124, 59, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(190, 124, 59, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(157, 121, 102, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3b3e48, #6d3714)",
      color: "#a4a79d",
      accentColor: "#be7c3b",
      border: "min(0.25vw, 2px) solid #be7c3b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6d3714, #3b3e48)",
    },
    stat: {
      background: "rgba(109, 55, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #be7c3b",
      color: "#f6c988",
      boxShadow: "0 0 min(1vw, 8px) rgba(190, 124, 59, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #be7c3b, #9d7966)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #6d3714",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(190, 124, 59, 0.6)",
    },
  },
  ancientGoldDragon3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(199, 117, 47, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(112, 67, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(248, 228, 134, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4c3d29, #70430c, #a47457)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(199, 117, 47, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(164, 116, 87, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c7752f, #a47457, #f8e486, #c7752f, #70430c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(199, 117, 47, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(199, 117, 47, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(248, 228, 134, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(199, 117, 47, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(112, 67, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4c3d29, #70430c, #a47457)",
      border: "min(0.25vw, 2px) solid #c7752f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(199, 117, 47, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(199, 117, 47, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(164, 116, 87, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c7752f, #a47457, #f8e486, #c7752f, #70430c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(199, 117, 47, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(199, 117, 47, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(164, 116, 87, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4c3d29, #70430c)",
      color: "#91acb3",
      accentColor: "#c7752f",
      border: "min(0.25vw, 2px) solid #c7752f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #70430c, #4c3d29)",
    },
    stat: {
      background: "rgba(112, 67, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #c7752f",
      color: "#f8e486",
      boxShadow: "0 0 min(1vw, 8px) rgba(199, 117, 47, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c7752f, #a47457)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #70430c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(199, 117, 47, 0.6)",
    },
  },
  ancientGreenDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(184, 86, 84, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(60, 92, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(248, 235, 179, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3a4931, #3c5c1c, #a4895c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(184, 86, 84, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(164, 137, 92, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b85654, #a4895c, #f8ebb3, #b85654, #3c5c1c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(184, 86, 84, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(184, 86, 84, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(248, 235, 179, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(184, 86, 84, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(60, 92, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3a4931, #3c5c1c, #a4895c)",
      border: "min(0.25vw, 2px) solid #b85654",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(184, 86, 84, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(184, 86, 84, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(164, 137, 92, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b85654, #a4895c, #f8ebb3, #b85654, #3c5c1c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(184, 86, 84, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(184, 86, 84, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(164, 137, 92, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3a4931, #3c5c1c)",
      color: "#bfc09b",
      accentColor: "#b85654",
      border: "min(0.25vw, 2px) solid #b85654",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3c5c1c, #3a4931)",
    },
    stat: {
      background: "rgba(60, 92, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #b85654",
      color: "#f8ebb3",
      boxShadow: "0 0 min(1vw, 8px) rgba(184, 86, 84, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b85654, #a4895c)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #3c5c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(184, 86, 84, 0.6)",
    },
  },
  ancientRedDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(187, 47, 43, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(114, 27, 27, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(199, 157, 122, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #334650, #721b1b, #936952)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(187, 47, 43, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(147, 105, 82, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #bb2f2b, #936952, #c79d7a, #bb2f2b, #721b1b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(187, 47, 43, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(187, 47, 43, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(199, 157, 122, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(187, 47, 43, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(114, 27, 27, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #334650, #721b1b, #936952)",
      border: "min(0.25vw, 2px) solid #bb2f2b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(187, 47, 43, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(187, 47, 43, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(147, 105, 82, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #bb2f2b, #936952, #c79d7a, #bb2f2b, #721b1b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(187, 47, 43, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(187, 47, 43, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(147, 105, 82, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #334650, #721b1b)",
      color: "#a7ad8e",
      accentColor: "#bb2f2b",
      border: "min(0.25vw, 2px) solid #bb2f2b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #721b1b, #334650)",
    },
    stat: {
      background: "rgba(114, 27, 27, 0.8)",
      border: "min(0.25vw, 2px) solid #bb2f2b",
      color: "#c79d7a",
      boxShadow: "0 0 min(1vw, 8px) rgba(187, 47, 43, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #bb2f2b, #936952)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #721b1b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(187, 47, 43, 0.6)",
    },
  },
  ancientSilverDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(87, 148, 179, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(30, 58, 87, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(136, 189, 198, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #394f3d, #1e3a57, #5383a3)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(87, 148, 179, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(83, 131, 163, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5794b3, #5383a3, #88bdc6, #5794b3, #1e3a57)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(87, 148, 179, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(87, 148, 179, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(136, 189, 198, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(87, 148, 179, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(30, 58, 87, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #394f3d, #1e3a57, #5383a3)",
      border: "min(0.25vw, 2px) solid #5794b3",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(87, 148, 179, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(87, 148, 179, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(83, 131, 163, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5794b3, #5383a3, #88bdc6, #5794b3, #1e3a57)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(87, 148, 179, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(87, 148, 179, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(83, 131, 163, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #394f3d, #1e3a57)",
      color: "#b5c9cd",
      accentColor: "#5794b3",
      border: "min(0.25vw, 2px) solid #5794b3",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1e3a57, #394f3d)",
    },
    stat: {
      background: "rgba(30, 58, 87, 0.8)",
      border: "min(0.25vw, 2px) solid #5794b3",
      color: "#88bdc6",
      boxShadow: "0 0 min(1vw, 8px) rgba(87, 148, 179, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5794b3, #5383a3)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1e3a57",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(87, 148, 179, 0.6)",
    },
  },
  androsphinx: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(244, 156, 113, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(123, 46, 9, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(247, 207, 150, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #573a31, #7b2e09, #996f63)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(244, 156, 113, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(153, 111, 99, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f49c71, #996f63, #f7cf96, #f49c71, #7b2e09)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(244, 156, 113, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(244, 156, 113, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(247, 207, 150, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(244, 156, 113, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(123, 46, 9, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #573a31, #7b2e09, #996f63)",
      border: "min(0.25vw, 2px) solid #f49c71",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(244, 156, 113, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(244, 156, 113, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(153, 111, 99, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f49c71, #996f63, #f7cf96, #f49c71, #7b2e09)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(244, 156, 113, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(244, 156, 113, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(153, 111, 99, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #573a31, #7b2e09)",
      color: "#c6aa86",
      accentColor: "#f49c71",
      border: "min(0.25vw, 2px) solid #f49c71",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #7b2e09, #573a31)",
    },
    stat: {
      background: "rgba(123, 46, 9, 0.8)",
      border: "min(0.25vw, 2px) solid #f49c71",
      color: "#f7cf96",
      boxShadow: "0 0 min(1vw, 8px) rgba(244, 156, 113, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f49c71, #996f63)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #7b2e09",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(244, 156, 113, 0.6)",
    },
  },
  animatedArmor: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(101, 129, 54, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(75, 94, 35, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(195, 215, 161, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3f4d37, #4b5e23, #5f8084)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(101, 129, 54, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(95, 128, 132, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #658136, #5f8084, #c3d7a1, #658136, #4b5e23)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(101, 129, 54, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(101, 129, 54, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(195, 215, 161, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(101, 129, 54, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(75, 94, 35, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3f4d37, #4b5e23, #5f8084)",
      border: "min(0.25vw, 2px) solid #658136",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(101, 129, 54, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(101, 129, 54, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(95, 128, 132, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #658136, #5f8084, #c3d7a1, #658136, #4b5e23)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(101, 129, 54, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(101, 129, 54, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(95, 128, 132, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3f4d37, #4b5e23)",
      color: "#b9d8d3",
      accentColor: "#658136",
      border: "min(0.25vw, 2px) solid #658136",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4b5e23, #3f4d37)",
    },
    stat: {
      background: "rgba(75, 94, 35, 0.8)",
      border: "min(0.25vw, 2px) solid #658136",
      color: "#c3d7a1",
      boxShadow: "0 0 min(1vw, 8px) rgba(101, 129, 54, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #658136, #5f8084)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #4b5e23",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(101, 129, 54, 0.6)",
    },
  },
  awakenedShrub: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(75, 121, 178, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(20, 104, 112, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(100, 156, 220, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2c4257, #146870, #517e75)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(75, 121, 178, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(81, 126, 117, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4b79b2, #517e75, #649cdc, #4b79b2, #146870)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(75, 121, 178, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(75, 121, 178, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(100, 156, 220, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(75, 121, 178, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(20, 104, 112, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2c4257, #146870, #517e75)",
      border: "min(0.25vw, 2px) solid #4b79b2",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(75, 121, 178, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(75, 121, 178, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(81, 126, 117, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4b79b2, #517e75, #649cdc, #4b79b2, #146870)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(75, 121, 178, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(75, 121, 178, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(81, 126, 117, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2c4257, #146870)",
      color: "#bea298",
      accentColor: "#4b79b2",
      border: "min(0.25vw, 2px) solid #4b79b2",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #146870, #2c4257)",
    },
    stat: {
      background: "rgba(20, 104, 112, 0.8)",
      border: "min(0.25vw, 2px) solid #4b79b2",
      color: "#649cdc",
      boxShadow: "0 0 min(1vw, 8px) rgba(75, 121, 178, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4b79b2, #517e75)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #146870",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(75, 121, 178, 0.6)",
    },
  },
  azer: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(247, 110, 71, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(110, 36, 18, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(252, 160, 132, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #57302e, #6e2412, #985a59)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(247, 110, 71, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(152, 90, 89, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f76e47, #985a59, #fca084, #f76e47, #6e2412)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(247, 110, 71, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(247, 110, 71, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(252, 160, 132, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(247, 110, 71, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(110, 36, 18, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #57302e, #6e2412, #985a59)",
      border: "min(0.25vw, 2px) solid #f76e47",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(247, 110, 71, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(247, 110, 71, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(152, 90, 89, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f76e47, #985a59, #fca084, #f76e47, #6e2412)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(247, 110, 71, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(247, 110, 71, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(152, 90, 89, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #57302e, #6e2412)",
      color: "#90a77c",
      accentColor: "#f76e47",
      border: "min(0.25vw, 2px) solid #f76e47",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6e2412, #57302e)",
    },
    stat: {
      background: "rgba(110, 36, 18, 0.8)",
      border: "min(0.25vw, 2px) solid #f76e47",
      color: "#fca084",
      boxShadow: "0 0 min(1vw, 8px) rgba(247, 110, 71, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f76e47, #985a59)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #6e2412",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(247, 110, 71, 0.6)",
    },
  },
  baboon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(188, 130, 89, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(94, 61, 38, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(156, 220, 244, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #39462f, #5e3d26, #84a45c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(188, 130, 89, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(132, 164, 92, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #bc8259, #84a45c, #9cdcf4, #bc8259, #5e3d26)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(188, 130, 89, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(188, 130, 89, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(156, 220, 244, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(188, 130, 89, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(94, 61, 38, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #39462f, #5e3d26, #84a45c)",
      border: "min(0.25vw, 2px) solid #bc8259",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(188, 130, 89, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(188, 130, 89, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(132, 164, 92, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #bc8259, #84a45c, #9cdcf4, #bc8259, #5e3d26)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(188, 130, 89, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(188, 130, 89, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(132, 164, 92, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #39462f, #5e3d26)",
      color: "#bcdac2",
      accentColor: "#bc8259",
      border: "min(0.25vw, 2px) solid #bc8259",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5e3d26, #39462f)",
    },
    stat: {
      background: "rgba(94, 61, 38, 0.8)",
      border: "min(0.25vw, 2px) solid #bc8259",
      color: "#9cdcf4",
      boxShadow: "0 0 min(1vw, 8px) rgba(188, 130, 89, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #bc8259, #84a45c)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5e3d26",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(188, 130, 89, 0.6)",
    },
  },
  baboon2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(180, 196, 132, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(68, 92, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(233, 228, 195, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4f5f32, #445c24, #889f60)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(180, 196, 132, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(136, 159, 96, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b4c484, #889f60, #e9e4c3, #b4c484, #445c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 196, 132, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(180, 196, 132, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(233, 228, 195, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(180, 196, 132, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(68, 92, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4f5f32, #445c24, #889f60)",
      border: "min(0.25vw, 2px) solid #b4c484",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(180, 196, 132, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(180, 196, 132, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(136, 159, 96, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b4c484, #889f60, #e9e4c3, #b4c484, #445c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(180, 196, 132, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(180, 196, 132, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(136, 159, 96, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4f5f32, #445c24)",
      color: "#c4d0a4",
      accentColor: "#b4c484",
      border: "min(0.25vw, 2px) solid #b4c484",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #445c24, #4f5f32)",
    },
    stat: {
      background: "rgba(68, 92, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #b4c484",
      color: "#e9e4c3",
      boxShadow: "0 0 min(1vw, 8px) rgba(180, 196, 132, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b4c484, #889f60)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #445c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(180, 196, 132, 0.6)",
    },
  },
  balor: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(208, 90, 46, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(88, 30, 18, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(249, 209, 91, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #52683a, #581e12, #9e6255)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(208, 90, 46, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(158, 98, 85, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d05a2e, #9e6255, #f9d15b, #d05a2e, #581e12)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(208, 90, 46, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(208, 90, 46, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(249, 209, 91, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(208, 90, 46, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(88, 30, 18, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #52683a, #581e12, #9e6255)",
      border: "min(0.25vw, 2px) solid #d05a2e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(208, 90, 46, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(208, 90, 46, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(158, 98, 85, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d05a2e, #9e6255, #f9d15b, #d05a2e, #581e12)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(208, 90, 46, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(208, 90, 46, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(158, 98, 85, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #52683a, #581e12)",
      color: "#c2ae7e",
      accentColor: "#d05a2e",
      border: "min(0.25vw, 2px) solid #d05a2e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #581e12, #52683a)",
    },
    stat: {
      background: "rgba(88, 30, 18, 0.8)",
      border: "min(0.25vw, 2px) solid #d05a2e",
      color: "#f9d15b",
      boxShadow: "0 0 min(1vw, 8px) rgba(208, 90, 46, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d05a2e, #9e6255)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #581e12",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(208, 90, 46, 0.6)",
    },
  },
  banditCaptain: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(91, 114, 53, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(102, 56, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(194, 212, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5a412b, #663814, #5d7481)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(91, 114, 53, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(93, 116, 129, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5b7235, #5d7481, #c2d4a4, #5b7235, #663814)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(91, 114, 53, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(91, 114, 53, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(194, 212, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(91, 114, 53, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(102, 56, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5a412b, #663814, #5d7481)",
      border: "min(0.25vw, 2px) solid #5b7235",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(91, 114, 53, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(91, 114, 53, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(93, 116, 129, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5b7235, #5d7481, #c2d4a4, #5b7235, #663814)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(91, 114, 53, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(91, 114, 53, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(93, 116, 129, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5a412b, #663814)",
      color: "#c5b498",
      accentColor: "#5b7235",
      border: "min(0.25vw, 2px) solid #5b7235",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #663814, #5a412b)",
    },
    stat: {
      background: "rgba(102, 56, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #5b7235",
      color: "#c2d4a4",
      boxShadow: "0 0 min(1vw, 8px) rgba(91, 114, 53, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5b7235, #5d7481)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #663814",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(91, 114, 53, 0.6)",
    },
  },
  barbedDevil2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(224, 110, 48, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(116, 20, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(237, 174, 139, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #694439, #74140c, #6c8c94)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(224, 110, 48, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 140, 148, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e06e30, #6c8c94, #edae8b, #e06e30, #74140c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(224, 110, 48, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(224, 110, 48, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(237, 174, 139, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(224, 110, 48, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(116, 20, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #694439, #74140c, #6c8c94)",
      border: "min(0.25vw, 2px) solid #e06e30",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(224, 110, 48, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(224, 110, 48, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 140, 148, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e06e30, #6c8c94, #edae8b, #e06e30, #74140c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(224, 110, 48, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(224, 110, 48, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 140, 148, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #694439, #74140c)",
      color: "#88a9b2",
      accentColor: "#e06e30",
      border: "min(0.25vw, 2px) solid #e06e30",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #74140c, #694439)",
    },
    stat: {
      background: "rgba(116, 20, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #e06e30",
      color: "#edae8b",
      boxShadow: "0 0 min(1vw, 8px) rgba(224, 110, 48, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e06e30, #6c8c94)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #74140c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(224, 110, 48, 0.6)",
    },
  },
  bat: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(139, 208, 46, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(12, 18, 4, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(194, 230, 146, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b453a, #0c1204, #6d899a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(139, 208, 46, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(109, 137, 154, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #8bd02e, #6d899a, #c2e692, #8bd02e, #0c1204)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(139, 208, 46, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(139, 208, 46, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(194, 230, 146, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(139, 208, 46, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(12, 18, 4, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b453a, #0c1204, #6d899a)",
      border: "min(0.25vw, 2px) solid #8bd02e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(139, 208, 46, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(139, 208, 46, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(109, 137, 154, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #8bd02e, #6d899a, #c2e692, #8bd02e, #0c1204)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(139, 208, 46, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(139, 208, 46, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(109, 137, 154, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b453a, #0c1204)",
      color: "#b2b2a7",
      accentColor: "#8bd02e",
      border: "min(0.25vw, 2px) solid #8bd02e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0c1204, #4b453a)",
    },
    stat: {
      background: "rgba(12, 18, 4, 0.8)",
      border: "min(0.25vw, 2px) solid #8bd02e",
      color: "#c2e692",
      boxShadow: "0 0 min(1vw, 8px) rgba(139, 208, 46, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #8bd02e, #6d899a)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #0c1204",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(139, 208, 46, 0.6)",
    },
  },
  beardedDevil3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(225, 76, 20, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(148, 48, 19, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(247, 200, 116, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5f3731, #943013, #9d6355)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(225, 76, 20, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(157, 99, 85, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e14c14, #9d6355, #f7c874, #e14c14, #943013)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(225, 76, 20, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(225, 76, 20, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(247, 200, 116, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(225, 76, 20, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(148, 48, 19, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5f3731, #943013, #9d6355)",
      border: "min(0.25vw, 2px) solid #e14c14",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(225, 76, 20, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(225, 76, 20, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(157, 99, 85, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e14c14, #9d6355, #f7c874, #e14c14, #943013)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(225, 76, 20, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(225, 76, 20, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(157, 99, 85, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5f3731, #943013)",
      color: "#a8a8a0",
      accentColor: "#e14c14",
      border: "min(0.25vw, 2px) solid #e14c14",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #943013, #5f3731)",
    },
    stat: {
      background: "rgba(148, 48, 19, 0.8)",
      border: "min(0.25vw, 2px) solid #e14c14",
      color: "#f7c874",
      boxShadow: "0 0 min(1vw, 8px) rgba(225, 76, 20, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e14c14, #9d6355)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #943013",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(225, 76, 20, 0.6)",
    },
  },
  behir: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(75, 151, 183, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 76, 108, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(101, 176, 199, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #375254, #1c4c6c, #4780a4)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(75, 151, 183, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(71, 128, 164, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4b97b7, #4780a4, #65b0c7, #4b97b7, #1c4c6c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(75, 151, 183, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(75, 151, 183, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(101, 176, 199, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(75, 151, 183, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 76, 108, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #375254, #1c4c6c, #4780a4)",
      border: "min(0.25vw, 2px) solid #4b97b7",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(75, 151, 183, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(75, 151, 183, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(71, 128, 164, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4b97b7, #4780a4, #65b0c7, #4b97b7, #1c4c6c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(75, 151, 183, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(75, 151, 183, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(71, 128, 164, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #375254, #1c4c6c)",
      color: "#c0bca8",
      accentColor: "#4b97b7",
      border: "min(0.25vw, 2px) solid #4b97b7",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c4c6c, #375254)",
    },
    stat: {
      background: "rgba(28, 76, 108, 0.8)",
      border: "min(0.25vw, 2px) solid #4b97b7",
      color: "#65b0c7",
      boxShadow: "0 0 min(1vw, 8px) rgba(75, 151, 183, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4b97b7, #4780a4)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1c4c6c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(75, 151, 183, 0.6)",
    },
  },
  berserker2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(156, 102, 69, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(135, 43, 37, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(205, 165, 130, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3c4c5b, #872b25, #948073)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(156, 102, 69, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(148, 128, 115, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #9c6645, #948073, #cda582, #9c6645, #872b25)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(156, 102, 69, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(156, 102, 69, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(205, 165, 130, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(156, 102, 69, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(135, 43, 37, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3c4c5b, #872b25, #948073)",
      border: "min(0.25vw, 2px) solid #9c6645",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(156, 102, 69, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(156, 102, 69, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(148, 128, 115, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #9c6645, #948073, #cda582, #9c6645, #872b25)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(156, 102, 69, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(156, 102, 69, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(148, 128, 115, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3c4c5b, #872b25)",
      color: "#8d9ab5",
      accentColor: "#9c6645",
      border: "min(0.25vw, 2px) solid #9c6645",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #872b25, #3c4c5b)",
    },
    stat: {
      background: "rgba(135, 43, 37, 0.8)",
      border: "min(0.25vw, 2px) solid #9c6645",
      color: "#cda582",
      boxShadow: "0 0 min(1vw, 8px) rgba(156, 102, 69, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #9c6645, #948073)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #872b25",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(156, 102, 69, 0.6)",
    },
  },
  blackBear: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(176, 143, 78, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(91, 74, 40, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(236, 228, 212, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #364434, #5b4a28, #9c8466)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(176, 143, 78, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(156, 132, 102, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b08f4e, #9c8466, #ece4d4, #b08f4e, #5b4a28)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(176, 143, 78, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(176, 143, 78, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(236, 228, 212, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(176, 143, 78, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(91, 74, 40, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #364434, #5b4a28, #9c8466)",
      border: "min(0.25vw, 2px) solid #b08f4e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(176, 143, 78, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(176, 143, 78, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(156, 132, 102, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b08f4e, #9c8466, #ece4d4, #b08f4e, #5b4a28)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(176, 143, 78, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(176, 143, 78, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(156, 132, 102, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #364434, #5b4a28)",
      color: "#dcd4c4",
      accentColor: "#b08f4e",
      border: "min(0.25vw, 2px) solid #b08f4e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5b4a28, #364434)",
    },
    stat: {
      background: "rgba(91, 74, 40, 0.8)",
      border: "min(0.25vw, 2px) solid #b08f4e",
      color: "#ece4d4",
      boxShadow: "0 0 min(1vw, 8px) rgba(176, 143, 78, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b08f4e, #9c8466)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5b4a28",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(176, 143, 78, 0.6)",
    },
  },
  blackDragonWyrmling: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(210, 123, 52, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(96, 58, 39, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(194, 140, 128, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #543441, #603a27, #83868e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(210, 123, 52, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(131, 134, 142, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d27b34, #83868e, #c28c80, #d27b34, #603a27)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(210, 123, 52, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(210, 123, 52, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(194, 140, 128, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(210, 123, 52, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(96, 58, 39, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #543441, #603a27, #83868e)",
      border: "min(0.25vw, 2px) solid #d27b34",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(210, 123, 52, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(210, 123, 52, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(131, 134, 142, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d27b34, #83868e, #c28c80, #d27b34, #603a27)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(210, 123, 52, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(210, 123, 52, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(131, 134, 142, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #543441, #603a27)",
      color: "#b1bfca",
      accentColor: "#d27b34",
      border: "min(0.25vw, 2px) solid #d27b34",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #603a27, #543441)",
    },
    stat: {
      background: "rgba(96, 58, 39, 0.8)",
      border: "min(0.25vw, 2px) solid #d27b34",
      color: "#c28c80",
      boxShadow: "0 0 min(1vw, 8px) rgba(210, 123, 52, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d27b34, #83868e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #603a27",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(210, 123, 52, 0.6)",
    },
  },
  blackPudding3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(115, 66, 54, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(101, 102, 27, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(212, 174, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b4332, #65661b, #907d52)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(115, 66, 54, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(144, 125, 82, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #734236, #907d52, #d4aea4, #734236, #65661b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(115, 66, 54, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(115, 66, 54, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(212, 174, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(115, 66, 54, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(101, 102, 27, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b4332, #65661b, #907d52)",
      border: "min(0.25vw, 2px) solid #734236",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(115, 66, 54, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(115, 66, 54, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(144, 125, 82, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #734236, #907d52, #d4aea4, #734236, #65661b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(115, 66, 54, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(115, 66, 54, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(144, 125, 82, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b4332, #65661b)",
      color: "#bca274",
      accentColor: "#734236",
      border: "min(0.25vw, 2px) solid #734236",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #65661b, #4b4332)",
    },
    stat: {
      background: "rgba(101, 102, 27, 0.8)",
      border: "min(0.25vw, 2px) solid #734236",
      color: "#d4aea4",
      boxShadow: "0 0 min(1vw, 8px) rgba(115, 66, 54, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #734236, #907d52)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #65661b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(115, 66, 54, 0.6)",
    },
  },
  bloodHawk: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(142, 28, 28, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(102, 22, 21, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(233, 144, 144, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b5c3b, #661615, #847692)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(142, 28, 28, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(132, 118, 146, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #8e1c1c, #847692, #e99090, #8e1c1c, #661615)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(142, 28, 28, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(142, 28, 28, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(233, 144, 144, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(142, 28, 28, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(102, 22, 21, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b5c3b, #661615, #847692)",
      border: "min(0.25vw, 2px) solid #8e1c1c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(142, 28, 28, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(142, 28, 28, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(132, 118, 146, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #8e1c1c, #847692, #e99090, #8e1c1c, #661615)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(142, 28, 28, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(142, 28, 28, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(132, 118, 146, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b5c3b, #661615)",
      color: "#c3909f",
      accentColor: "#8e1c1c",
      border: "min(0.25vw, 2px) solid #8e1c1c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #661615, #4b5c3b)",
    },
    stat: {
      background: "rgba(102, 22, 21, 0.8)",
      border: "min(0.25vw, 2px) solid #8e1c1c",
      color: "#e99090",
      boxShadow: "0 0 min(1vw, 8px) rgba(142, 28, 28, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #8e1c1c, #847692)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #661615",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(142, 28, 28, 0.6)",
    },
  },
  boar2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(125, 189, 193, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 68, 76, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(155, 226, 228, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #324d54, #24444c, #649ea6)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(125, 189, 193, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(100, 158, 166, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7dbdc1, #649ea6, #9be2e4, #7dbdc1, #24444c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(125, 189, 193, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(125, 189, 193, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(155, 226, 228, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(125, 189, 193, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 68, 76, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #324d54, #24444c, #649ea6)",
      border: "min(0.25vw, 2px) solid #7dbdc1",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(125, 189, 193, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(125, 189, 193, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(100, 158, 166, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7dbdc1, #649ea6, #9be2e4, #7dbdc1, #24444c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(125, 189, 193, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(125, 189, 193, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(100, 158, 166, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #324d54, #24444c)",
      color: "#8eb272",
      accentColor: "#7dbdc1",
      border: "min(0.25vw, 2px) solid #7dbdc1",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #24444c, #324d54)",
    },
    stat: {
      background: "rgba(36, 68, 76, 0.8)",
      border: "min(0.25vw, 2px) solid #7dbdc1",
      color: "#9be2e4",
      boxShadow: "0 0 min(1vw, 8px) rgba(125, 189, 193, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7dbdc1, #649ea6)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #24444c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(125, 189, 193, 0.6)",
    },
  },
  bugbear: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(115, 72, 46, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(108, 60, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(239, 233, 193, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #524233, #6c3c24, #82976a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(115, 72, 46, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(130, 151, 106, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #73482e, #82976a, #efe9c1, #73482e, #6c3c24)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(115, 72, 46, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(115, 72, 46, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(239, 233, 193, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(115, 72, 46, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(108, 60, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #524233, #6c3c24, #82976a)",
      border: "min(0.25vw, 2px) solid #73482e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(115, 72, 46, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(115, 72, 46, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(130, 151, 106, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #73482e, #82976a, #efe9c1, #73482e, #6c3c24)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(115, 72, 46, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(115, 72, 46, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(130, 151, 106, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #524233, #6c3c24)",
      color: "#b5beaf",
      accentColor: "#73482e",
      border: "min(0.25vw, 2px) solid #73482e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6c3c24, #524233)",
    },
    stat: {
      background: "rgba(108, 60, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #73482e",
      color: "#efe9c1",
      boxShadow: "0 0 min(1vw, 8px) rgba(115, 72, 46, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #73482e, #82976a)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #6c3c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(115, 72, 46, 0.6)",
    },
  },
  bugbear2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(116, 76, 44, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(102, 65, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(218, 185, 158, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #31394e, #664124, #648646)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(116, 76, 44, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(100, 134, 70, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #744c2c, #648646, #dab99e, #744c2c, #664124)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(116, 76, 44, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(116, 76, 44, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(218, 185, 158, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(116, 76, 44, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(102, 65, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #31394e, #664124, #648646)",
      border: "min(0.25vw, 2px) solid #744c2c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(116, 76, 44, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(116, 76, 44, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(100, 134, 70, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #744c2c, #648646, #dab99e, #744c2c, #664124)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(116, 76, 44, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(116, 76, 44, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(100, 134, 70, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #31394e, #664124)",
      color: "#b09e7e",
      accentColor: "#744c2c",
      border: "min(0.25vw, 2px) solid #744c2c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #664124, #31394e)",
    },
    stat: {
      background: "rgba(102, 65, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #744c2c",
      color: "#dab99e",
      boxShadow: "0 0 min(1vw, 8px) rgba(116, 76, 44, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #744c2c, #648646)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #664124",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(116, 76, 44, 0.6)",
    },
  },
  chimera: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(242, 208, 104, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(122, 94, 10, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(212, 188, 116, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3e4035, #7a5e0a, #aa9477)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(242, 208, 104, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(170, 148, 119, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f2d068, #aa9477, #d4bc74, #f2d068, #7a5e0a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(242, 208, 104, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(242, 208, 104, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(212, 188, 116, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(242, 208, 104, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(122, 94, 10, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3e4035, #7a5e0a, #aa9477)",
      border: "min(0.25vw, 2px) solid #f2d068",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(242, 208, 104, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(242, 208, 104, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(170, 148, 119, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f2d068, #aa9477, #d4bc74, #f2d068, #7a5e0a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(242, 208, 104, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(242, 208, 104, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(170, 148, 119, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3e4035, #7a5e0a)",
      color: "#acbcc4",
      accentColor: "#f2d068",
      border: "min(0.25vw, 2px) solid #f2d068",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #7a5e0a, #3e4035)",
    },
    stat: {
      background: "rgba(122, 94, 10, 0.8)",
      border: "min(0.25vw, 2px) solid #f2d068",
      color: "#d4bc74",
      boxShadow: "0 0 min(1vw, 8px) rgba(242, 208, 104, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f2d068, #aa9477)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #7a5e0a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(242, 208, 104, 0.6)",
    },
  },
  chuul: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(135, 160, 94, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(70, 83, 49, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(192, 205, 171, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3e4935, #465331, #7b8f51)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(135, 160, 94, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(123, 143, 81, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #87a05e, #7b8f51, #c0cdab, #87a05e, #465331)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(135, 160, 94, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(135, 160, 94, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(192, 205, 171, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(135, 160, 94, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(70, 83, 49, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3e4935, #465331, #7b8f51)",
      border: "min(0.25vw, 2px) solid #87a05e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(135, 160, 94, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(135, 160, 94, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(123, 143, 81, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #87a05e, #7b8f51, #c0cdab, #87a05e, #465331)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(135, 160, 94, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(135, 160, 94, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(123, 143, 81, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3e4935, #465331)",
      color: "#bccaa5",
      accentColor: "#87a05e",
      border: "min(0.25vw, 2px) solid #87a05e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #465331, #3e4935)",
    },
    stat: {
      background: "rgba(70, 83, 49, 0.8)",
      border: "min(0.25vw, 2px) solid #87a05e",
      color: "#c0cdab",
      boxShadow: "0 0 min(1vw, 8px) rgba(135, 160, 94, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #87a05e, #7b8f51)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #465331",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(135, 160, 94, 0.6)",
    },
  },
  cloudGiant: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(104, 160, 195, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(37, 72, 94, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(223, 166, 135, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5e4544, #25485e, #6c7897)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(104, 160, 195, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 120, 151, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #68a0c3, #6c7897, #dfa687, #68a0c3, #25485e)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(104, 160, 195, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(104, 160, 195, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(223, 166, 135, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(104, 160, 195, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(37, 72, 94, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5e4544, #25485e, #6c7897)",
      border: "min(0.25vw, 2px) solid #68a0c3",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(104, 160, 195, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(104, 160, 195, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 120, 151, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #68a0c3, #6c7897, #dfa687, #68a0c3, #25485e)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(104, 160, 195, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(104, 160, 195, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 120, 151, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5e4544, #25485e)",
      color: "#d2a69f",
      accentColor: "#68a0c3",
      border: "min(0.25vw, 2px) solid #68a0c3",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #25485e, #5e4544)",
    },
    stat: {
      background: "rgba(37, 72, 94, 0.8)",
      border: "min(0.25vw, 2px) solid #68a0c3",
      color: "#dfa687",
      boxShadow: "0 0 min(1vw, 8px) rgba(104, 160, 195, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #68a0c3, #6c7897)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #25485e",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(104, 160, 195, 0.6)",
    },
  },
  cloudGiant2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(235, 211, 108, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(116, 97, 15, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(228, 242, 252, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #344b63, #74610f, #6d8297)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(235, 211, 108, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(109, 130, 151, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ebd36c, #6d8297, #e4f2fc, #ebd36c, #74610f)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(235, 211, 108, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(235, 211, 108, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(228, 242, 252, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(235, 211, 108, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(116, 97, 15, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #344b63, #74610f, #6d8297)",
      border: "min(0.25vw, 2px) solid #ebd36c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(235, 211, 108, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(235, 211, 108, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(109, 130, 151, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ebd36c, #6d8297, #e4f2fc, #ebd36c, #74610f)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(235, 211, 108, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(235, 211, 108, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(109, 130, 151, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #344b63, #74610f)",
      color: "#b9c9d5",
      accentColor: "#ebd36c",
      border: "min(0.25vw, 2px) solid #ebd36c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #74610f, #344b63)",
    },
    stat: {
      background: "rgba(116, 97, 15, 0.8)",
      border: "min(0.25vw, 2px) solid #ebd36c",
      color: "#e4f2fc",
      boxShadow: "0 0 min(1vw, 8px) rgba(235, 211, 108, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ebd36c, #6d8297)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #74610f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(235, 211, 108, 0.6)",
    },
  },
  cockatrice2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(116, 163, 202, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(52, 84, 108, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(156, 206, 232, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #394e31, #34546c, #648eac)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(116, 163, 202, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(100, 142, 172, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #74a3ca, #648eac, #9ccee8, #74a3ca, #34546c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(116, 163, 202, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(116, 163, 202, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(156, 206, 232, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(116, 163, 202, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(52, 84, 108, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #394e31, #34546c, #648eac)",
      border: "min(0.25vw, 2px) solid #74a3ca",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(116, 163, 202, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(116, 163, 202, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(100, 142, 172, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #74a3ca, #648eac, #9ccee8, #74a3ca, #34546c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(116, 163, 202, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(116, 163, 202, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(100, 142, 172, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #394e31, #34546c)",
      color: "#99b9d3",
      accentColor: "#74a3ca",
      border: "min(0.25vw, 2px) solid #74a3ca",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #34546c, #394e31)",
    },
    stat: {
      background: "rgba(52, 84, 108, 0.8)",
      border: "min(0.25vw, 2px) solid #74a3ca",
      color: "#9ccee8",
      boxShadow: "0 0 min(1vw, 8px) rgba(116, 163, 202, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #74a3ca, #648eac)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #34546c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(116, 163, 202, 0.6)",
    },
  },
  copperDragonWyrmling3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(175, 109, 61, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(86, 47, 26, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(140, 204, 236, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #30281f, #562f1a, #959e54)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(175, 109, 61, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(149, 158, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #af6d3d, #959e54, #8cccec, #af6d3d, #562f1a)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(175, 109, 61, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(175, 109, 61, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(140, 204, 236, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(175, 109, 61, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(86, 47, 26, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #30281f, #562f1a, #959e54)",
      border: "min(0.25vw, 2px) solid #af6d3d",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(175, 109, 61, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(175, 109, 61, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(149, 158, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #af6d3d, #959e54, #8cccec, #af6d3d, #562f1a)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(175, 109, 61, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(175, 109, 61, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(149, 158, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #30281f, #562f1a)",
      color: "#adc3d0",
      accentColor: "#af6d3d",
      border: "min(0.25vw, 2px) solid #af6d3d",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #562f1a, #30281f)",
    },
    stat: {
      background: "rgba(86, 47, 26, 0.8)",
      border: "min(0.25vw, 2px) solid #af6d3d",
      color: "#8cccec",
      boxShadow: "0 0 min(1vw, 8px) rgba(175, 109, 61, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #af6d3d, #959e54)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #562f1a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(175, 109, 61, 0.6)",
    },
  },
  couatl: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(199, 169, 68, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(131, 32, 26, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(248, 222, 145, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #36522f, #83201a, #815a91)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(199, 169, 68, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(129, 90, 145, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c7a944, #815a91, #f8de91, #c7a944, #83201a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(199, 169, 68, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(199, 169, 68, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(248, 222, 145, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(199, 169, 68, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(131, 32, 26, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #36522f, #83201a, #815a91)",
      border: "min(0.25vw, 2px) solid #c7a944",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(199, 169, 68, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(199, 169, 68, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(129, 90, 145, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c7a944, #815a91, #f8de91, #c7a944, #83201a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(199, 169, 68, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(199, 169, 68, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(129, 90, 145, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #36522f, #83201a)",
      color: "#c57d85",
      accentColor: "#c7a944",
      border: "min(0.25vw, 2px) solid #c7a944",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #83201a, #36522f)",
    },
    stat: {
      background: "rgba(131, 32, 26, 0.8)",
      border: "min(0.25vw, 2px) solid #c7a944",
      color: "#f8de91",
      boxShadow: "0 0 min(1vw, 8px) rgba(199, 169, 68, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c7a944, #815a91)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #83201a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(199, 169, 68, 0.6)",
    },
  },
  cultist: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(136, 175, 79, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(60, 77, 35, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(193, 213, 163, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #38515a, #3c4d23, #608da1)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(136, 175, 79, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(96, 141, 161, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #88af4f, #608da1, #c1d5a3, #88af4f, #3c4d23)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(136, 175, 79, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(136, 175, 79, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(193, 213, 163, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(136, 175, 79, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(60, 77, 35, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #38515a, #3c4d23, #608da1)",
      border: "min(0.25vw, 2px) solid #88af4f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(136, 175, 79, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(136, 175, 79, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(96, 141, 161, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #88af4f, #608da1, #c1d5a3, #88af4f, #3c4d23)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(136, 175, 79, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(136, 175, 79, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(96, 141, 161, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #38515a, #3c4d23)",
      color: "#7bb5b6",
      accentColor: "#88af4f",
      border: "min(0.25vw, 2px) solid #88af4f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3c4d23, #38515a)",
    },
    stat: {
      background: "rgba(60, 77, 35, 0.8)",
      border: "min(0.25vw, 2px) solid #88af4f",
      color: "#c1d5a3",
      boxShadow: "0 0 min(1vw, 8px) rgba(136, 175, 79, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #88af4f, #608da1)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #3c4d23",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(136, 175, 79, 0.6)",
    },
  },
  cultFanatic: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(195, 146, 68, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(76, 28, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(142, 221, 222, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b3b29, #4c1c14, #569a8d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(195, 146, 68, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(86, 154, 141, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c39244, #569a8d, #8eddde, #c39244, #4c1c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(195, 146, 68, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(195, 146, 68, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(142, 221, 222, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(195, 146, 68, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(76, 28, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b3b29, #4c1c14, #569a8d)",
      border: "min(0.25vw, 2px) solid #c39244",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(195, 146, 68, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(195, 146, 68, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(86, 154, 141, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c39244, #569a8d, #8eddde, #c39244, #4c1c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(195, 146, 68, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(195, 146, 68, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(86, 154, 141, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b3b29, #4c1c14)",
      color: "#73bdac",
      accentColor: "#c39244",
      border: "min(0.25vw, 2px) solid #c39244",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4c1c14, #4b3b29)",
    },
    stat: {
      background: "rgba(76, 28, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #c39244",
      color: "#8eddde",
      boxShadow: "0 0 min(1vw, 8px) rgba(195, 146, 68, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c39244, #569a8d)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #4c1c14",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(195, 146, 68, 0.6)",
    },
  },
  darkmantle2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(134, 177, 77, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(76, 100, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(192, 214, 162, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #37473e, #4c642c, #698f6c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(134, 177, 77, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(105, 143, 108, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #86b14d, #698f6c, #c0d6a2, #86b14d, #4c642c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(134, 177, 77, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(134, 177, 77, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(192, 214, 162, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(134, 177, 77, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(76, 100, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #37473e, #4c642c, #698f6c)",
      border: "min(0.25vw, 2px) solid #86b14d",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(134, 177, 77, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(134, 177, 77, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(105, 143, 108, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #86b14d, #698f6c, #c0d6a2, #86b14d, #4c642c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(134, 177, 77, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(134, 177, 77, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(105, 143, 108, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #37473e, #4c642c)",
      color: "#a2cf9e",
      accentColor: "#86b14d",
      border: "min(0.25vw, 2px) solid #86b14d",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4c642c, #37473e)",
    },
    stat: {
      background: "rgba(76, 100, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #86b14d",
      color: "#c0d6a2",
      boxShadow: "0 0 min(1vw, 8px) rgba(134, 177, 77, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #86b14d, #698f6c)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #4c642c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(134, 177, 77, 0.6)",
    },
  },
  deepGnomeSvirfneblin: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(105, 199, 207, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 84, 90, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(154, 217, 222, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #304b54, #24545a, #549ba4)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(105, 199, 207, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(84, 155, 164, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #69c7cf, #549ba4, #9ad9de, #69c7cf, #24545a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(105, 199, 207, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(105, 199, 207, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(154, 217, 222, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(105, 199, 207, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 84, 90, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #304b54, #24545a, #549ba4)",
      border: "min(0.25vw, 2px) solid #69c7cf",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(105, 199, 207, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(105, 199, 207, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(84, 155, 164, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #69c7cf, #549ba4, #9ad9de, #69c7cf, #24545a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(105, 199, 207, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(105, 199, 207, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(84, 155, 164, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #304b54, #24545a)",
      color: "#dfe5db",
      accentColor: "#69c7cf",
      border: "min(0.25vw, 2px) solid #69c7cf",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #24545a, #304b54)",
    },
    stat: {
      background: "rgba(36, 84, 90, 0.8)",
      border: "min(0.25vw, 2px) solid #69c7cf",
      color: "#9ad9de",
      boxShadow: "0 0 min(1vw, 8px) rgba(105, 199, 207, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #69c7cf, #549ba4)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #24545a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(105, 199, 207, 0.6)",
    },
  },
  draftHorse3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(233, 159, 108, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 84, 52, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(237, 204, 155, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #435d35, #1c5434, #a96460)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(233, 159, 108, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(169, 100, 96, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e99f6c, #a96460, #edcc9b, #e99f6c, #1c5434)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(233, 159, 108, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(233, 159, 108, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(237, 204, 155, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(233, 159, 108, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 84, 52, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #435d35, #1c5434, #a96460)",
      border: "min(0.25vw, 2px) solid #e99f6c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(233, 159, 108, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(233, 159, 108, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(169, 100, 96, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e99f6c, #a96460, #edcc9b, #e99f6c, #1c5434)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(233, 159, 108, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(233, 159, 108, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(169, 100, 96, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #435d35, #1c5434)",
      color: "#d1b09c",
      accentColor: "#e99f6c",
      border: "min(0.25vw, 2px) solid #e99f6c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c5434, #435d35)",
    },
    stat: {
      background: "rgba(28, 84, 52, 0.8)",
      border: "min(0.25vw, 2px) solid #e99f6c",
      color: "#edcc9b",
      boxShadow: "0 0 min(1vw, 8px) rgba(233, 159, 108, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e99f6c, #a96460)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1c5434",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(233, 159, 108, 0.6)",
    },
  },
  dragonTurtle: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(173, 114, 79, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(68, 92, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(234, 245, 243, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4f633e, #445c24, #6d857a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(173, 114, 79, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(109, 133, 122, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ad724f, #6d857a, #eaf5f3, #ad724f, #445c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(173, 114, 79, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(173, 114, 79, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(234, 245, 243, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(173, 114, 79, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(68, 92, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4f633e, #445c24, #6d857a)",
      border: "min(0.25vw, 2px) solid #ad724f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(173, 114, 79, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(173, 114, 79, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(109, 133, 122, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ad724f, #6d857a, #eaf5f3, #ad724f, #445c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(173, 114, 79, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(173, 114, 79, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(109, 133, 122, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4f633e, #445c24)",
      color: "#bdd4cc",
      accentColor: "#ad724f",
      border: "min(0.25vw, 2px) solid #ad724f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #445c24, #4f633e)",
    },
    stat: {
      background: "rgba(68, 92, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #ad724f",
      color: "#eaf5f3",
      boxShadow: "0 0 min(1vw, 8px) rgba(173, 114, 79, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ad724f, #6d857a)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #445c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(173, 114, 79, 0.6)",
    },
  },
  dragonTurtle2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(112, 155, 211, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(31, 61, 101, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(153, 184, 223, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #305740, #1f3d65, #569984)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(112, 155, 211, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(86, 153, 132, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #709bd3, #569984, #99b8df, #709bd3, #1f3d65)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(112, 155, 211, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(112, 155, 211, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(153, 184, 223, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(112, 155, 211, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(31, 61, 101, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #305740, #1f3d65, #569984)",
      border: "min(0.25vw, 2px) solid #709bd3",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(112, 155, 211, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(112, 155, 211, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(86, 153, 132, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #709bd3, #569984, #99b8df, #709bd3, #1f3d65)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(112, 155, 211, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(112, 155, 211, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(86, 153, 132, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #305740, #1f3d65)",
      color: "#96c2c7",
      accentColor: "#709bd3",
      border: "min(0.25vw, 2px) solid #709bd3",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1f3d65, #305740)",
    },
    stat: {
      background: "rgba(31, 61, 101, 0.8)",
      border: "min(0.25vw, 2px) solid #709bd3",
      color: "#99b8df",
      boxShadow: "0 0 min(1vw, 8px) rgba(112, 155, 211, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #709bd3, #569984)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1f3d65",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(112, 155, 211, 0.6)",
    },
  },
  drider: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(46, 139, 208, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(4, 12, 18, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(146, 194, 230, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3e5434, #040c12, #648449)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(46, 139, 208, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(100, 132, 73, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #2e8bd0, #648449, #92c2e6, #2e8bd0, #040c12)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(46, 139, 208, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(46, 139, 208, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(146, 194, 230, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(46, 139, 208, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(4, 12, 18, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3e5434, #040c12, #648449)",
      border: "min(0.25vw, 2px) solid #2e8bd0",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(46, 139, 208, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(46, 139, 208, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(100, 132, 73, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #2e8bd0, #648449, #92c2e6, #2e8bd0, #040c12)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(46, 139, 208, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(46, 139, 208, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(100, 132, 73, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3e5434, #040c12)",
      color: "#a9be94",
      accentColor: "#2e8bd0",
      border: "min(0.25vw, 2px) solid #2e8bd0",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #040c12, #3e5434)",
    },
    stat: {
      background: "rgba(4, 12, 18, 0.8)",
      border: "min(0.25vw, 2px) solid #2e8bd0",
      color: "#92c2e6",
      boxShadow: "0 0 min(1vw, 8px) rgba(46, 139, 208, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #2e8bd0, #648449)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #040c12",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(46, 139, 208, 0.6)",
    },
  },
  drow: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(91, 186, 204, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(20, 118, 101, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(153, 212, 223, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #274052, #147665, #5188ad)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(91, 186, 204, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(81, 136, 173, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5bbacc, #5188ad, #99d4df, #5bbacc, #147665)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(91, 186, 204, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(91, 186, 204, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(153, 212, 223, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(91, 186, 204, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(20, 118, 101, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #274052, #147665, #5188ad)",
      border: "min(0.25vw, 2px) solid #5bbacc",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(91, 186, 204, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(91, 186, 204, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(81, 136, 173, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5bbacc, #5188ad, #99d4df, #5bbacc, #147665)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(91, 186, 204, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(91, 186, 204, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(81, 136, 173, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #274052, #147665)",
      color: "#babec7",
      accentColor: "#5bbacc",
      border: "min(0.25vw, 2px) solid #5bbacc",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #147665, #274052)",
    },
    stat: {
      background: "rgba(20, 118, 101, 0.8)",
      border: "min(0.25vw, 2px) solid #5bbacc",
      color: "#99d4df",
      boxShadow: "0 0 min(1vw, 8px) rgba(91, 186, 204, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5bbacc, #5188ad)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #147665",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(91, 186, 204, 0.6)",
    },
  },
  druid: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(130, 178, 63, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(92, 81, 41, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(193, 220, 157, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #423921, #5c5129, #7f7c47)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(130, 178, 63, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(127, 124, 71, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #82b23f, #7f7c47, #c1dc9d, #82b23f, #5c5129)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(130, 178, 63, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(130, 178, 63, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(193, 220, 157, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(130, 178, 63, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(92, 81, 41, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #423921, #5c5129, #7f7c47)",
      border: "min(0.25vw, 2px) solid #82b23f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(130, 178, 63, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(130, 178, 63, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(127, 124, 71, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #82b23f, #7f7c47, #c1dc9d, #82b23f, #5c5129)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(130, 178, 63, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(130, 178, 63, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(127, 124, 71, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #423921, #5c5129)",
      color: "#c7d4ae",
      accentColor: "#82b23f",
      border: "min(0.25vw, 2px) solid #82b23f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5c5129, #423921)",
    },
    stat: {
      background: "rgba(92, 81, 41, 0.8)",
      border: "min(0.25vw, 2px) solid #82b23f",
      color: "#c1dc9d",
      boxShadow: "0 0 min(1vw, 8px) rgba(130, 178, 63, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #82b23f, #7f7c47)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5c5129",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(130, 178, 63, 0.6)",
    },
  },
  dryad2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(189, 202, 71, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(84, 92, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(234, 240, 184, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5c5d31, #545c14, #ac8c54)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(189, 202, 71, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(172, 140, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #bdca47, #ac8c54, #eaf0b8, #bdca47, #545c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(189, 202, 71, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(189, 202, 71, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(234, 240, 184, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(189, 202, 71, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(84, 92, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5c5d31, #545c14, #ac8c54)",
      border: "min(0.25vw, 2px) solid #bdca47",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(189, 202, 71, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(189, 202, 71, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(172, 140, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #bdca47, #ac8c54, #eaf0b8, #bdca47, #545c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(189, 202, 71, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(189, 202, 71, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(172, 140, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5c5d31, #545c14)",
      color: "#becfa2",
      accentColor: "#bdca47",
      border: "min(0.25vw, 2px) solid #bdca47",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #545c14, #5c5d31)",
    },
    stat: {
      background: "rgba(84, 92, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #bdca47",
      color: "#eaf0b8",
      boxShadow: "0 0 min(1vw, 8px) rgba(189, 202, 71, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #bdca47, #ac8c54)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #545c14",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(189, 202, 71, 0.6)",
    },
  },
  duergar2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(183, 73, 71, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(100, 40, 39, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(217, 160, 159, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #475f34, #642827, #7da067)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(183, 73, 71, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(125, 160, 103, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b74947, #7da067, #d9a09f, #b74947, #642827)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(183, 73, 71, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(183, 73, 71, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(217, 160, 159, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(183, 73, 71, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(100, 40, 39, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #475f34, #642827, #7da067)",
      border: "min(0.25vw, 2px) solid #b74947",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(183, 73, 71, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(183, 73, 71, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(125, 160, 103, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b74947, #7da067, #d9a09f, #b74947, #642827)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(183, 73, 71, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(183, 73, 71, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(125, 160, 103, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #475f34, #642827)",
      color: "#dfdfd0",
      accentColor: "#b74947",
      border: "min(0.25vw, 2px) solid #b74947",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #642827, #475f34)",
    },
    stat: {
      background: "rgba(100, 40, 39, 0.8)",
      border: "min(0.25vw, 2px) solid #b74947",
      color: "#d9a09f",
      boxShadow: "0 0 min(1vw, 8px) rgba(183, 73, 71, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b74947, #7da067)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #642827",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(183, 73, 71, 0.6)",
    },
  },
  dustMephit: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(196, 128, 108, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(108, 60, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(217, 173, 160, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5f4034, #6c3c2c, #8f7e70)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(196, 128, 108, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(143, 126, 112, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c4806c, #8f7e70, #d9ada0, #c4806c, #6c3c2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(196, 128, 108, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(196, 128, 108, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(217, 173, 160, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(196, 128, 108, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(108, 60, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5f4034, #6c3c2c, #8f7e70)",
      border: "min(0.25vw, 2px) solid #c4806c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(196, 128, 108, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(196, 128, 108, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(143, 126, 112, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c4806c, #8f7e70, #d9ada0, #c4806c, #6c3c2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(196, 128, 108, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(196, 128, 108, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(143, 126, 112, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5f4034, #6c3c2c)",
      color: "#a4a496",
      accentColor: "#c4806c",
      border: "min(0.25vw, 2px) solid #c4806c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6c3c2c, #5f4034)",
    },
    stat: {
      background: "rgba(108, 60, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #c4806c",
      color: "#d9ada0",
      boxShadow: "0 0 min(1vw, 8px) rgba(196, 128, 108, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c4806c, #8f7e70)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #6c3c2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(196, 128, 108, 0.6)",
    },
  },
  efreeti2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(225, 135, 57, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(112, 71, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(240, 215, 131, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4a3539, #704724, #6f6489)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(225, 135, 57, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(111, 100, 137, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e18739, #6f6489, #f0d783, #e18739, #704724)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(225, 135, 57, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(225, 135, 57, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(240, 215, 131, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(225, 135, 57, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(112, 71, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4a3539, #704724, #6f6489)",
      border: "min(0.25vw, 2px) solid #e18739",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(225, 135, 57, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(225, 135, 57, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(111, 100, 137, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e18739, #6f6489, #f0d783, #e18739, #704724)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(225, 135, 57, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(225, 135, 57, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(111, 100, 137, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4a3539, #704724)",
      color: "#c4b29c",
      accentColor: "#e18739",
      border: "min(0.25vw, 2px) solid #e18739",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #704724, #4a3539)",
    },
    stat: {
      background: "rgba(112, 71, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #e18739",
      color: "#f0d783",
      boxShadow: "0 0 min(1vw, 8px) rgba(225, 135, 57, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e18739, #6f6489)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #704724",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(225, 135, 57, 0.6)",
    },
  },
  elephant2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(76, 132, 180, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(39, 68, 93, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(167, 222, 232, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2c4453, #27445d, #6c8454)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(76, 132, 180, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 132, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4c84b4, #6c8454, #a7dee8, #4c84b4, #27445d)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 132, 180, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(76, 132, 180, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(167, 222, 232, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(76, 132, 180, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(39, 68, 93, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2c4453, #27445d, #6c8454)",
      border: "min(0.25vw, 2px) solid #4c84b4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(76, 132, 180, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(76, 132, 180, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 132, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4c84b4, #6c8454, #a7dee8, #4c84b4, #27445d)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 132, 180, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(76, 132, 180, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 132, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2c4453, #27445d)",
      color: "#a6c3c7",
      accentColor: "#4c84b4",
      border: "min(0.25vw, 2px) solid #4c84b4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #27445d, #2c4453)",
    },
    stat: {
      background: "rgba(39, 68, 93, 0.8)",
      border: "min(0.25vw, 2px) solid #4c84b4",
      color: "#a7dee8",
      boxShadow: "0 0 min(1vw, 8px) rgba(76, 132, 180, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4c84b4, #6c8454)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #27445d",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(76, 132, 180, 0.6)",
    },
  },
  elk3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(149, 180, 84, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(96, 132, 60, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(238, 241, 221, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #504f3a, #60843c, #738d7e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(149, 180, 84, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(115, 141, 126, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #95b454, #738d7e, #eef1dd, #95b454, #60843c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(149, 180, 84, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(149, 180, 84, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(238, 241, 221, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(149, 180, 84, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(96, 132, 60, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #504f3a, #60843c, #738d7e)",
      border: "min(0.25vw, 2px) solid #95b454",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(149, 180, 84, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(149, 180, 84, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(115, 141, 126, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #95b454, #738d7e, #eef1dd, #95b454, #60843c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(149, 180, 84, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(149, 180, 84, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(115, 141, 126, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #504f3a, #60843c)",
      color: "#acccbb",
      accentColor: "#95b454",
      border: "min(0.25vw, 2px) solid #95b454",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #60843c, #504f3a)",
    },
    stat: {
      background: "rgba(96, 132, 60, 0.8)",
      border: "min(0.25vw, 2px) solid #95b454",
      color: "#eef1dd",
      boxShadow: "0 0 min(1vw, 8px) rgba(149, 180, 84, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #95b454, #738d7e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #60843c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(149, 180, 84, 0.6)",
    },
  },
  erinyes: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(214, 163, 102, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(92, 52, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(226, 192, 150, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5e4338, #5c341c, #6c8394)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(214, 163, 102, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 131, 148, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d6a366, #6c8394, #e2c096, #d6a366, #5c341c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(214, 163, 102, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(214, 163, 102, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(226, 192, 150, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(214, 163, 102, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(92, 52, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5e4338, #5c341c, #6c8394)",
      border: "min(0.25vw, 2px) solid #d6a366",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(214, 163, 102, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(214, 163, 102, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 131, 148, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d6a366, #6c8394, #e2c096, #d6a366, #5c341c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(214, 163, 102, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(214, 163, 102, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 131, 148, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5e4338, #5c341c)",
      color: "#8d9cb4",
      accentColor: "#d6a366",
      border: "min(0.25vw, 2px) solid #d6a366",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5c341c, #5e4338)",
    },
    stat: {
      background: "rgba(92, 52, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #d6a366",
      color: "#e2c096",
      boxShadow: "0 0 min(1vw, 8px) rgba(214, 163, 102, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d6a366, #6c8394)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5c341c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(214, 163, 102, 0.6)",
    },
  },
  ettin: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(120, 76, 36, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(97, 60, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(241, 226, 186, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #464c30, #613c1c, #a4845c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(120, 76, 36, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(164, 132, 92, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #784c24, #a4845c, #f1e2ba, #784c24, #613c1c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(120, 76, 36, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(120, 76, 36, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(241, 226, 186, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(120, 76, 36, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(97, 60, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #464c30, #613c1c, #a4845c)",
      border: "min(0.25vw, 2px) solid #784c24",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(120, 76, 36, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(120, 76, 36, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(164, 132, 92, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #784c24, #a4845c, #f1e2ba, #784c24, #613c1c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(120, 76, 36, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(120, 76, 36, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(164, 132, 92, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #464c30, #613c1c)",
      color: "#d5cbb0",
      accentColor: "#784c24",
      border: "min(0.25vw, 2px) solid #784c24",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #613c1c, #464c30)",
    },
    stat: {
      background: "rgba(97, 60, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #784c24",
      color: "#f1e2ba",
      boxShadow: "0 0 min(1vw, 8px) rgba(120, 76, 36, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #784c24, #a4845c)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #613c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(120, 76, 36, 0.6)",
    },
  },
  ettin2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(116, 144, 60, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(92, 56, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(197, 216, 161, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4e5937, #5c3824, #8da959)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(116, 144, 60, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(141, 169, 89, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #74903c, #8da959, #c5d8a1, #74903c, #5c3824)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(116, 144, 60, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(116, 144, 60, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(197, 216, 161, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(116, 144, 60, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(92, 56, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4e5937, #5c3824, #8da959)",
      border: "min(0.25vw, 2px) solid #74903c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(116, 144, 60, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(116, 144, 60, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(141, 169, 89, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #74903c, #8da959, #c5d8a1, #74903c, #5c3824)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(116, 144, 60, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(116, 144, 60, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(141, 169, 89, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4e5937, #5c3824)",
      color: "#c2c08c",
      accentColor: "#74903c",
      border: "min(0.25vw, 2px) solid #74903c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5c3824, #4e5937)",
    },
    stat: {
      background: "rgba(92, 56, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #74903c",
      color: "#c5d8a1",
      boxShadow: "0 0 min(1vw, 8px) rgba(116, 144, 60, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #74903c, #8da959)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #5c3824",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(116, 144, 60, 0.6)",
    },
  },
  fireElemental: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(233, 103, 36, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(137, 28, 22, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(249, 201, 73, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5a2e2f, #891c16, #a96c5a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(233, 103, 36, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(169, 108, 90, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e96724, #a96c5a, #f9c949, #e96724, #891c16)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(233, 103, 36, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(233, 103, 36, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(249, 201, 73, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(233, 103, 36, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(137, 28, 22, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5a2e2f, #891c16, #a96c5a)",
      border: "min(0.25vw, 2px) solid #e96724",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(233, 103, 36, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(233, 103, 36, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(169, 108, 90, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e96724, #a96c5a, #f9c949, #e96724, #891c16)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(233, 103, 36, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(233, 103, 36, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(169, 108, 90, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5a2e2f, #891c16)",
      color: "#c4a39c",
      accentColor: "#e96724",
      border: "min(0.25vw, 2px) solid #e96724",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #891c16, #5a2e2f)",
    },
    stat: {
      background: "rgba(137, 28, 22, 0.8)",
      border: "min(0.25vw, 2px) solid #e96724",
      color: "#f9c949",
      boxShadow: "0 0 min(1vw, 8px) rgba(233, 103, 36, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e96724, #a96c5a)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #891c16",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(233, 103, 36, 0.6)",
    },
  },
  fireElemental2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(239, 78, 27, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(106, 28, 19, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(247, 238, 124, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4f373a, #6a1c13, #8e423d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(239, 78, 27, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(142, 66, 61, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ef4e1b, #8e423d, #f7ee7c, #ef4e1b, #6a1c13)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(239, 78, 27, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(239, 78, 27, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(247, 238, 124, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(239, 78, 27, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(106, 28, 19, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4f373a, #6a1c13, #8e423d)",
      border: "min(0.25vw, 2px) solid #ef4e1b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(239, 78, 27, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(239, 78, 27, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(142, 66, 61, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ef4e1b, #8e423d, #f7ee7c, #ef4e1b, #6a1c13)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(239, 78, 27, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(239, 78, 27, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(142, 66, 61, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4f373a, #6a1c13)",
      color: "#c27b73",
      accentColor: "#ef4e1b",
      border: "min(0.25vw, 2px) solid #ef4e1b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6a1c13, #4f373a)",
    },
    stat: {
      background: "rgba(106, 28, 19, 0.8)",
      border: "min(0.25vw, 2px) solid #ef4e1b",
      color: "#f7ee7c",
      boxShadow: "0 0 min(1vw, 8px) rgba(239, 78, 27, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ef4e1b, #8e423d)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #6a1c13",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(239, 78, 27, 0.6)",
    },
  },
  frostGiant: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(58, 149, 190, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(33, 64, 90, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(152, 215, 237, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #324e2b, #21405a, #5b9da2)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(58, 149, 190, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(91, 157, 162, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3a95be, #5b9da2, #98d7ed, #3a95be, #21405a)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(58, 149, 190, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(58, 149, 190, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(152, 215, 237, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(58, 149, 190, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(33, 64, 90, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #324e2b, #21405a, #5b9da2)",
      border: "min(0.25vw, 2px) solid #3a95be",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(58, 149, 190, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(58, 149, 190, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(91, 157, 162, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3a95be, #5b9da2, #98d7ed, #3a95be, #21405a)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(58, 149, 190, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(58, 149, 190, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(91, 157, 162, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #324e2b, #21405a)",
      color: "#acc3d6",
      accentColor: "#3a95be",
      border: "min(0.25vw, 2px) solid #3a95be",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #21405a, #324e2b)",
    },
    stat: {
      background: "rgba(33, 64, 90, 0.8)",
      border: "min(0.25vw, 2px) solid #3a95be",
      color: "#98d7ed",
      boxShadow: "0 0 min(1vw, 8px) rgba(58, 149, 190, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3a95be, #5b9da2)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #21405a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(58, 149, 190, 0.6)",
    },
  },
  gelatinousCube: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(76, 176, 104, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(44, 92, 56, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(156, 232, 196, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #374f3f, #2c5c38, #559368)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(76, 176, 104, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(85, 147, 104, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4cb068, #559368, #9ce8c4, #4cb068, #2c5c38)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 176, 104, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(76, 176, 104, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(156, 232, 196, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(76, 176, 104, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(44, 92, 56, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #374f3f, #2c5c38, #559368)",
      border: "min(0.25vw, 2px) solid #4cb068",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(76, 176, 104, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(76, 176, 104, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(85, 147, 104, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4cb068, #559368, #9ce8c4, #4cb068, #2c5c38)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 176, 104, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(76, 176, 104, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(85, 147, 104, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #374f3f, #2c5c38)",
      color: "#90c29f",
      accentColor: "#4cb068",
      border: "min(0.25vw, 2px) solid #4cb068",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2c5c38, #374f3f)",
    },
    stat: {
      background: "rgba(44, 92, 56, 0.8)",
      border: "min(0.25vw, 2px) solid #4cb068",
      color: "#9ce8c4",
      boxShadow: "0 0 min(1vw, 8px) rgba(76, 176, 104, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4cb068, #559368)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #2c5c38",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(76, 176, 104, 0.6)",
    },
  },
  ghast: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(228, 84, 19, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(113, 38, 17, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(244, 167, 132, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #535936, #712611, #a35454)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(228, 84, 19, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(163, 84, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e45413, #a35454, #f4a784, #e45413, #712611)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(228, 84, 19, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(228, 84, 19, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(244, 167, 132, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(228, 84, 19, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(113, 38, 17, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #535936, #712611, #a35454)",
      border: "min(0.25vw, 2px) solid #e45413",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(228, 84, 19, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(228, 84, 19, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(163, 84, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e45413, #a35454, #f4a784, #e45413, #712611)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(228, 84, 19, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(228, 84, 19, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(163, 84, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #535936, #712611)",
      color: "#b2b698",
      accentColor: "#e45413",
      border: "min(0.25vw, 2px) solid #e45413",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #712611, #535936)",
    },
    stat: {
      background: "rgba(113, 38, 17, 0.8)",
      border: "min(0.25vw, 2px) solid #e45413",
      color: "#f4a784",
      boxShadow: "0 0 min(1vw, 8px) rgba(228, 84, 19, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e45413, #a35454)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #712611",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(228, 84, 19, 0.6)",
    },
  },
  ghast2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(248, 132, 24, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(106, 25, 16, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(251, 225, 81, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #345528, #6a1910, #a55c54)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(248, 132, 24, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(165, 92, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f88418, #a55c54, #fbe151, #f88418, #6a1910)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(248, 132, 24, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(248, 132, 24, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(251, 225, 81, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(248, 132, 24, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(106, 25, 16, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #345528, #6a1910, #a55c54)",
      border: "min(0.25vw, 2px) solid #f88418",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(248, 132, 24, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(248, 132, 24, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(165, 92, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f88418, #a55c54, #fbe151, #f88418, #6a1910)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(248, 132, 24, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(248, 132, 24, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(165, 92, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #345528, #6a1910)",
      color: "#ebdbd5",
      accentColor: "#f88418",
      border: "min(0.25vw, 2px) solid #f88418",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6a1910, #345528)",
    },
    stat: {
      background: "rgba(106, 25, 16, 0.8)",
      border: "min(0.25vw, 2px) solid #f88418",
      color: "#fbe151",
      boxShadow: "0 0 min(1vw, 8px) rgba(248, 132, 24, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f88418, #a55c54)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #6a1910",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(248, 132, 24, 0.6)",
    },
  },
  giantApe: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(186, 158, 108, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(60, 76, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(238, 203, 148, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3c5233, #3c4c24, #72965b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(186, 158, 108, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(114, 150, 91, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ba9e6c, #72965b, #eecb94, #ba9e6c, #3c4c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(186, 158, 108, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(186, 158, 108, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(238, 203, 148, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(186, 158, 108, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(60, 76, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3c5233, #3c4c24, #72965b)",
      border: "min(0.25vw, 2px) solid #ba9e6c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(186, 158, 108, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(186, 158, 108, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(114, 150, 91, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ba9e6c, #72965b, #eecb94, #ba9e6c, #3c4c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(186, 158, 108, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(186, 158, 108, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(114, 150, 91, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3c5233, #3c4c24)",
      color: "#c9b393",
      accentColor: "#ba9e6c",
      border: "min(0.25vw, 2px) solid #ba9e6c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3c4c24, #3c5233)",
    },
    stat: {
      background: "rgba(60, 76, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #ba9e6c",
      color: "#eecb94",
      boxShadow: "0 0 min(1vw, 8px) rgba(186, 158, 108, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ba9e6c, #72965b)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #3c4c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(186, 158, 108, 0.6)",
    },
  },
  giantBat: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(121, 115, 139, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(63, 59, 72, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(185, 182, 195, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #445c34, #3f3b48, #7c9c62)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(121, 115, 139, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(124, 156, 98, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #79738b, #7c9c62, #b9b6c3, #79738b, #3f3b48)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(121, 115, 139, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(121, 115, 139, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(185, 182, 195, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(121, 115, 139, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(63, 59, 72, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #445c34, #3f3b48, #7c9c62)",
      border: "min(0.25vw, 2px) solid #79738b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(121, 115, 139, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(121, 115, 139, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(124, 156, 98, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #79738b, #7c9c62, #b9b6c3, #79738b, #3f3b48)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(121, 115, 139, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(121, 115, 139, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(124, 156, 98, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #445c34, #3f3b48)",
      color: "#d4d2da",
      accentColor: "#79738b",
      border: "min(0.25vw, 2px) solid #79738b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3f3b48, #445c34)",
    },
    stat: {
      background: "rgba(63, 59, 72, 0.8)",
      border: "min(0.25vw, 2px) solid #79738b",
      color: "#b9b6c3",
      boxShadow: "0 0 min(1vw, 8px) rgba(121, 115, 139, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #79738b, #7c9c62)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #3f3b48",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(121, 115, 139, 0.6)",
    },
  },
  giantCentipede: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(76, 158, 146, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(69, 100, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(122, 179, 191, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #354e2f, #45642c, #648aa9)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(76, 158, 146, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(100, 138, 169, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4c9e92, #648aa9, #7ab3bf, #4c9e92, #45642c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 158, 146, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(76, 158, 146, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(122, 179, 191, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(76, 158, 146, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(69, 100, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #354e2f, #45642c, #648aa9)",
      border: "min(0.25vw, 2px) solid #4c9e92",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(76, 158, 146, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(76, 158, 146, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(100, 138, 169, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4c9e92, #648aa9, #7ab3bf, #4c9e92, #45642c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 158, 146, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(76, 158, 146, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(100, 138, 169, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #354e2f, #45642c)",
      color: "#b1d1c4",
      accentColor: "#4c9e92",
      border: "min(0.25vw, 2px) solid #4c9e92",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #45642c, #354e2f)",
    },
    stat: {
      background: "rgba(69, 100, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #4c9e92",
      color: "#7ab3bf",
      boxShadow: "0 0 min(1vw, 8px) rgba(76, 158, 146, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4c9e92, #648aa9)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #45642c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(76, 158, 146, 0.6)",
    },
  },
  giantConstrictorSnake: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(114, 150, 71, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(68, 92, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(190, 212, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3a4e26, #445c1c, #7e984e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(114, 150, 71, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(126, 152, 78, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #729647, #7e984e, #bed4a5, #729647, #445c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(114, 150, 71, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(114, 150, 71, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(190, 212, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(114, 150, 71, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(68, 92, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3a4e26, #445c1c, #7e984e)",
      border: "min(0.25vw, 2px) solid #729647",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(114, 150, 71, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(114, 150, 71, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(126, 152, 78, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #729647, #7e984e, #bed4a5, #729647, #445c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(114, 150, 71, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(114, 150, 71, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(126, 152, 78, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3a4e26, #445c1c)",
      color: "#bbd9bd",
      accentColor: "#729647",
      border: "min(0.25vw, 2px) solid #729647",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #445c1c, #3a4e26)",
    },
    stat: {
      background: "rgba(68, 92, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #729647",
      color: "#bed4a5",
      boxShadow: "0 0 min(1vw, 8px) rgba(114, 150, 71, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #729647, #7e984e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #445c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(114, 150, 71, 0.6)",
    },
  },
  giantCrab: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(102, 134, 152, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(53, 70, 79, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(175, 192, 201, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #614636, #35464f, #7c9464)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(102, 134, 152, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(124, 148, 100, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #668698, #7c9464, #afc0c9, #668698, #35464f)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(102, 134, 152, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(102, 134, 152, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(175, 192, 201, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(102, 134, 152, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(53, 70, 79, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #614636, #35464f, #7c9464)",
      border: "min(0.25vw, 2px) solid #668698",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(102, 134, 152, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(102, 134, 152, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(124, 148, 100, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #668698, #7c9464, #afc0c9, #668698, #35464f)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(102, 134, 152, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(102, 134, 152, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(124, 148, 100, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #614636, #35464f)",
      color: "#96acb8",
      accentColor: "#668698",
      border: "min(0.25vw, 2px) solid #668698",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #35464f, #614636)",
    },
    stat: {
      background: "rgba(53, 70, 79, 0.8)",
      border: "min(0.25vw, 2px) solid #668698",
      color: "#afc0c9",
      boxShadow: "0 0 min(1vw, 8px) rgba(102, 134, 152, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #668698, #7c9464)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #35464f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(102, 134, 152, 0.6)",
    },
  },
  giantFireBeetle: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(245, 106, 49, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(98, 20, 14, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(251, 228, 116, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #653b32, #62140e, #8ca568)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(245, 106, 49, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(140, 165, 104, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f56a31, #8ca568, #fbe474, #f56a31, #62140e)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(245, 106, 49, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(245, 106, 49, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(251, 228, 116, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(245, 106, 49, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(98, 20, 14, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #653b32, #62140e, #8ca568)",
      border: "min(0.25vw, 2px) solid #f56a31",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(245, 106, 49, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(245, 106, 49, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(140, 165, 104, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f56a31, #8ca568, #fbe474, #f56a31, #62140e)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(245, 106, 49, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(245, 106, 49, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(140, 165, 104, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #653b32, #62140e)",
      color: "#947c04",
      accentColor: "#f56a31",
      border: "min(0.25vw, 2px) solid #f56a31",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #62140e, #653b32)",
    },
    stat: {
      background: "rgba(98, 20, 14, 0.8)",
      border: "min(0.25vw, 2px) solid #f56a31",
      color: "#fbe474",
      boxShadow: "0 0 min(1vw, 8px) rgba(245, 106, 49, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f56a31, #8ca568)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #62140e",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(245, 106, 49, 0.6)",
    },
  },
  giantFrog: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(186, 78, 60, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(84, 56, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(248, 223, 167, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #455933, #543824, #8c656c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(186, 78, 60, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(140, 101, 108, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ba4e3c, #8c656c, #f8dfa7, #ba4e3c, #543824)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(186, 78, 60, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(186, 78, 60, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(248, 223, 167, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(186, 78, 60, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(84, 56, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #455933, #543824, #8c656c)",
      border: "min(0.25vw, 2px) solid #ba4e3c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(186, 78, 60, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(186, 78, 60, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(140, 101, 108, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ba4e3c, #8c656c, #f8dfa7, #ba4e3c, #543824)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(186, 78, 60, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(186, 78, 60, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(140, 101, 108, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #455933, #543824)",
      color: "#e6e2d0",
      accentColor: "#ba4e3c",
      border: "min(0.25vw, 2px) solid #ba4e3c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #543824, #455933)",
    },
    stat: {
      background: "rgba(84, 56, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #ba4e3c",
      color: "#f8dfa7",
      boxShadow: "0 0 min(1vw, 8px) rgba(186, 78, 60, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ba4e3c, #8c656c)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #543824",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(186, 78, 60, 0.6)",
    },
  },
  giantGoat3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(132, 92, 62, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(132, 84, 60, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(240, 232, 215, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #33454f, #84543c, #72858e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(132, 92, 62, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(114, 133, 142, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #845c3e, #72858e, #f0e8d7, #845c3e, #84543c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(132, 92, 62, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(132, 92, 62, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(240, 232, 215, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(132, 92, 62, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(132, 84, 60, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #33454f, #84543c, #72858e)",
      border: "min(0.25vw, 2px) solid #845c3e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(132, 92, 62, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(132, 92, 62, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(114, 133, 142, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #845c3e, #72858e, #f0e8d7, #845c3e, #84543c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(132, 92, 62, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(132, 92, 62, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(114, 133, 142, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #33454f, #84543c)",
      color: "#bfc7c6",
      accentColor: "#845c3e",
      border: "min(0.25vw, 2px) solid #845c3e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #84543c, #33454f)",
    },
    stat: {
      background: "rgba(132, 84, 60, 0.8)",
      border: "min(0.25vw, 2px) solid #845c3e",
      color: "#f0e8d7",
      boxShadow: "0 0 min(1vw, 8px) rgba(132, 92, 62, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #845c3e, #72858e)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #84543c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(132, 92, 62, 0.6)",
    },
  },
  giantOctopus2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(99, 146, 155, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(51, 75, 80, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(174, 198, 203, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3c4e5e, #334b50, #6c8292)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(99, 146, 155, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 130, 146, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #63929b, #6c8292, #aec6cb, #63929b, #334b50)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(99, 146, 155, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(99, 146, 155, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(174, 198, 203, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(99, 146, 155, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(51, 75, 80, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3c4e5e, #334b50, #6c8292)",
      border: "min(0.25vw, 2px) solid #63929b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(99, 146, 155, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(99, 146, 155, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 130, 146, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #63929b, #6c8292, #aec6cb, #63929b, #334b50)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(99, 146, 155, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(99, 146, 155, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 130, 146, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3c4e5e, #334b50)",
      color: "#bcd0d4",
      accentColor: "#63929b",
      border: "min(0.25vw, 2px) solid #63929b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #334b50, #3c4e5e)",
    },
    stat: {
      background: "rgba(51, 75, 80, 0.8)",
      border: "min(0.25vw, 2px) solid #63929b",
      color: "#aec6cb",
      boxShadow: "0 0 min(1vw, 8px) rgba(99, 146, 155, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #63929b, #6c8292)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #334b50",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(99, 146, 155, 0.6)",
    },
  },
  giantSeaHorse: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(44, 128, 152, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(20, 84, 108, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(188, 210, 224, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #34435d, #14546c, #6e869b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(44, 128, 152, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(110, 134, 155, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #2c8098, #6e869b, #bcd2e0, #2c8098, #14546c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(44, 128, 152, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(44, 128, 152, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(188, 210, 224, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(44, 128, 152, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(20, 84, 108, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #34435d, #14546c, #6e869b)",
      border: "min(0.25vw, 2px) solid #2c8098",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(44, 128, 152, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(44, 128, 152, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(110, 134, 155, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #2c8098, #6e869b, #bcd2e0, #2c8098, #14546c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(44, 128, 152, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(44, 128, 152, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(110, 134, 155, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #34435d, #14546c)",
      color: "#95b2c3",
      accentColor: "#2c8098",
      border: "min(0.25vw, 2px) solid #2c8098",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #14546c, #34435d)",
    },
    stat: {
      background: "rgba(20, 84, 108, 0.8)",
      border: "min(0.25vw, 2px) solid #2c8098",
      color: "#bcd2e0",
      boxShadow: "0 0 min(1vw, 8px) rgba(44, 128, 152, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #2c8098, #6e869b)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #14546c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(44, 128, 152, 0.6)",
    },
  },
  gibberingMouther: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(52, 117, 140, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 84, 100, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(158, 203, 219, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2e4652, #245464, #5f93a9)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(52, 117, 140, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(95, 147, 169, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #34758c, #5f93a9, #9ecbdb, #34758c, #245464)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(52, 117, 140, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(52, 117, 140, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(158, 203, 219, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(52, 117, 140, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 84, 100, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2e4652, #245464, #5f93a9)",
      border: "min(0.25vw, 2px) solid #34758c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(52, 117, 140, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(52, 117, 140, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(95, 147, 169, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #34758c, #5f93a9, #9ecbdb, #34758c, #245464)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(52, 117, 140, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(52, 117, 140, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(95, 147, 169, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2e4652, #245464)",
      color: "#d6d4c8",
      accentColor: "#34758c",
      border: "min(0.25vw, 2px) solid #34758c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #245464, #2e4652)",
    },
    stat: {
      background: "rgba(36, 84, 100, 0.8)",
      border: "min(0.25vw, 2px) solid #34758c",
      color: "#9ecbdb",
      boxShadow: "0 0 min(1vw, 8px) rgba(52, 117, 140, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #34758c, #5f93a9)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #245464",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(52, 117, 140, 0.6)",
    },
  },
  glabrezu: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(132, 187, 67, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(68, 97, 34, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(193, 221, 160, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #445448, #446122, #728e57)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(132, 187, 67, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(114, 142, 87, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #84bb43, #728e57, #c1dda0, #84bb43, #446122)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(132, 187, 67, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(132, 187, 67, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(193, 221, 160, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(132, 187, 67, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(68, 97, 34, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #445448, #446122, #728e57)",
      border: "min(0.25vw, 2px) solid #84bb43",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(132, 187, 67, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(132, 187, 67, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(114, 142, 87, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #84bb43, #728e57, #c1dda0, #84bb43, #446122)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(132, 187, 67, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(132, 187, 67, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(114, 142, 87, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #445448, #446122)",
      color: "#a0bb81",
      accentColor: "#84bb43",
      border: "min(0.25vw, 2px) solid #84bb43",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #446122, #445448)",
    },
    stat: {
      background: "rgba(68, 97, 34, 0.8)",
      border: "min(0.25vw, 2px) solid #84bb43",
      color: "#c1dda0",
      boxShadow: "0 0 min(1vw, 8px) rgba(132, 187, 67, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #84bb43, #728e57)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #446122",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(132, 187, 67, 0.6)",
    },
  },
  goat: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(208, 169, 126, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(92, 52, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(251, 229, 155, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #534933, #5c3424, #a48154)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(208, 169, 126, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(164, 129, 84, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d0a97e, #a48154, #fbe59b, #d0a97e, #5c3424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(208, 169, 126, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(208, 169, 126, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(251, 229, 155, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(208, 169, 126, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(92, 52, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #534933, #5c3424, #a48154)",
      border: "min(0.25vw, 2px) solid #d0a97e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(208, 169, 126, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(208, 169, 126, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(164, 129, 84, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d0a97e, #a48154, #fbe59b, #d0a97e, #5c3424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(208, 169, 126, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(208, 169, 126, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(164, 129, 84, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #534933, #5c3424)",
      color: "#d0c4af",
      accentColor: "#d0a97e",
      border: "min(0.25vw, 2px) solid #d0a97e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5c3424, #534933)",
    },
    stat: {
      background: "rgba(92, 52, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #d0a97e",
      color: "#fbe59b",
      boxShadow: "0 0 min(1vw, 8px) rgba(208, 169, 126, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d0a97e, #a48154)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5c3424",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(208, 169, 126, 0.6)",
    },
  },
  goblin: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(196, 97, 58, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(105, 52, 31, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(224, 173, 152, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b483a, #69341f, #52879f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(196, 97, 58, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(82, 135, 159, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c4613a, #52879f, #e0ad98, #c4613a, #69341f)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(196, 97, 58, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(196, 97, 58, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(224, 173, 152, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(196, 97, 58, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(105, 52, 31, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b483a, #69341f, #52879f)",
      border: "min(0.25vw, 2px) solid #c4613a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(196, 97, 58, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(196, 97, 58, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(82, 135, 159, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c4613a, #52879f, #e0ad98, #c4613a, #69341f)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(196, 97, 58, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(196, 97, 58, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(82, 135, 159, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b483a, #69341f)",
      color: "#aeaf98",
      accentColor: "#c4613a",
      border: "min(0.25vw, 2px) solid #c4613a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #69341f, #4b483a)",
    },
    stat: {
      background: "rgba(105, 52, 31, 0.8)",
      border: "min(0.25vw, 2px) solid #c4613a",
      color: "#e0ad98",
      boxShadow: "0 0 min(1vw, 8px) rgba(196, 97, 58, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c4613a, #52879f)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #69341f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(196, 97, 58, 0.6)",
    },
  },
  goldDragonWyrmling2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(211, 117, 47, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(105, 34, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(245, 228, 145, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3f4455, #692214, #957c86)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(211, 117, 47, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(149, 124, 134, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d3752f, #957c86, #f5e491, #d3752f, #692214)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(211, 117, 47, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(211, 117, 47, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(245, 228, 145, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(211, 117, 47, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(105, 34, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3f4455, #692214, #957c86)",
      border: "min(0.25vw, 2px) solid #d3752f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(211, 117, 47, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(211, 117, 47, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(149, 124, 134, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d3752f, #957c86, #f5e491, #d3752f, #692214)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(211, 117, 47, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(211, 117, 47, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(149, 124, 134, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3f4455, #692214)",
      color: "#c1a4a9",
      accentColor: "#d3752f",
      border: "min(0.25vw, 2px) solid #d3752f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #692214, #3f4455)",
    },
    stat: {
      background: "rgba(105, 34, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #d3752f",
      color: "#f5e491",
      boxShadow: "0 0 min(1vw, 8px) rgba(211, 117, 47, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d3752f, #957c86)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #692214",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(211, 117, 47, 0.6)",
    },
  },
  gorgon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(76, 116, 52, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(60, 86, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(197, 232, 172, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4a5b3a, #3c5624, #799765)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(76, 116, 52, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(121, 151, 101, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4c7434, #799765, #c5e8ac, #4c7434, #3c5624)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 116, 52, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(76, 116, 52, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(197, 232, 172, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(76, 116, 52, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(60, 86, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4a5b3a, #3c5624, #799765)",
      border: "min(0.25vw, 2px) solid #4c7434",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(76, 116, 52, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(76, 116, 52, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(121, 151, 101, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4c7434, #799765, #c5e8ac, #4c7434, #3c5624)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 116, 52, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(76, 116, 52, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(121, 151, 101, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4a5b3a, #3c5624)",
      color: "#bdd1a3",
      accentColor: "#4c7434",
      border: "min(0.25vw, 2px) solid #4c7434",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3c5624, #4a5b3a)",
    },
    stat: {
      background: "rgba(60, 86, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #4c7434",
      color: "#c5e8ac",
      boxShadow: "0 0 min(1vw, 8px) rgba(76, 116, 52, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4c7434, #799765)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #3c5624",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(76, 116, 52, 0.6)",
    },
  },
  greenDragonWyrmling: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(174, 144, 80, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(90, 75, 41, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(225, 214, 190, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5f4736, #5a4b29, #8ca464)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(174, 144, 80, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(140, 164, 100, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ae9050, #8ca464, #e1d6be, #ae9050, #5a4b29)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(174, 144, 80, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(174, 144, 80, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(225, 214, 190, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(174, 144, 80, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(90, 75, 41, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5f4736, #5a4b29, #8ca464)",
      border: "min(0.25vw, 2px) solid #ae9050",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(174, 144, 80, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(174, 144, 80, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(140, 164, 100, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ae9050, #8ca464, #e1d6be, #ae9050, #5a4b29)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(174, 144, 80, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(174, 144, 80, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(140, 164, 100, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5f4736, #5a4b29)",
      color: "#abbccb",
      accentColor: "#ae9050",
      border: "min(0.25vw, 2px) solid #ae9050",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5a4b29, #5f4736)",
    },
    stat: {
      background: "rgba(90, 75, 41, 0.8)",
      border: "min(0.25vw, 2px) solid #ae9050",
      color: "#e1d6be",
      boxShadow: "0 0 min(1vw, 8px) rgba(174, 144, 80, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ae9050, #8ca464)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5a4b29",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(174, 144, 80, 0.6)",
    },
  },
  greenHag: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(93, 133, 58, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(87, 61, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(186, 214, 162, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #345541, #573d24, #63a493)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(93, 133, 58, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(99, 164, 147, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5d853a, #63a493, #bad6a2, #5d853a, #573d24)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(93, 133, 58, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(93, 133, 58, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(186, 214, 162, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(93, 133, 58, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(87, 61, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #345541, #573d24, #63a493)",
      border: "min(0.25vw, 2px) solid #5d853a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(93, 133, 58, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(93, 133, 58, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(99, 164, 147, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5d853a, #63a493, #bad6a2, #5d853a, #573d24)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(93, 133, 58, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(93, 133, 58, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(99, 164, 147, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #345541, #573d24)",
      color: "#82bba7",
      accentColor: "#5d853a",
      border: "min(0.25vw, 2px) solid #5d853a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #573d24, #345541)",
    },
    stat: {
      background: "rgba(87, 61, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #5d853a",
      color: "#bad6a2",
      boxShadow: "0 0 min(1vw, 8px) rgba(93, 133, 58, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5d853a, #63a493)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #573d24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(93, 133, 58, 0.6)",
    },
  },
  griffon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(172, 129, 79, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(140, 99, 61, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(213, 190, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #54633d, #8c633d, #769c59)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(172, 129, 79, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(118, 156, 89, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ac814f, #769c59, #d5bea4, #ac814f, #8c633d)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(172, 129, 79, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(172, 129, 79, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(213, 190, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(172, 129, 79, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(140, 99, 61, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #54633d, #8c633d, #769c59)",
      border: "min(0.25vw, 2px) solid #ac814f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(172, 129, 79, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(172, 129, 79, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(118, 156, 89, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ac814f, #769c59, #d5bea4, #ac814f, #8c633d)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(172, 129, 79, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(172, 129, 79, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(118, 156, 89, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #54633d, #8c633d)",
      color: "#bbbcbd",
      accentColor: "#ac814f",
      border: "min(0.25vw, 2px) solid #ac814f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #8c633d, #54633d)",
    },
    stat: {
      background: "rgba(140, 99, 61, 0.8)",
      border: "min(0.25vw, 2px) solid #ac814f",
      color: "#d5bea4",
      boxShadow: "0 0 min(1vw, 8px) rgba(172, 129, 79, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ac814f, #769c59)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #8c633d",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(172, 129, 79, 0.6)",
    },
  },
  guard2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(195, 148, 89, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(96, 55, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(219, 192, 157, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5a432d, #603714, #978656)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(195, 148, 89, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(151, 134, 86, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c39459, #978656, #dbc09d, #c39459, #603714)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(195, 148, 89, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(195, 148, 89, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(219, 192, 157, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(195, 148, 89, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(96, 55, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5a432d, #603714, #978656)",
      border: "min(0.25vw, 2px) solid #c39459",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(195, 148, 89, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(195, 148, 89, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(151, 134, 86, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c39459, #978656, #dbc09d, #c39459, #603714)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(195, 148, 89, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(195, 148, 89, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(151, 134, 86, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5a432d, #603714)",
      color: "#979fa0",
      accentColor: "#c39459",
      border: "min(0.25vw, 2px) solid #c39459",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #603714, #5a432d)",
    },
    stat: {
      background: "rgba(96, 55, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #c39459",
      color: "#dbc09d",
      boxShadow: "0 0 min(1vw, 8px) rgba(195, 148, 89, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c39459, #978656)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #603714",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(195, 148, 89, 0.6)",
    },
  },
  halfRedDragonVeteran2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(203, 78, 53, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(152, 52, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(227, 162, 149, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #573a35, #983414, #94504c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(203, 78, 53, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(148, 80, 76, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #cb4e35, #94504c, #e3a295, #cb4e35, #983414)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(203, 78, 53, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(203, 78, 53, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(227, 162, 149, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(203, 78, 53, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(152, 52, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #573a35, #983414, #94504c)",
      border: "min(0.25vw, 2px) solid #cb4e35",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(203, 78, 53, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(203, 78, 53, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(148, 80, 76, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #cb4e35, #94504c, #e3a295, #cb4e35, #983414)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(203, 78, 53, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(203, 78, 53, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(148, 80, 76, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #573a35, #983414)",
      color: "#92a37b",
      accentColor: "#cb4e35",
      border: "min(0.25vw, 2px) solid #cb4e35",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #983414, #573a35)",
    },
    stat: {
      background: "rgba(152, 52, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #cb4e35",
      color: "#e3a295",
      boxShadow: "0 0 min(1vw, 8px) rgba(203, 78, 53, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #cb4e35, #94504c)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #983414",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(203, 78, 53, 0.6)",
    },
  },
  hellHound: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(230, 78, 44, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(117, 48, 41, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(246, 149, 64, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #574534, #753029, #ac614b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(230, 78, 44, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(172, 97, 75, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e64e2c, #ac614b, #f69540, #e64e2c, #753029)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(230, 78, 44, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(230, 78, 44, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(246, 149, 64, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(230, 78, 44, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(117, 48, 41, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #574534, #753029, #ac614b)",
      border: "min(0.25vw, 2px) solid #e64e2c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(230, 78, 44, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(230, 78, 44, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(172, 97, 75, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e64e2c, #ac614b, #f69540, #e64e2c, #753029)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(230, 78, 44, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(230, 78, 44, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(172, 97, 75, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #574534, #753029)",
      color: "#b8b1a6",
      accentColor: "#e64e2c",
      border: "min(0.25vw, 2px) solid #e64e2c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #753029, #574534)",
    },
    stat: {
      background: "rgba(117, 48, 41, 0.8)",
      border: "min(0.25vw, 2px) solid #e64e2c",
      color: "#f69540",
      boxShadow: "0 0 min(1vw, 8px) rgba(230, 78, 44, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e64e2c, #ac614b)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #753029",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(230, 78, 44, 0.6)",
    },
  },
  hillGiant: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(152, 137, 102, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(79, 71, 53, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(201, 193, 175, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3d4f37, #4f4735, #5b7e4e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(152, 137, 102, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(91, 126, 78, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #988966, #5b7e4e, #c9c1af, #988966, #4f4735)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(152, 137, 102, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(152, 137, 102, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(201, 193, 175, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(152, 137, 102, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(79, 71, 53, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3d4f37, #4f4735, #5b7e4e)",
      border: "min(0.25vw, 2px) solid #988966",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(152, 137, 102, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(152, 137, 102, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(91, 126, 78, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #988966, #5b7e4e, #c9c1af, #988966, #4f4735)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(152, 137, 102, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(152, 137, 102, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(91, 126, 78, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3d4f37, #4f4735)",
      color: "#cac2b0",
      accentColor: "#988966",
      border: "min(0.25vw, 2px) solid #988966",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #4f4735, #3d4f37)",
    },
    stat: {
      background: "rgba(79, 71, 53, 0.8)",
      border: "min(0.25vw, 2px) solid #988966",
      color: "#c9c1af",
      boxShadow: "0 0 min(1vw, 8px) rgba(152, 137, 102, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #988966, #5b7e4e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #4f4735",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(152, 137, 102, 0.6)",
    },
  },
  hobgoblin: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(131, 178, 76, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(62, 84, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(190, 215, 162, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #485b30, #3e5424, #637e78)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(131, 178, 76, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(99, 126, 120, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #83b24c, #637e78, #bed7a2, #83b24c, #3e5424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(131, 178, 76, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(131, 178, 76, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(190, 215, 162, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(131, 178, 76, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(62, 84, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #485b30, #3e5424, #637e78)",
      border: "min(0.25vw, 2px) solid #83b24c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(131, 178, 76, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(131, 178, 76, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(99, 126, 120, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #83b24c, #637e78, #bed7a2, #83b24c, #3e5424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(131, 178, 76, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(131, 178, 76, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(99, 126, 120, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #485b30, #3e5424)",
      color: "#b6c2b3",
      accentColor: "#83b24c",
      border: "min(0.25vw, 2px) solid #83b24c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3e5424, #485b30)",
    },
    stat: {
      background: "rgba(62, 84, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #83b24c",
      color: "#bed7a2",
      boxShadow: "0 0 min(1vw, 8px) rgba(131, 178, 76, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #83b24c, #637e78)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #3e5424",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(131, 178, 76, 0.6)",
    },
  },
  homunculus: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(120, 50, 102, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(88, 36, 77, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(216, 161, 201, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #39414e, #58244d, #a55a8d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(120, 50, 102, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(165, 90, 141, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #783266, #a55a8d, #d8a1c9, #783266, #58244d)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(120, 50, 102, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(120, 50, 102, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(216, 161, 201, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(120, 50, 102, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(88, 36, 77, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #39414e, #58244d, #a55a8d)",
      border: "min(0.25vw, 2px) solid #783266",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(120, 50, 102, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(120, 50, 102, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(165, 90, 141, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #783266, #a55a8d, #d8a1c9, #783266, #58244d)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(120, 50, 102, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(120, 50, 102, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(165, 90, 141, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #39414e, #58244d)",
      color: "#c3c0b2",
      accentColor: "#783266",
      border: "min(0.25vw, 2px) solid #783266",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #58244d, #39414e)",
    },
    stat: {
      background: "rgba(88, 36, 77, 0.8)",
      border: "min(0.25vw, 2px) solid #783266",
      color: "#d8a1c9",
      boxShadow: "0 0 min(1vw, 8px) rgba(120, 50, 102, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #783266, #a55a8d)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #58244d",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(120, 50, 102, 0.6)",
    },
  },
  homunculus2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(109, 54, 44, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(84, 28, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(216, 169, 160, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5a4235, #541c24, #7a5a43)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(109, 54, 44, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(122, 90, 67, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #6d362c, #7a5a43, #d8a9a0, #6d362c, #541c24)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(109, 54, 44, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(109, 54, 44, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(216, 169, 160, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(109, 54, 44, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(84, 28, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5a4235, #541c24, #7a5a43)",
      border: "min(0.25vw, 2px) solid #6d362c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(109, 54, 44, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(109, 54, 44, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(122, 90, 67, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #6d362c, #7a5a43, #d8a9a0, #6d362c, #541c24)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(109, 54, 44, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(109, 54, 44, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(122, 90, 67, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5a4235, #541c24)",
      color: "#b99472",
      accentColor: "#6d362c",
      border: "min(0.25vw, 2px) solid #6d362c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #541c24, #5a4235)",
    },
    stat: {
      background: "rgba(84, 28, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #6d362c",
      color: "#d8a9a0",
      boxShadow: "0 0 min(1vw, 8px) rgba(109, 54, 44, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #6d362c, #7a5a43)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #541c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(109, 54, 44, 0.6)",
    },
  },
  hydra: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(76, 108, 52, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(12, 20, 4, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(185, 211, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #405435, #0c1404, #6f7782)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(76, 108, 52, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(111, 119, 130, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4c6c34, #6f7782, #b9d3a5, #4c6c34, #0c1404)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 108, 52, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(76, 108, 52, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(185, 211, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(76, 108, 52, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(12, 20, 4, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #405435, #0c1404, #6f7782)",
      border: "min(0.25vw, 2px) solid #4c6c34",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(76, 108, 52, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(76, 108, 52, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(111, 119, 130, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4c6c34, #6f7782, #b9d3a5, #4c6c34, #0c1404)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(76, 108, 52, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(76, 108, 52, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(111, 119, 130, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #405435, #0c1404)",
      color: "#bdc2c6",
      accentColor: "#4c6c34",
      border: "min(0.25vw, 2px) solid #4c6c34",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0c1404, #405435)",
    },
    stat: {
      background: "rgba(12, 20, 4, 0.8)",
      border: "min(0.25vw, 2px) solid #4c6c34",
      color: "#b9d3a5",
      boxShadow: "0 0 min(1vw, 8px) rgba(76, 108, 52, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4c6c34, #6f7782)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #0c1404",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(76, 108, 52, 0.6)",
    },
  },
  iceDevil: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(58, 103, 136, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(17, 63, 95, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(156, 196, 210, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #304a61, #113f5f, #5685a1)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(58, 103, 136, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(86, 133, 161, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3a6788, #5685a1, #9cc4d2, #3a6788, #113f5f)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(58, 103, 136, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(58, 103, 136, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(156, 196, 210, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(58, 103, 136, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(17, 63, 95, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #304a61, #113f5f, #5685a1)",
      border: "min(0.25vw, 2px) solid #3a6788",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(58, 103, 136, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(58, 103, 136, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(86, 133, 161, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3a6788, #5685a1, #9cc4d2, #3a6788, #113f5f)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(58, 103, 136, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(58, 103, 136, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(86, 133, 161, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #304a61, #113f5f)",
      color: "#c0d4d9",
      accentColor: "#3a6788",
      border: "min(0.25vw, 2px) solid #3a6788",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #113f5f, #304a61)",
    },
    stat: {
      background: "rgba(17, 63, 95, 0.8)",
      border: "min(0.25vw, 2px) solid #3a6788",
      color: "#9cc4d2",
      boxShadow: "0 0 min(1vw, 8px) rgba(58, 103, 136, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3a6788, #5685a1)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #113f5f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(58, 103, 136, 0.6)",
    },
  },
  knight2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(172, 180, 69, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(133, 146, 58, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(247, 247, 212, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #46475a, #85923a, #868381)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(172, 180, 69, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(134, 131, 129, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #acb445, #868381, #f7f7d4, #acb445, #85923a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(172, 180, 69, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(172, 180, 69, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(247, 247, 212, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(172, 180, 69, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(133, 146, 58, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #46475a, #85923a, #868381)",
      border: "min(0.25vw, 2px) solid #acb445",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(172, 180, 69, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(172, 180, 69, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(134, 131, 129, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #acb445, #868381, #f7f7d4, #acb445, #85923a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(172, 180, 69, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(172, 180, 69, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(134, 131, 129, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #46475a, #85923a)",
      color: "#b2b67a",
      accentColor: "#acb445",
      border: "min(0.25vw, 2px) solid #acb445",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #85923a, #46475a)",
    },
    stat: {
      background: "rgba(133, 146, 58, 0.8)",
      border: "min(0.25vw, 2px) solid #acb445",
      color: "#f7f7d4",
      boxShadow: "0 0 min(1vw, 8px) rgba(172, 180, 69, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #acb445, #868381)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #85923a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(172, 180, 69, 0.6)",
    },
  },
  knight4: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(185, 71, 69, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(85, 33, 32, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(218, 159, 158, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3d4e30, #552120, #698691)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(185, 71, 69, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(105, 134, 145, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b94745, #698691, #da9f9e, #b94745, #552120)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 71, 69, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(185, 71, 69, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(218, 159, 158, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(185, 71, 69, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(85, 33, 32, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3d4e30, #552120, #698691)",
      border: "min(0.25vw, 2px) solid #b94745",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(185, 71, 69, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(185, 71, 69, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(105, 134, 145, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b94745, #698691, #da9f9e, #b94745, #552120)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 71, 69, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(185, 71, 69, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(105, 134, 145, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3d4e30, #552120)",
      color: "#b3ccd1",
      accentColor: "#b94745",
      border: "min(0.25vw, 2px) solid #b94745",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #552120, #3d4e30)",
    },
    stat: {
      background: "rgba(85, 33, 32, 0.8)",
      border: "min(0.25vw, 2px) solid #b94745",
      color: "#da9f9e",
      boxShadow: "0 0 min(1vw, 8px) rgba(185, 71, 69, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b94745, #698691)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #552120",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(185, 71, 69, 0.6)",
    },
  },
  kobold: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(65, 192, 202, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(136, 86, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(151, 220, 226, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #465334, #88560c, #517735)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(65, 192, 202, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(81, 119, 53, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #41c0ca, #517735, #97dce2, #41c0ca, #88560c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(65, 192, 202, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(65, 192, 202, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(151, 220, 226, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(65, 192, 202, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(136, 86, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #465334, #88560c, #517735)",
      border: "min(0.25vw, 2px) solid #41c0ca",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(65, 192, 202, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(65, 192, 202, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(81, 119, 53, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #41c0ca, #517735, #97dce2, #41c0ca, #88560c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(65, 192, 202, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(65, 192, 202, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(81, 119, 53, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #465334, #88560c)",
      color: "#217177",
      accentColor: "#41c0ca",
      border: "min(0.25vw, 2px) solid #41c0ca",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #88560c, #465334)",
    },
    stat: {
      background: "rgba(136, 86, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #41c0ca",
      color: "#97dce2",
      boxShadow: "0 0 min(1vw, 8px) rgba(65, 192, 202, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #41c0ca, #517735)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #88560c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(65, 192, 202, 0.6)",
    },
  },
  kraken: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(99, 144, 69, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 76, 108, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(184, 212, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2b3e56, #1c4c6c, #4f7694)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(99, 144, 69, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(79, 118, 148, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #639045, #4f7694, #b8d4a5, #639045, #1c4c6c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(99, 144, 69, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(99, 144, 69, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(184, 212, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(99, 144, 69, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 76, 108, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2b3e56, #1c4c6c, #4f7694)",
      border: "min(0.25vw, 2px) solid #639045",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(99, 144, 69, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(99, 144, 69, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(79, 118, 148, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #639045, #4f7694, #b8d4a5, #639045, #1c4c6c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(99, 144, 69, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(99, 144, 69, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(79, 118, 148, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2b3e56, #1c4c6c)",
      color: "#bdd7dd",
      accentColor: "#639045",
      border: "min(0.25vw, 2px) solid #639045",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c4c6c, #2b3e56)",
    },
    stat: {
      background: "rgba(28, 76, 108, 0.8)",
      border: "min(0.25vw, 2px) solid #639045",
      color: "#b8d4a5",
      boxShadow: "0 0 min(1vw, 8px) rgba(99, 144, 69, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #639045, #4f7694)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #1c4c6c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(99, 144, 69, 0.6)",
    },
  },
  lich: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(82, 187, 67, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(44, 100, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(165, 219, 157, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #624a35, #2c6424, #79827b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(82, 187, 67, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(121, 130, 123, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #52bb43, #79827b, #a5db9d, #52bb43, #2c6424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(82, 187, 67, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(82, 187, 67, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(165, 219, 157, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(82, 187, 67, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(44, 100, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #624a35, #2c6424, #79827b)",
      border: "min(0.25vw, 2px) solid #52bb43",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(82, 187, 67, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(82, 187, 67, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(121, 130, 123, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #52bb43, #79827b, #a5db9d, #52bb43, #2c6424)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(82, 187, 67, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(82, 187, 67, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(121, 130, 123, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #624a35, #2c6424)",
      color: "#b1c9b2",
      accentColor: "#52bb43",
      border: "min(0.25vw, 2px) solid #52bb43",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2c6424, #624a35)",
    },
    stat: {
      background: "rgba(44, 100, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #52bb43",
      color: "#a5db9d",
      boxShadow: "0 0 min(1vw, 8px) rgba(82, 187, 67, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #52bb43, #79827b)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #2c6424",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(82, 187, 67, 0.6)",
    },
  },
  lich2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(127, 191, 106, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 116, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(175, 215, 162, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #32472c, #24742c, #5b7f4f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(127, 191, 106, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(91, 127, 79, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7fbf6a, #5b7f4f, #afd7a2, #7fbf6a, #24742c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(127, 191, 106, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(127, 191, 106, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(175, 215, 162, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(127, 191, 106, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 116, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #32472c, #24742c, #5b7f4f)",
      border: "min(0.25vw, 2px) solid #7fbf6a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(127, 191, 106, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(127, 191, 106, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(91, 127, 79, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7fbf6a, #5b7f4f, #afd7a2, #7fbf6a, #24742c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(127, 191, 106, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(127, 191, 106, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(91, 127, 79, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #32472c, #24742c)",
      color: "#9d9c81",
      accentColor: "#7fbf6a",
      border: "min(0.25vw, 2px) solid #7fbf6a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #24742c, #32472c)",
    },
    stat: {
      background: "rgba(36, 116, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #7fbf6a",
      color: "#afd7a2",
      boxShadow: "0 0 min(1vw, 8px) rgba(127, 191, 106, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7fbf6a, #5b7f4f)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #24742c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(127, 191, 106, 0.6)",
    },
  },
  lizardfolk2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(125, 172, 82, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(29, 40, 19, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(187, 212, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #415733, #1d2813, #7f9296)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(125, 172, 82, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(127, 146, 150, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7dac52, #7f9296, #bbd4a5, #7dac52, #1d2813)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(125, 172, 82, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(125, 172, 82, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(187, 212, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(125, 172, 82, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(29, 40, 19, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #415733, #1d2813, #7f9296)",
      border: "min(0.25vw, 2px) solid #7dac52",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(125, 172, 82, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(125, 172, 82, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(127, 146, 150, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7dac52, #7f9296, #bbd4a5, #7dac52, #1d2813)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(125, 172, 82, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(125, 172, 82, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(127, 146, 150, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #415733, #1d2813)",
      color: "#c8c0ad",
      accentColor: "#7dac52",
      border: "min(0.25vw, 2px) solid #7dac52",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1d2813, #415733)",
    },
    stat: {
      background: "rgba(29, 40, 19, 0.8)",
      border: "min(0.25vw, 2px) solid #7dac52",
      color: "#bbd4a5",
      boxShadow: "0 0 min(1vw, 8px) rgba(125, 172, 82, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7dac52, #7f9296)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1d2813",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(125, 172, 82, 0.6)",
    },
  },
  magmaMephit: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(240, 158, 44, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(138, 65, 19, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(248, 221, 116, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #573331, #8a4113, #996258)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(240, 158, 44, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(153, 98, 88, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #f09e2c, #996258, #f8dd74, #f09e2c, #8a4113)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(240, 158, 44, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(240, 158, 44, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(248, 221, 116, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(240, 158, 44, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(138, 65, 19, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #573331, #8a4113, #996258)",
      border: "min(0.25vw, 2px) solid #f09e2c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(240, 158, 44, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(240, 158, 44, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(153, 98, 88, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #f09e2c, #996258, #f8dd74, #f09e2c, #8a4113)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(240, 158, 44, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(240, 158, 44, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(153, 98, 88, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #573331, #8a4113)",
      color: "#b4aca0",
      accentColor: "#f09e2c",
      border: "min(0.25vw, 2px) solid #f09e2c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #8a4113, #573331)",
    },
    stat: {
      background: "rgba(138, 65, 19, 0.8)",
      border: "min(0.25vw, 2px) solid #f09e2c",
      color: "#f8dd74",
      boxShadow: "0 0 min(1vw, 8px) rgba(240, 158, 44, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #f09e2c, #996258)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #8a4113",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(240, 158, 44, 0.6)",
    },
  },
  magmaMephit3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(230, 78, 37, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(103, 30, 19, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(249, 213, 127, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #542f2e, #671e13, #a95955)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(230, 78, 37, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(169, 89, 85, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e64e25, #a95955, #f9d57f, #e64e25, #671e13)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(230, 78, 37, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(230, 78, 37, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(249, 213, 127, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(230, 78, 37, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(103, 30, 19, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #542f2e, #671e13, #a95955)",
      border: "min(0.25vw, 2px) solid #e64e25",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(230, 78, 37, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(230, 78, 37, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(169, 89, 85, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e64e25, #a95955, #f9d57f, #e64e25, #671e13)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(230, 78, 37, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(230, 78, 37, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(169, 89, 85, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #542f2e, #671e13)",
      color: "#d4b49c",
      accentColor: "#e64e25",
      border: "min(0.25vw, 2px) solid #e64e25",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #671e13, #542f2e)",
    },
    stat: {
      background: "rgba(103, 30, 19, 0.8)",
      border: "min(0.25vw, 2px) solid #e64e25",
      color: "#f9d57f",
      boxShadow: "0 0 min(1vw, 8px) rgba(230, 78, 37, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e64e25, #a95955)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #671e13",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(230, 78, 37, 0.6)",
    },
  },
  magmaMephit4: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(206, 88, 42, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(143, 33, 13, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(248, 222, 78, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4f2e29, #8f210d, #945d52)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(206, 88, 42, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(148, 93, 82, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ce582a, #945d52, #f8de4e, #ce582a, #8f210d)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(206, 88, 42, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(206, 88, 42, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(248, 222, 78, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(206, 88, 42, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(143, 33, 13, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4f2e29, #8f210d, #945d52)",
      border: "min(0.25vw, 2px) solid #ce582a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(206, 88, 42, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(206, 88, 42, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(148, 93, 82, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ce582a, #945d52, #f8de4e, #ce582a, #8f210d)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(206, 88, 42, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(206, 88, 42, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(148, 93, 82, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4f2e29, #8f210d)",
      color: "#bfa69b",
      accentColor: "#ce582a",
      border: "min(0.25vw, 2px) solid #ce582a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #8f210d, #4f2e29)",
    },
    stat: {
      background: "rgba(143, 33, 13, 0.8)",
      border: "min(0.25vw, 2px) solid #ce582a",
      color: "#f8de4e",
      boxShadow: "0 0 min(1vw, 8px) rgba(206, 88, 42, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ce582a, #945d52)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #8f210d",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(206, 88, 42, 0.6)",
    },
  },
  magmaMephit5: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(231, 91, 44, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(99, 19, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(247, 217, 128, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #372221, #63130c, #84777d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(231, 91, 44, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(132, 119, 125, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #e75b2c, #84777d, #f7d980, #e75b2c, #63130c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(231, 91, 44, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(231, 91, 44, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(247, 217, 128, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(231, 91, 44, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(99, 19, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #372221, #63130c, #84777d)",
      border: "min(0.25vw, 2px) solid #e75b2c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(231, 91, 44, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(231, 91, 44, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(132, 119, 125, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #e75b2c, #84777d, #f7d980, #e75b2c, #63130c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(231, 91, 44, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(231, 91, 44, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(132, 119, 125, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #372221, #63130c)",
      color: "#c6a99a",
      accentColor: "#e75b2c",
      border: "min(0.25vw, 2px) solid #e75b2c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #63130c, #372221)",
    },
    stat: {
      background: "rgba(99, 19, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #e75b2c",
      color: "#f7d980",
      boxShadow: "0 0 min(1vw, 8px) rgba(231, 91, 44, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #e75b2c, #84777d)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #63130c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(231, 91, 44, 0.6)",
    },
  },
  mammoth: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(143, 175, 79, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 44, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(212, 201, 148, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3b482b, #242c14, #949f69)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(143, 175, 79, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(148, 159, 105, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #8faf4f, #949f69, #d4c994, #8faf4f, #242c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(143, 175, 79, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(143, 175, 79, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(212, 201, 148, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(143, 175, 79, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 44, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3b482b, #242c14, #949f69)",
      border: "min(0.25vw, 2px) solid #8faf4f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(143, 175, 79, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(143, 175, 79, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(148, 159, 105, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #8faf4f, #949f69, #d4c994, #8faf4f, #242c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(143, 175, 79, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(143, 175, 79, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(148, 159, 105, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3b482b, #242c14)",
      color: "#cccaaf",
      accentColor: "#8faf4f",
      border: "min(0.25vw, 2px) solid #8faf4f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #242c14, #3b482b)",
    },
    stat: {
      background: "rgba(36, 44, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #8faf4f",
      color: "#d4c994",
      boxShadow: "0 0 min(1vw, 8px) rgba(143, 175, 79, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #8faf4f, #949f69)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #242c14",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(143, 175, 79, 0.6)",
    },
  },
  marilith2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(84, 108, 52, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(69, 89, 43, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(192, 211, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #36445c, #45592b, #739a52)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(84, 108, 52, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(115, 154, 82, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #546c34, #739a52, #c0d3a5, #546c34, #45592b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(84, 108, 52, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(84, 108, 52, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(192, 211, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(84, 108, 52, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(69, 89, 43, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #36445c, #45592b, #739a52)",
      border: "min(0.25vw, 2px) solid #546c34",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(84, 108, 52, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(84, 108, 52, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(115, 154, 82, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #546c34, #739a52, #c0d3a5, #546c34, #45592b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(84, 108, 52, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(84, 108, 52, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(115, 154, 82, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #36445c, #45592b)",
      color: "#8ba5ba",
      accentColor: "#546c34",
      border: "min(0.25vw, 2px) solid #546c34",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #45592b, #36445c)",
    },
    stat: {
      background: "rgba(69, 89, 43, 0.8)",
      border: "min(0.25vw, 2px) solid #546c34",
      color: "#c0d3a5",
      boxShadow: "0 0 min(1vw, 8px) rgba(84, 108, 52, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #546c34, #739a52)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #45592b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(84, 108, 52, 0.6)",
    },
  },
  mastiff: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(108, 78, 52, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(89, 64, 43, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(211, 187, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #494934, #59402b, #6c7885)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(108, 78, 52, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 120, 133, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #6c4e34, #6c7885, #d3bba5, #6c4e34, #59402b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(108, 78, 52, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(108, 78, 52, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(211, 187, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(108, 78, 52, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(89, 64, 43, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #494934, #59402b, #6c7885)",
      border: "min(0.25vw, 2px) solid #6c4e34",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(108, 78, 52, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(108, 78, 52, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 120, 133, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #6c4e34, #6c7885, #d3bba5, #6c4e34, #59402b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(108, 78, 52, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(108, 78, 52, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 120, 133, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #494934, #59402b)",
      color: "#b8b3c2",
      accentColor: "#6c4e34",
      border: "min(0.25vw, 2px) solid #6c4e34",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #59402b, #494934)",
    },
    stat: {
      background: "rgba(89, 64, 43, 0.8)",
      border: "min(0.25vw, 2px) solid #6c4e34",
      color: "#d3bba5",
      boxShadow: "0 0 min(1vw, 8px) rgba(108, 78, 52, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #6c4e34, #6c7885)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #59402b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(108, 78, 52, 0.6)",
    },
  },
  medusa: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(183, 119, 71, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(92, 60, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(217, 184, 159, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #404c39, #5c3c24, #7f9c73)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(183, 119, 71, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(127, 156, 115, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b77747, #7f9c73, #d9b89f, #b77747, #5c3c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(183, 119, 71, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(183, 119, 71, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(217, 184, 159, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(183, 119, 71, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(92, 60, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #404c39, #5c3c24, #7f9c73)",
      border: "min(0.25vw, 2px) solid #b77747",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(183, 119, 71, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(183, 119, 71, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(127, 156, 115, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b77747, #7f9c73, #d9b89f, #b77747, #5c3c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(183, 119, 71, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(183, 119, 71, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(127, 156, 115, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #404c39, #5c3c24)",
      color: "#a9b885",
      accentColor: "#b77747",
      border: "min(0.25vw, 2px) solid #b77747",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5c3c24, #404c39)",
    },
    stat: {
      background: "rgba(92, 60, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #b77747",
      color: "#d9b89f",
      boxShadow: "0 0 min(1vw, 8px) rgba(183, 119, 71, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b77747, #7f9c73)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5c3c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(183, 119, 71, 0.6)",
    },
  },
  merrow: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(52, 182, 206, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(23, 68, 97, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(134, 217, 221, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #315038, #174461, #52919c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(52, 182, 206, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(82, 145, 156, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #34b6ce, #52919c, #86d9dd, #34b6ce, #174461)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(52, 182, 206, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(52, 182, 206, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(134, 217, 221, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(52, 182, 206, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(23, 68, 97, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #315038, #174461, #52919c)",
      border: "min(0.25vw, 2px) solid #34b6ce",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(52, 182, 206, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(52, 182, 206, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(82, 145, 156, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #34b6ce, #52919c, #86d9dd, #34b6ce, #174461)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(52, 182, 206, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(52, 182, 206, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(82, 145, 156, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #315038, #174461)",
      color: "#bae1da",
      accentColor: "#34b6ce",
      border: "min(0.25vw, 2px) solid #34b6ce",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #174461, #315038)",
    },
    stat: {
      background: "rgba(23, 68, 97, 0.8)",
      border: "min(0.25vw, 2px) solid #34b6ce",
      color: "#86d9dd",
      boxShadow: "0 0 min(1vw, 8px) rgba(52, 182, 206, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #34b6ce, #52919c)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #174461",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(52, 182, 206, 0.6)",
    },
  },
  mimic2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(119, 43, 39, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(96, 40, 37, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(222, 158, 155, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5f4e37, #602825, #855944)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(119, 43, 39, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(133, 89, 68, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #772b27, #855944, #de9e9b, #772b27, #602825)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(119, 43, 39, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(119, 43, 39, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(222, 158, 155, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(119, 43, 39, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(96, 40, 37, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5f4e37, #602825, #855944)",
      border: "min(0.25vw, 2px) solid #772b27",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(119, 43, 39, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(119, 43, 39, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(133, 89, 68, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #772b27, #855944, #de9e9b, #772b27, #602825)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(119, 43, 39, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(119, 43, 39, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(133, 89, 68, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5f4e37, #602825)",
      color: "#c1a189",
      accentColor: "#772b27",
      border: "min(0.25vw, 2px) solid #772b27",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #602825, #5f4e37)",
    },
    stat: {
      background: "rgba(96, 40, 37, 0.8)",
      border: "min(0.25vw, 2px) solid #772b27",
      color: "#de9e9b",
      boxShadow: "0 0 min(1vw, 8px) rgba(119, 43, 39, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #772b27, #855944)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #602825",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(119, 43, 39, 0.6)",
    },
  },
  minotaur: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(157, 90, 58, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(52, 76, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(209, 231, 235, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2e3e25, #344c14, #9e8552)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(157, 90, 58, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(158, 133, 82, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #9d5a3a, #9e8552, #d1e7eb, #9d5a3a, #344c14)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(157, 90, 58, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(157, 90, 58, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(209, 231, 235, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(157, 90, 58, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(52, 76, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2e3e25, #344c14, #9e8552)",
      border: "min(0.25vw, 2px) solid #9d5a3a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(157, 90, 58, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(157, 90, 58, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(158, 133, 82, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #9d5a3a, #9e8552, #d1e7eb, #9d5a3a, #344c14)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(157, 90, 58, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(157, 90, 58, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(158, 133, 82, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2e3e25, #344c14)",
      color: "#afc7cc",
      accentColor: "#9d5a3a",
      border: "min(0.25vw, 2px) solid #9d5a3a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #344c14, #2e3e25)",
    },
    stat: {
      background: "rgba(52, 76, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #9d5a3a",
      color: "#d1e7eb",
      boxShadow: "0 0 min(1vw, 8px) rgba(157, 90, 58, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #9d5a3a, #9e8552)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #344c14",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(157, 90, 58, 0.6)",
    },
  },
  minotaurSkeleton: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(130, 81, 55, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(100, 52, 40, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(225, 235, 182, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b4f39, #643428, #84a464)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(130, 81, 55, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(132, 164, 100, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #825137, #84a464, #e1ebb6, #825137, #643428)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(130, 81, 55, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(130, 81, 55, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(225, 235, 182, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(130, 81, 55, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(100, 52, 40, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b4f39, #643428, #84a464)",
      border: "min(0.25vw, 2px) solid #825137",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(130, 81, 55, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(130, 81, 55, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(132, 164, 100, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #825137, #84a464, #e1ebb6, #825137, #643428)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(130, 81, 55, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(130, 81, 55, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(132, 164, 100, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b4f39, #643428)",
      color: "#c5bb99",
      accentColor: "#825137",
      border: "min(0.25vw, 2px) solid #825137",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #643428, #4b4f39)",
    },
    stat: {
      background: "rgba(100, 52, 40, 0.8)",
      border: "min(0.25vw, 2px) solid #825137",
      color: "#e1ebb6",
      boxShadow: "0 0 min(1vw, 8px) rgba(130, 81, 55, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #825137, #84a464)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #643428",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(130, 81, 55, 0.6)",
    },
  },
  mummy: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(170, 149, 72, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(100, 75, 35, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(215, 204, 161, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #414234, #644b23, #947c64)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(170, 149, 72, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(148, 124, 100, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #aa9548, #947c64, #d7cca1, #aa9548, #644b23)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(170, 149, 72, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(170, 149, 72, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(215, 204, 161, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(170, 149, 72, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(100, 75, 35, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #414234, #644b23, #947c64)",
      border: "min(0.25vw, 2px) solid #aa9548",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(170, 149, 72, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(170, 149, 72, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(148, 124, 100, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #aa9548, #947c64, #d7cca1, #aa9548, #644b23)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(170, 149, 72, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(170, 149, 72, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(148, 124, 100, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #414234, #644b23)",
      color: "#d4ccac",
      accentColor: "#aa9548",
      border: "min(0.25vw, 2px) solid #aa9548",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #644b23, #414234)",
    },
    stat: {
      background: "rgba(100, 75, 35, 0.8)",
      border: "min(0.25vw, 2px) solid #aa9548",
      color: "#d7cca1",
      boxShadow: "0 0 min(1vw, 8px) rgba(170, 149, 72, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #aa9548, #947c64)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #644b23",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(170, 149, 72, 0.6)",
    },
  },
  mummyLord: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(173, 148, 78, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(100, 86, 34, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(229, 215, 155, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b4032, #645622, #947c64)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(173, 148, 78, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(148, 124, 100, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ad944e, #947c64, #e5d79b, #ad944e, #645622)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(173, 148, 78, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(173, 148, 78, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(229, 215, 155, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(173, 148, 78, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(100, 86, 34, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b4032, #645622, #947c64)",
      border: "min(0.25vw, 2px) solid #ad944e",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(173, 148, 78, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(173, 148, 78, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(148, 124, 100, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ad944e, #947c64, #e5d79b, #ad944e, #645622)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(173, 148, 78, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(173, 148, 78, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(148, 124, 100, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b4032, #645622)",
      color: "#cdc3ae",
      accentColor: "#ad944e",
      border: "min(0.25vw, 2px) solid #ad944e",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #645622, #4b4032)",
    },
    stat: {
      background: "rgba(100, 86, 34, 0.8)",
      border: "min(0.25vw, 2px) solid #ad944e",
      color: "#e5d79b",
      boxShadow: "0 0 min(1vw, 8px) rgba(173, 148, 78, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ad944e, #947c64)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #645622",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(173, 148, 78, 0.6)",
    },
  },
  nalfeshnee2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(122, 176, 85, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(39, 57, 25, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(184, 212, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2c3b48, #273919, #508095)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(122, 176, 85, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(80, 128, 149, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7ab055, #508095, #b8d4a4, #7ab055, #273919)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(122, 176, 85, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(122, 176, 85, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(184, 212, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(122, 176, 85, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(39, 57, 25, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2c3b48, #273919, #508095)",
      border: "min(0.25vw, 2px) solid #7ab055",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(122, 176, 85, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(122, 176, 85, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(80, 128, 149, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7ab055, #508095, #b8d4a4, #7ab055, #273919)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(122, 176, 85, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(122, 176, 85, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(80, 128, 149, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2c3b48, #273919)",
      color: "#b9dbd2",
      accentColor: "#7ab055",
      border: "min(0.25vw, 2px) solid #7ab055",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #273919, #2c3b48)",
    },
    stat: {
      background: "rgba(39, 57, 25, 0.8)",
      border: "min(0.25vw, 2px) solid #7ab055",
      color: "#b8d4a4",
      boxShadow: "0 0 min(1vw, 8px) rgba(122, 176, 85, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7ab055, #508095)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #273919",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(122, 176, 85, 0.6)",
    },
  },
  orc: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(132, 179, 197, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(68, 90, 40, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(164, 199, 212, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2c4454, #445a28, #577b94)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(132, 179, 197, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(87, 123, 148, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #84b3c5, #577b94, #a4c7d4, #84b3c5, #445a28)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(132, 179, 197, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(132, 179, 197, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(164, 199, 212, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(132, 179, 197, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(68, 90, 40, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2c4454, #445a28, #577b94)",
      border: "min(0.25vw, 2px) solid #84b3c5",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(132, 179, 197, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(132, 179, 197, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(87, 123, 148, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #84b3c5, #577b94, #a4c7d4, #84b3c5, #445a28)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(132, 179, 197, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(132, 179, 197, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(87, 123, 148, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2c4454, #445a28)",
      color: "#adc0c1",
      accentColor: "#84b3c5",
      border: "min(0.25vw, 2px) solid #84b3c5",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #445a28, #2c4454)",
    },
    stat: {
      background: "rgba(68, 90, 40, 0.8)",
      border: "min(0.25vw, 2px) solid #84b3c5",
      color: "#a4c7d4",
      boxShadow: "0 0 min(1vw, 8px) rgba(132, 179, 197, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #84b3c5, #577b94)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #445a28",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(132, 179, 197, 0.6)",
    },
  },
  phaseSpider: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(73, 123, 186, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(20, 63, 107, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(158, 185, 218, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #253856, #143f6b, #5f589f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(73, 123, 186, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(95, 88, 159, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #497bba, #5f589f, #9eb9da, #497bba, #143f6b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(73, 123, 186, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(73, 123, 186, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(158, 185, 218, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(73, 123, 186, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(20, 63, 107, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #253856, #143f6b, #5f589f)",
      border: "min(0.25vw, 2px) solid #497bba",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(73, 123, 186, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(73, 123, 186, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(95, 88, 159, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #497bba, #5f589f, #9eb9da, #497bba, #143f6b)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(73, 123, 186, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(73, 123, 186, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(95, 88, 159, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #253856, #143f6b)",
      color: "#c2b2d3",
      accentColor: "#497bba",
      border: "min(0.25vw, 2px) solid #497bba",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #143f6b, #253856)",
    },
    stat: {
      background: "rgba(20, 63, 107, 0.8)",
      border: "min(0.25vw, 2px) solid #497bba",
      color: "#9eb9da",
      boxShadow: "0 0 min(1vw, 8px) rgba(73, 123, 186, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #497bba, #5f589f)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #143f6b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(73, 123, 186, 0.6)",
    },
  },
  planetar3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(179, 163, 77, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 60, 108, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(215, 206, 162, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b5a36, #1c3c6c, #6d84b0)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(179, 163, 77, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(109, 132, 176, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b3a34d, #6d84b0, #d7cea2, #b3a34d, #1c3c6c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(179, 163, 77, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(179, 163, 77, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(215, 206, 162, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(179, 163, 77, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 60, 108, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b5a36, #1c3c6c, #6d84b0)",
      border: "min(0.25vw, 2px) solid #b3a34d",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(179, 163, 77, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(179, 163, 77, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(109, 132, 176, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b3a34d, #6d84b0, #d7cea2, #b3a34d, #1c3c6c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(179, 163, 77, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(179, 163, 77, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(109, 132, 176, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b5a36, #1c3c6c)",
      color: "#cbc4ac",
      accentColor: "#b3a34d",
      border: "min(0.25vw, 2px) solid #b3a34d",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c3c6c, #4b5a36)",
    },
    stat: {
      background: "rgba(28, 60, 108, 0.8)",
      border: "min(0.25vw, 2px) solid #b3a34d",
      color: "#d7cea2",
      boxShadow: "0 0 min(1vw, 8px) rgba(179, 163, 77, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b3a34d, #6d84b0)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1c3c6c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(179, 163, 77, 0.6)",
    },
  },
  poisonousSnake: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(122, 175, 73, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(36, 76, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(193, 226, 222, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #455a31, #244c0c, #8fae69)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(122, 175, 73, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(143, 174, 105, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7aaf49, #8fae69, #c1e2de, #7aaf49, #244c0c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(122, 175, 73, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(122, 175, 73, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(193, 226, 222, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(122, 175, 73, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(36, 76, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #455a31, #244c0c, #8fae69)",
      border: "min(0.25vw, 2px) solid #7aaf49",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(122, 175, 73, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(122, 175, 73, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(143, 174, 105, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7aaf49, #8fae69, #c1e2de, #7aaf49, #244c0c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(122, 175, 73, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(122, 175, 73, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(143, 174, 105, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #455a31, #244c0c)",
      color: "#8ab3b3",
      accentColor: "#7aaf49",
      border: "min(0.25vw, 2px) solid #7aaf49",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #244c0c, #455a31)",
    },
    stat: {
      background: "rgba(36, 76, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #7aaf49",
      color: "#c1e2de",
      boxShadow: "0 0 min(1vw, 8px) rgba(122, 175, 73, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7aaf49, #8fae69)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #244c0c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(122, 175, 73, 0.6)",
    },
  },
  rat: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(128, 98, 52, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(92, 68, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(204, 163, 140, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #514131, #5c4424, #956d56)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(128, 98, 52, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(149, 109, 86, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #806234, #956d56, #cca38c, #806234, #5c4424)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(128, 98, 52, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(128, 98, 52, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(204, 163, 140, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(128, 98, 52, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(92, 68, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #514131, #5c4424, #956d56)",
      border: "min(0.25vw, 2px) solid #806234",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(128, 98, 52, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(128, 98, 52, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(149, 109, 86, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #806234, #956d56, #cca38c, #806234, #5c4424)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(128, 98, 52, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(128, 98, 52, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(149, 109, 86, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #514131, #5c4424)",
      color: "#8faa7d",
      accentColor: "#806234",
      border: "min(0.25vw, 2px) solid #806234",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5c4424, #514131)",
    },
    stat: {
      background: "rgba(92, 68, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #806234",
      color: "#cca38c",
      boxShadow: "0 0 min(1vw, 8px) rgba(128, 98, 52, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #806234, #956d56)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #5c4424",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(128, 98, 52, 0.6)",
    },
  },
  reefShark: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(36, 162, 199, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(14, 84, 131, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(101, 202, 217, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #493c4d, #0e5483, #7b8161)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(36, 162, 199, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(123, 129, 97, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #24a2c7, #7b8161, #65cad9, #24a2c7, #0e5483)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(36, 162, 199, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(36, 162, 199, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(101, 202, 217, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(36, 162, 199, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(14, 84, 131, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #493c4d, #0e5483, #7b8161)",
      border: "min(0.25vw, 2px) solid #24a2c7",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(36, 162, 199, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(36, 162, 199, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(123, 129, 97, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #24a2c7, #7b8161, #65cad9, #24a2c7, #0e5483)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(36, 162, 199, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(36, 162, 199, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(123, 129, 97, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #493c4d, #0e5483)",
      color: "#bdcdb8",
      accentColor: "#24a2c7",
      border: "min(0.25vw, 2px) solid #24a2c7",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #0e5483, #493c4d)",
    },
    stat: {
      background: "rgba(14, 84, 131, 0.8)",
      border: "min(0.25vw, 2px) solid #24a2c7",
      color: "#65cad9",
      boxShadow: "0 0 min(1vw, 8px) rgba(36, 162, 199, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #24a2c7, #7b8161)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #0e5483",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(36, 162, 199, 0.6)",
    },
  },
  remorhaz: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(65, 130, 177, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(29, 65, 103, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(151, 203, 226, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #43643a, #1d4167, #5e8c45)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(65, 130, 177, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(94, 140, 69, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4182b1, #5e8c45, #97cbe2, #4182b1, #1d4167)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(65, 130, 177, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(65, 130, 177, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(151, 203, 226, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(65, 130, 177, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(29, 65, 103, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #43643a, #1d4167, #5e8c45)",
      border: "min(0.25vw, 2px) solid #4182b1",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(65, 130, 177, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(65, 130, 177, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(94, 140, 69, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4182b1, #5e8c45, #97cbe2, #4182b1, #1d4167)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(65, 130, 177, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(65, 130, 177, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(94, 140, 69, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #43643a, #1d4167)",
      color: "#aebea9",
      accentColor: "#4182b1",
      border: "min(0.25vw, 2px) solid #4182b1",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1d4167, #43643a)",
    },
    stat: {
      background: "rgba(29, 65, 103, 0.8)",
      border: "min(0.25vw, 2px) solid #4182b1",
      color: "#97cbe2",
      boxShadow: "0 0 min(1vw, 8px) rgba(65, 130, 177, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4182b1, #5e8c45)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #1d4167",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(65, 130, 177, 0.6)",
    },
  },
  ridingHorse2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(198, 66, 54, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(52, 84, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(226, 220, 123, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #40562d, #34541c, #5c84a4)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(198, 66, 54, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(92, 132, 164, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c64236, #5c84a4, #e2dc7b, #c64236, #34541c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(198, 66, 54, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(198, 66, 54, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(226, 220, 123, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(198, 66, 54, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(52, 84, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #40562d, #34541c, #5c84a4)",
      border: "min(0.25vw, 2px) solid #c64236",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(198, 66, 54, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(198, 66, 54, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(92, 132, 164, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c64236, #5c84a4, #e2dc7b, #c64236, #34541c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(198, 66, 54, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(198, 66, 54, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(92, 132, 164, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #40562d, #34541c)",
      color: "#a8d0be",
      accentColor: "#c64236",
      border: "min(0.25vw, 2px) solid #c64236",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #34541c, #40562d)",
    },
    stat: {
      background: "rgba(52, 84, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #c64236",
      color: "#e2dc7b",
      boxShadow: "0 0 min(1vw, 8px) rgba(198, 66, 54, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c64236, #5c84a4)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #34541c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(198, 66, 54, 0.6)",
    },
  },
  roper: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(173, 127, 81, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(60, 44, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(212, 188, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #543c2d, #3c2c1c, #7c885f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(173, 127, 81, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(124, 136, 95, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ad7f51, #7c885f, #d4bca4, #ad7f51, #3c2c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(173, 127, 81, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(173, 127, 81, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(212, 188, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(173, 127, 81, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(60, 44, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #543c2d, #3c2c1c, #7c885f)",
      border: "min(0.25vw, 2px) solid #ad7f51",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(173, 127, 81, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(173, 127, 81, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(124, 136, 95, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ad7f51, #7c885f, #d4bca4, #ad7f51, #3c2c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(173, 127, 81, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(173, 127, 81, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(124, 136, 95, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #543c2d, #3c2c1c)",
      color: "#bec7b3",
      accentColor: "#ad7f51",
      border: "min(0.25vw, 2px) solid #ad7f51",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3c2c1c, #543c2d)",
    },
    stat: {
      background: "rgba(60, 44, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #ad7f51",
      color: "#d4bca4",
      boxShadow: "0 0 min(1vw, 8px) rgba(173, 127, 81, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ad7f51, #7c885f)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #3c2c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(173, 127, 81, 0.6)",
    },
  },
  rugOfSmothering: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(123, 145, 69, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(92, 36, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(198, 212, 165, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #475230, #5c241c, #6c9ca4)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(123, 145, 69, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(108, 156, 164, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7b9145, #6c9ca4, #c6d4a5, #7b9145, #5c241c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(123, 145, 69, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(123, 145, 69, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(198, 212, 165, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(123, 145, 69, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(92, 36, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #475230, #5c241c, #6c9ca4)",
      border: "min(0.25vw, 2px) solid #7b9145",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(123, 145, 69, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(123, 145, 69, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(108, 156, 164, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7b9145, #6c9ca4, #c6d4a5, #7b9145, #5c241c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(123, 145, 69, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(123, 145, 69, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(108, 156, 164, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #475230, #5c241c)",
      color: "#cec6b0",
      accentColor: "#7b9145",
      border: "min(0.25vw, 2px) solid #7b9145",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5c241c, #475230)",
    },
    stat: {
      background: "rgba(92, 36, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #7b9145",
      color: "#c6d4a5",
      boxShadow: "0 0 min(1vw, 8px) rgba(123, 145, 69, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7b9145, #6c9ca4)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5c241c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(123, 145, 69, 0.6)",
    },
  },
  sahuagin: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(39, 140, 163, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(24, 92, 116, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(148, 214, 229, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2c2c50, #185c74, #5b7a4c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(39, 140, 163, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(91, 122, 76, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #278ca3, #5b7a4c, #94d6e5, #278ca3, #185c74)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(39, 140, 163, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(39, 140, 163, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(148, 214, 229, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(39, 140, 163, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(24, 92, 116, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2c2c50, #185c74, #5b7a4c)",
      border: "min(0.25vw, 2px) solid #278ca3",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(39, 140, 163, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(39, 140, 163, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(91, 122, 76, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #278ca3, #5b7a4c, #94d6e5, #278ca3, #185c74)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(39, 140, 163, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(39, 140, 163, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(91, 122, 76, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2c2c50, #185c74)",
      color: "#adb599",
      accentColor: "#278ca3",
      border: "min(0.25vw, 2px) solid #278ca3",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #185c74, #2c2c50)",
    },
    stat: {
      background: "rgba(24, 92, 116, 0.8)",
      border: "min(0.25vw, 2px) solid #278ca3",
      color: "#94d6e5",
      boxShadow: "0 0 min(1vw, 8px) rgba(39, 140, 163, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #278ca3, #5b7a4c)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #185c74",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(39, 140, 163, 0.6)",
    },
  },
  scorpion: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(139, 157, 97, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(72, 81, 50, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(194, 204, 173, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #35404e, #485132, #83a161)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(139, 157, 97, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(131, 161, 97, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #8b9d61, #83a161, #c2ccad, #8b9d61, #485132)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(139, 157, 97, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(139, 157, 97, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(194, 204, 173, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(139, 157, 97, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(72, 81, 50, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #35404e, #485132, #83a161)",
      border: "min(0.25vw, 2px) solid #8b9d61",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(139, 157, 97, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(139, 157, 97, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(131, 161, 97, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #8b9d61, #83a161, #c2ccad, #8b9d61, #485132)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(139, 157, 97, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(139, 157, 97, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(131, 161, 97, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #35404e, #485132)",
      color: "#b7c29d",
      accentColor: "#8b9d61",
      border: "min(0.25vw, 2px) solid #8b9d61",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #485132, #35404e)",
    },
    stat: {
      background: "rgba(72, 81, 50, 0.8)",
      border: "min(0.25vw, 2px) solid #8b9d61",
      color: "#c2ccad",
      boxShadow: "0 0 min(1vw, 8px) rgba(139, 157, 97, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #8b9d61, #83a161)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #485132",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(139, 157, 97, 0.6)",
    },
  },
  seaHorse4: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(48, 165, 197, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(20, 77, 120, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(127, 207, 219, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2e4c52, #144d78, #b19768)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(48, 165, 197, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(177, 151, 104, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #30a5c5, #b19768, #7fcfdb, #30a5c5, #144d78)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(48, 165, 197, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(48, 165, 197, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(127, 207, 219, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(48, 165, 197, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(20, 77, 120, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2e4c52, #144d78, #b19768)",
      border: "min(0.25vw, 2px) solid #30a5c5",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(48, 165, 197, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(48, 165, 197, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(177, 151, 104, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #30a5c5, #b19768, #7fcfdb, #30a5c5, #144d78)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(48, 165, 197, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(48, 165, 197, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(177, 151, 104, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2e4c52, #144d78)",
      color: "#8ab474",
      accentColor: "#30a5c5",
      border: "min(0.25vw, 2px) solid #30a5c5",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #144d78, #2e4c52)",
    },
    stat: {
      background: "rgba(20, 77, 120, 0.8)",
      border: "min(0.25vw, 2px) solid #30a5c5",
      color: "#7fcfdb",
      boxShadow: "0 0 min(1vw, 8px) rgba(48, 165, 197, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #30a5c5, #b19768)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #144d78",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(48, 165, 197, 0.6)",
    },
  },
  shadow: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(91, 143, 180, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 60, 92, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(118, 178, 209, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #304968, #1c3c5c, #5e8ca1)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(91, 143, 180, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(94, 140, 161, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5b8fb4, #5e8ca1, #76b2d1, #5b8fb4, #1c3c5c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(91, 143, 180, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(91, 143, 180, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(118, 178, 209, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(91, 143, 180, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 60, 92, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #304968, #1c3c5c, #5e8ca1)",
      border: "min(0.25vw, 2px) solid #5b8fb4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(91, 143, 180, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(91, 143, 180, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(94, 140, 161, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5b8fb4, #5e8ca1, #76b2d1, #5b8fb4, #1c3c5c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(91, 143, 180, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(91, 143, 180, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(94, 140, 161, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #304968, #1c3c5c)",
      color: "#265872",
      accentColor: "#5b8fb4",
      border: "min(0.25vw, 2px) solid #5b8fb4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c3c5c, #304968)",
    },
    stat: {
      background: "rgba(28, 60, 92, 0.8)",
      border: "min(0.25vw, 2px) solid #5b8fb4",
      color: "#76b2d1",
      boxShadow: "0 0 min(1vw, 8px) rgba(91, 143, 180, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5b8fb4, #5e8ca1)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1c3c5c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(91, 143, 180, 0.6)",
    },
  },
  shamblingMound: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(178, 110, 76, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(84, 52, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(212, 228, 236, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #42542c, #543424, #5d7647)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(178, 110, 76, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(93, 118, 71, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b26e4c, #5d7647, #d4e4ec, #b26e4c, #543424)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(178, 110, 76, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(178, 110, 76, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(212, 228, 236, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(178, 110, 76, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(84, 52, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #42542c, #543424, #5d7647)",
      border: "min(0.25vw, 2px) solid #b26e4c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(178, 110, 76, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(178, 110, 76, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(93, 118, 71, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b26e4c, #5d7647, #d4e4ec, #b26e4c, #543424)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(178, 110, 76, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(178, 110, 76, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(93, 118, 71, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #42542c, #543424)",
      color: "#c5d2d7",
      accentColor: "#b26e4c",
      border: "min(0.25vw, 2px) solid #b26e4c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #543424, #42542c)",
    },
    stat: {
      background: "rgba(84, 52, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #b26e4c",
      color: "#d4e4ec",
      boxShadow: "0 0 min(1vw, 8px) rgba(178, 110, 76, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b26e4c, #5d7647)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #543424",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(178, 110, 76, 0.6)",
    },
  },
  silverDragonWyrmling: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(75, 114, 174, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(43, 66, 119, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(211, 187, 118, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #5b4f38, #2b4277, #9e885a)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(75, 114, 174, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(158, 136, 90, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #4b72ae, #9e885a, #d3bb76, #4b72ae, #2b4277)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(75, 114, 174, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(75, 114, 174, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(211, 187, 118, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(75, 114, 174, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(43, 66, 119, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #5b4f38, #2b4277, #9e885a)",
      border: "min(0.25vw, 2px) solid #4b72ae",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(75, 114, 174, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(75, 114, 174, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(158, 136, 90, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #4b72ae, #9e885a, #d3bb76, #4b72ae, #2b4277)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(75, 114, 174, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(75, 114, 174, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(158, 136, 90, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #5b4f38, #2b4277)",
      color: "#a5c2d2",
      accentColor: "#4b72ae",
      border: "min(0.25vw, 2px) solid #4b72ae",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2b4277, #5b4f38)",
    },
    stat: {
      background: "rgba(43, 66, 119, 0.8)",
      border: "min(0.25vw, 2px) solid #4b72ae",
      color: "#d3bb76",
      boxShadow: "0 0 min(1vw, 8px) rgba(75, 114, 174, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #4b72ae, #9e885a)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #2b4277",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(75, 114, 174, 0.6)",
    },
  },
  skeleton2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(156, 138, 98, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(81, 72, 51, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(203, 194, 173, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3c542c, #514833, #80a062)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(156, 138, 98, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(128, 160, 98, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #9c8a62, #80a062, #cbc2ad, #9c8a62, #514833)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(156, 138, 98, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(156, 138, 98, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(203, 194, 173, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(156, 138, 98, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(81, 72, 51, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3c542c, #514833, #80a062)",
      border: "min(0.25vw, 2px) solid #9c8a62",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(156, 138, 98, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(156, 138, 98, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(128, 160, 98, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #9c8a62, #80a062, #cbc2ad, #9c8a62, #514833)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(156, 138, 98, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(156, 138, 98, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(128, 160, 98, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3c542c, #514833)",
      color: "#c6bca5",
      accentColor: "#9c8a62",
      border: "min(0.25vw, 2px) solid #9c8a62",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #514833, #3c542c)",
    },
    stat: {
      background: "rgba(81, 72, 51, 0.8)",
      border: "min(0.25vw, 2px) solid #9c8a62",
      color: "#cbc2ad",
      boxShadow: "0 0 min(1vw, 8px) rgba(156, 138, 98, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #9c8a62, #80a062)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #514833",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(156, 138, 98, 0.6)",
    },
  },
  specter: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(52, 84, 116, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(44, 68, 93, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(148, 185, 212, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #344b63, #2c445d, #4e6e89)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(52, 84, 116, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(78, 110, 137, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #345474, #4e6e89, #94b9d4, #345474, #2c445d)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(52, 84, 116, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(52, 84, 116, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(148, 185, 212, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(52, 84, 116, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(44, 68, 93, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #344b63, #2c445d, #4e6e89)",
      border: "min(0.25vw, 2px) solid #345474",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(52, 84, 116, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(52, 84, 116, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(78, 110, 137, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #345474, #4e6e89, #94b9d4, #345474, #2c445d)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(52, 84, 116, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(52, 84, 116, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(78, 110, 137, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #344b63, #2c445d)",
      color: "#b2d7c8",
      accentColor: "#345474",
      border: "min(0.25vw, 2px) solid #345474",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2c445d, #344b63)",
    },
    stat: {
      background: "rgba(44, 68, 93, 0.8)",
      border: "min(0.25vw, 2px) solid #345474",
      color: "#94b9d4",
      boxShadow: "0 0 min(1vw, 8px) rgba(52, 84, 116, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #345474, #4e6e89)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #2c445d",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(52, 84, 116, 0.6)",
    },
  },
  spy: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(213, 41, 49, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(73, 14, 17, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(233, 143, 148, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2a3c4a, #490e11, #6e8ca3)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(213, 41, 49, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(110, 140, 163, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d52931, #6e8ca3, #e98f94, #d52931, #490e11)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(213, 41, 49, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(213, 41, 49, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(233, 143, 148, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(213, 41, 49, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(73, 14, 17, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2a3c4a, #490e11, #6e8ca3)",
      border: "min(0.25vw, 2px) solid #d52931",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(213, 41, 49, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(213, 41, 49, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(110, 140, 163, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d52931, #6e8ca3, #e98f94, #d52931, #490e11)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(213, 41, 49, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(213, 41, 49, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(110, 140, 163, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2a3c4a, #490e11)",
      color: "#bbbcbe",
      accentColor: "#d52931",
      border: "min(0.25vw, 2px) solid #d52931",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #490e11, #2a3c4a)",
    },
    stat: {
      background: "rgba(73, 14, 17, 0.8)",
      border: "min(0.25vw, 2px) solid #d52931",
      color: "#e98f94",
      boxShadow: "0 0 min(1vw, 8px) rgba(213, 41, 49, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d52931, #6e8ca3)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #490e11",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(213, 41, 49, 0.6)",
    },
  },
  stoneGiant: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(159, 180, 74, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(60, 68, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(205, 216, 161, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #344454, #3c441c, #788589)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(159, 180, 74, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(120, 133, 137, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #9fb44a, #788589, #cdd8a1, #9fb44a, #3c441c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(159, 180, 74, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(159, 180, 74, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(205, 216, 161, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(159, 180, 74, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(60, 68, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #344454, #3c441c, #788589)",
      border: "min(0.25vw, 2px) solid #9fb44a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(159, 180, 74, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(159, 180, 74, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(120, 133, 137, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #9fb44a, #788589, #cdd8a1, #9fb44a, #3c441c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(159, 180, 74, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(159, 180, 74, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(120, 133, 137, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #344454, #3c441c)",
      color: "#91abb6",
      accentColor: "#9fb44a",
      border: "min(0.25vw, 2px) solid #9fb44a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3c441c, #344454)",
    },
    stat: {
      background: "rgba(60, 68, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #9fb44a",
      color: "#cdd8a1",
      boxShadow: "0 0 min(1vw, 8px) rgba(159, 180, 74, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #9fb44a, #788589)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #3c441c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(159, 180, 74, 0.6)",
    },
  },
  stormGiant: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(52, 140, 124, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(35, 96, 85, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(172, 204, 220, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #30424d, #236055, #6b8c95)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(52, 140, 124, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(107, 140, 149, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #348c7c, #6b8c95, #acccdc, #348c7c, #236055)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(52, 140, 124, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(52, 140, 124, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(172, 204, 220, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(52, 140, 124, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(35, 96, 85, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #30424d, #236055, #6b8c95)",
      border: "min(0.25vw, 2px) solid #348c7c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(52, 140, 124, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(52, 140, 124, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(107, 140, 149, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #348c7c, #6b8c95, #acccdc, #348c7c, #236055)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(52, 140, 124, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(52, 140, 124, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(107, 140, 149, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #30424d, #236055)",
      color: "#a3c1c8",
      accentColor: "#348c7c",
      border: "min(0.25vw, 2px) solid #348c7c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #236055, #30424d)",
    },
    stat: {
      background: "rgba(35, 96, 85, 0.8)",
      border: "min(0.25vw, 2px) solid #348c7c",
      color: "#acccdc",
      boxShadow: "0 0 min(1vw, 8px) rgba(52, 140, 124, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #348c7c, #6b8c95)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #236055",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(52, 140, 124, 0.6)",
    },
  },
  swarmOfBeetles2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(216, 105, 56, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(100, 50, 39, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(240, 203, 136, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #41532e, #643227, #9c5e47)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(216, 105, 56, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(156, 94, 71, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d86938, #9c5e47, #f0cb88, #d86938, #643227)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(216, 105, 56, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(216, 105, 56, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(240, 203, 136, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(216, 105, 56, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(100, 50, 39, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #41532e, #643227, #9c5e47)",
      border: "min(0.25vw, 2px) solid #d86938",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(216, 105, 56, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(216, 105, 56, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(156, 94, 71, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d86938, #9c5e47, #f0cb88, #d86938, #643227)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(216, 105, 56, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(216, 105, 56, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(156, 94, 71, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #41532e, #643227)",
      color: "#b4b4ac",
      accentColor: "#d86938",
      border: "min(0.25vw, 2px) solid #d86938",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #643227, #41532e)",
    },
    stat: {
      background: "rgba(100, 50, 39, 0.8)",
      border: "min(0.25vw, 2px) solid #d86938",
      color: "#f0cb88",
      boxShadow: "0 0 min(1vw, 8px) rgba(216, 105, 56, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d86938, #9c5e47)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #643227",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(216, 105, 56, 0.6)",
    },
  },
  swarmOfPoisonousSnakes: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(179, 126, 75, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(85, 60, 36, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(215, 188, 161, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #425737, #553c24, #60964e)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(179, 126, 75, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(96, 150, 78, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b37e4b, #60964e, #d7bca1, #b37e4b, #553c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(179, 126, 75, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(179, 126, 75, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(215, 188, 161, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(179, 126, 75, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(85, 60, 36, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #425737, #553c24, #60964e)",
      border: "min(0.25vw, 2px) solid #b37e4b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(179, 126, 75, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(179, 126, 75, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(96, 150, 78, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b37e4b, #60964e, #d7bca1, #b37e4b, #553c24)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(179, 126, 75, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(179, 126, 75, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(96, 150, 78, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #425737, #553c24)",
      color: "#a4bd97",
      accentColor: "#b37e4b",
      border: "min(0.25vw, 2px) solid #b37e4b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #553c24, #425737)",
    },
    stat: {
      background: "rgba(85, 60, 36, 0.8)",
      border: "min(0.25vw, 2px) solid #b37e4b",
      color: "#d7bca1",
      boxShadow: "0 0 min(1vw, 8px) rgba(179, 126, 75, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b37e4b, #60964e)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #553c24",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(179, 126, 75, 0.6)",
    },
  },
  tarrasque: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(203, 131, 99, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(133, 61, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(221, 175, 155, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #445434, #853d2c, #8b6160)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(203, 131, 99, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(139, 97, 96, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #cb8363, #8b6160, #ddaf9b, #cb8363, #853d2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(203, 131, 99, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(203, 131, 99, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(221, 175, 155, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(203, 131, 99, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(133, 61, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #445434, #853d2c, #8b6160)",
      border: "min(0.25vw, 2px) solid #cb8363",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(203, 131, 99, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(203, 131, 99, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(139, 97, 96, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #cb8363, #8b6160, #ddaf9b, #cb8363, #853d2c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(203, 131, 99, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(203, 131, 99, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(139, 97, 96, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #445434, #853d2c)",
      color: "#9e9c9c",
      accentColor: "#cb8363",
      border: "min(0.25vw, 2px) solid #cb8363",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #853d2c, #445434)",
    },
    stat: {
      background: "rgba(133, 61, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #cb8363",
      color: "#ddaf9b",
      boxShadow: "0 0 min(1vw, 8px) rgba(203, 131, 99, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #cb8363, #8b6160)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #853d2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(203, 131, 99, 0.6)",
    },
  },
  tiger2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(182, 170, 92, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(72, 95, 45, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(225, 241, 209, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #44542d, #485f2d, #8b9e60)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(182, 170, 92, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(139, 158, 96, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b6aa5c, #8b9e60, #e1f1d1, #b6aa5c, #485f2d)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(182, 170, 92, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(182, 170, 92, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(225, 241, 209, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(182, 170, 92, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(72, 95, 45, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #44542d, #485f2d, #8b9e60)",
      border: "min(0.25vw, 2px) solid #b6aa5c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(182, 170, 92, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(182, 170, 92, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(139, 158, 96, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b6aa5c, #8b9e60, #e1f1d1, #b6aa5c, #485f2d)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(182, 170, 92, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(182, 170, 92, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(139, 158, 96, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #44542d, #485f2d)",
      color: "#c2d2af",
      accentColor: "#b6aa5c",
      border: "min(0.25vw, 2px) solid #b6aa5c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #485f2d, #44542d)",
    },
    stat: {
      background: "rgba(72, 95, 45, 0.8)",
      border: "min(0.25vw, 2px) solid #b6aa5c",
      color: "#e1f1d1",
      boxShadow: "0 0 min(1vw, 8px) rgba(182, 170, 92, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b6aa5c, #8b9e60)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #485f2d",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(182, 170, 92, 0.6)",
    },
  },
  tribalWarrior: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(175, 111, 76, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(84, 132, 60, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(227, 194, 160, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #375561, #54843c, #4b7085)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(175, 111, 76, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(75, 112, 133, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #af6f4c, #4b7085, #e3c2a0, #af6f4c, #54843c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(175, 111, 76, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(175, 111, 76, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(227, 194, 160, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(175, 111, 76, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(84, 132, 60, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #375561, #54843c, #4b7085)",
      border: "min(0.25vw, 2px) solid #af6f4c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(175, 111, 76, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(175, 111, 76, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(75, 112, 133, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #af6f4c, #4b7085, #e3c2a0, #af6f4c, #54843c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(175, 111, 76, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(175, 111, 76, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(75, 112, 133, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #375561, #54843c)",
      color: "#bdab92",
      accentColor: "#af6f4c",
      border: "min(0.25vw, 2px) solid #af6f4c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #54843c, #375561)",
    },
    stat: {
      background: "rgba(84, 132, 60, 0.8)",
      border: "min(0.25vw, 2px) solid #af6f4c",
      color: "#e3c2a0",
      boxShadow: "0 0 min(1vw, 8px) rgba(175, 111, 76, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #af6f4c, #4b7085)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #54843c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(175, 111, 76, 0.6)",
    },
  },
  unicorn3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(65, 161, 212, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(29, 101, 127, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(236, 227, 142, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #4b5939, #1d657f, #6b9a5b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(65, 161, 212, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(107, 154, 91, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #41a1d4, #6b9a5b, #ece38e, #41a1d4, #1d657f)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(65, 161, 212, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(65, 161, 212, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(236, 227, 142, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(65, 161, 212, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(29, 101, 127, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #4b5939, #1d657f, #6b9a5b)",
      border: "min(0.25vw, 2px) solid #41a1d4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(65, 161, 212, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(65, 161, 212, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(107, 154, 91, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #41a1d4, #6b9a5b, #ece38e, #41a1d4, #1d657f)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(65, 161, 212, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(65, 161, 212, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(107, 154, 91, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #4b5939, #1d657f)",
      color: "#cda4b9",
      accentColor: "#41a1d4",
      border: "min(0.25vw, 2px) solid #41a1d4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1d657f, #4b5939)",
    },
    stat: {
      background: "rgba(29, 101, 127, 0.8)",
      border: "min(0.25vw, 2px) solid #41a1d4",
      color: "#ece38e",
      boxShadow: "0 0 min(1vw, 8px) rgba(65, 161, 212, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #41a1d4, #6b9a5b)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1d657f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(65, 161, 212, 0.6)",
    },
  },
  vampireBatForm: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(181, 100, 73, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(108, 60, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(216, 174, 160, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #405031, #6c3c2c, #767a77)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(181, 100, 73, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(118, 122, 119, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b56449, #767a77, #d8aea0, #b56449, #6c3c2c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(181, 100, 73, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(181, 100, 73, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(216, 174, 160, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(181, 100, 73, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(108, 60, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #405031, #6c3c2c, #767a77)",
      border: "min(0.25vw, 2px) solid #b56449",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(181, 100, 73, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(181, 100, 73, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(118, 122, 119, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b56449, #767a77, #d8aea0, #b56449, #6c3c2c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(181, 100, 73, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(181, 100, 73, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(118, 122, 119, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #405031, #6c3c2c)",
      color: "#d3d6d8",
      accentColor: "#b56449",
      border: "min(0.25vw, 2px) solid #b56449",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6c3c2c, #405031)",
    },
    stat: {
      background: "rgba(108, 60, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #b56449",
      color: "#d8aea0",
      boxShadow: "0 0 min(1vw, 8px) rgba(181, 100, 73, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b56449, #767a77)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #6c3c2c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(181, 100, 73, 0.6)",
    },
  },
  vampireMistForm4: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(125, 68, 43, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(37, 12, 4, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(221, 176, 156, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #394839, #250c04, #83a879)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(125, 68, 43, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(131, 168, 121, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7d442b, #83a879, #ddb09c, #7d442b, #250c04)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(125, 68, 43, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(125, 68, 43, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(221, 176, 156, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(125, 68, 43, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(37, 12, 4, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #394839, #250c04, #83a879)",
      border: "min(0.25vw, 2px) solid #7d442b",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(125, 68, 43, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(125, 68, 43, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(131, 168, 121, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7d442b, #83a879, #ddb09c, #7d442b, #250c04)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(125, 68, 43, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(125, 68, 43, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(131, 168, 121, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #394839, #250c04)",
      color: "#94c48b",
      accentColor: "#7d442b",
      border: "min(0.25vw, 2px) solid #7d442b",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #250c04, #394839)",
    },
    stat: {
      background: "rgba(37, 12, 4, 0.8)",
      border: "min(0.25vw, 2px) solid #7d442b",
      color: "#ddb09c",
      boxShadow: "0 0 min(1vw, 8px) rgba(125, 68, 43, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7d442b, #83a879)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #250c04",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(125, 68, 43, 0.6)",
    },
  },
  violetFungus: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(126, 90, 180, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 84, 92, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(100, 181, 201, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #354d63, #1c545c, #7c578f)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(126, 90, 180, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(124, 87, 143, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7e5ab4, #7c578f, #64b5c9, #7e5ab4, #1c545c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(126, 90, 180, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(126, 90, 180, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(100, 181, 201, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(126, 90, 180, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 84, 92, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #354d63, #1c545c, #7c578f)",
      border: "min(0.25vw, 2px) solid #7e5ab4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(126, 90, 180, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(126, 90, 180, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(124, 87, 143, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7e5ab4, #7c578f, #64b5c9, #7e5ab4, #1c545c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(126, 90, 180, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(126, 90, 180, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(124, 87, 143, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #354d63, #1c545c)",
      color: "#b587c4",
      accentColor: "#7e5ab4",
      border: "min(0.25vw, 2px) solid #7e5ab4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c545c, #354d63)",
    },
    stat: {
      background: "rgba(28, 84, 92, 0.8)",
      border: "min(0.25vw, 2px) solid #7e5ab4",
      color: "#64b5c9",
      boxShadow: "0 0 min(1vw, 8px) rgba(126, 90, 180, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7e5ab4, #7c578f)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #1c545c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(126, 90, 180, 0.6)",
    },
  },
  warhorse2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(126, 202, 42, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(68, 130, 18, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(192, 228, 216, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3e4739, #448212, #6d8481)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(126, 202, 42, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(109, 132, 129, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #7eca2a, #6d8481, #c0e4d8, #7eca2a, #448212)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(126, 202, 42, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(126, 202, 42, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(192, 228, 216, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(126, 202, 42, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(68, 130, 18, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3e4739, #448212, #6d8481)",
      border: "min(0.25vw, 2px) solid #7eca2a",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(126, 202, 42, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(126, 202, 42, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(109, 132, 129, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #7eca2a, #6d8481, #c0e4d8, #7eca2a, #448212)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(126, 202, 42, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(126, 202, 42, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(109, 132, 129, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3e4739, #448212)",
      color: "#b0d5d2",
      accentColor: "#7eca2a",
      border: "min(0.25vw, 2px) solid #7eca2a",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #448212, #3e4739)",
    },
    stat: {
      background: "rgba(68, 130, 18, 0.8)",
      border: "min(0.25vw, 2px) solid #7eca2a",
      color: "#c0e4d8",
      boxShadow: "0 0 min(1vw, 8px) rgba(126, 202, 42, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #7eca2a, #6d8481)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #448212",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(126, 202, 42, 0.6)",
    },
  },
  wereboarHybridForm2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(63, 191, 159, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(4, 12, 10, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(155, 221, 205, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #38434c, #040c0a, #6f8c78)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(63, 191, 159, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(111, 140, 120, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #3fbf9f, #6f8c78, #9bddcd, #3fbf9f, #040c0a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(63, 191, 159, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(63, 191, 159, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(155, 221, 205, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(63, 191, 159, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(4, 12, 10, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #38434c, #040c0a, #6f8c78)",
      border: "min(0.25vw, 2px) solid #3fbf9f",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(63, 191, 159, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(63, 191, 159, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(111, 140, 120, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #3fbf9f, #6f8c78, #9bddcd, #3fbf9f, #040c0a)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(63, 191, 159, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(63, 191, 159, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(111, 140, 120, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #38434c, #040c0a)",
      color: "#a1bfcd",
      accentColor: "#3fbf9f",
      border: "min(0.25vw, 2px) solid #3fbf9f",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #040c0a, #38434c)",
    },
    stat: {
      background: "rgba(4, 12, 10, 0.8)",
      border: "min(0.25vw, 2px) solid #3fbf9f",
      color: "#9bddcd",
      boxShadow: "0 0 min(1vw, 8px) rgba(63, 191, 159, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #3fbf9f, #6f8c78)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #040c0a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(63, 191, 159, 0.6)",
    },
  },
  wereratHumanForm: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(165, 202, 137, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(94, 45, 27, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(223, 232, 189, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #424632, #5e2d1b, #7ca466)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(165, 202, 137, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(124, 164, 102, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #a5ca89, #7ca466, #dfe8bd, #a5ca89, #5e2d1b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(165, 202, 137, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(165, 202, 137, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(223, 232, 189, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(165, 202, 137, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(94, 45, 27, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #424632, #5e2d1b, #7ca466)",
      border: "min(0.25vw, 2px) solid #a5ca89",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(165, 202, 137, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(165, 202, 137, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(124, 164, 102, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #a5ca89, #7ca466, #dfe8bd, #a5ca89, #5e2d1b)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(165, 202, 137, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(165, 202, 137, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(124, 164, 102, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #424632, #5e2d1b)",
      color: "#8c948c",
      accentColor: "#a5ca89",
      border: "min(0.25vw, 2px) solid #a5ca89",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5e2d1b, #424632)",
    },
    stat: {
      background: "rgba(94, 45, 27, 0.8)",
      border: "min(0.25vw, 2px) solid #a5ca89",
      color: "#dfe8bd",
      boxShadow: "0 0 min(1vw, 8px) rgba(165, 202, 137, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #a5ca89, #7ca466)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #5e2d1b",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(165, 202, 137, 0.6)",
    },
  },
  werewolfHybridForm2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(47, 68, 108, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(44, 76, 108, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(210, 221, 234, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #30435b, #2c4c6c, #6a89b2)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(47, 68, 108, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(106, 137, 178, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #2f446c, #6a89b2, #d2ddea, #2f446c, #2c4c6c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(47, 68, 108, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(47, 68, 108, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(210, 221, 234, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(47, 68, 108, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(44, 76, 108, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #30435b, #2c4c6c, #6a89b2)",
      border: "min(0.25vw, 2px) solid #2f446c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(47, 68, 108, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(47, 68, 108, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(106, 137, 178, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #2f446c, #6a89b2, #d2ddea, #2f446c, #2c4c6c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(47, 68, 108, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(47, 68, 108, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(106, 137, 178, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #30435b, #2c4c6c)",
      color: "#304a68",
      accentColor: "#2f446c",
      border: "min(0.25vw, 2px) solid #2f446c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2c4c6c, #30435b)",
    },
    stat: {
      background: "rgba(44, 76, 108, 0.8)",
      border: "min(0.25vw, 2px) solid #2f446c",
      color: "#d2ddea",
      boxShadow: "0 0 min(1vw, 8px) rgba(47, 68, 108, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #2f446c, #6a89b2)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #2c4c6c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(47, 68, 108, 0.6)",
    },
  },
  willOWisp: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(162, 201, 68, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(4, 9, 12, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(190, 229, 123, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #2e374a, #04090c, #83aa59)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(162, 201, 68, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(131, 170, 89, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #a2c944, #83aa59, #bee57b, #a2c944, #04090c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(162, 201, 68, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(162, 201, 68, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(190, 229, 123, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(162, 201, 68, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(4, 9, 12, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #2e374a, #04090c, #83aa59)",
      border: "min(0.25vw, 2px) solid #a2c944",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(162, 201, 68, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(162, 201, 68, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(131, 170, 89, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #a2c944, #83aa59, #bee57b, #a2c944, #04090c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(162, 201, 68, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(162, 201, 68, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(131, 170, 89, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #2e374a, #04090c)",
      color: "#c6d2a9",
      accentColor: "#a2c944",
      border: "min(0.25vw, 2px) solid #a2c944",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #04090c, #2e374a)",
    },
    stat: {
      background: "rgba(4, 9, 12, 0.8)",
      border: "min(0.25vw, 2px) solid #a2c944",
      color: "#bee57b",
      boxShadow: "0 0 min(1vw, 8px) rgba(162, 201, 68, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #a2c944, #83aa59)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #04090c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(162, 201, 68, 0.6)",
    },
  },
  winterWolf: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(116, 164, 212, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(31, 66, 101, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(151, 188, 217, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #644d44, #1f4265, #66839b)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(116, 164, 212, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(102, 131, 155, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #74a4d4, #66839b, #97bcd9, #74a4d4, #1f4265)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(116, 164, 212, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(116, 164, 212, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(151, 188, 217, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(116, 164, 212, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(31, 66, 101, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #644d44, #1f4265, #66839b)",
      border: "min(0.25vw, 2px) solid #74a4d4",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(116, 164, 212, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(116, 164, 212, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(102, 131, 155, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #74a4d4, #66839b, #97bcd9, #74a4d4, #1f4265)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(116, 164, 212, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(116, 164, 212, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(102, 131, 155, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #644d44, #1f4265)",
      color: "#9eb8c9",
      accentColor: "#74a4d4",
      border: "min(0.25vw, 2px) solid #74a4d4",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1f4265, #644d44)",
    },
    stat: {
      background: "rgba(31, 66, 101, 0.8)",
      border: "min(0.25vw, 2px) solid #74a4d4",
      color: "#97bcd9",
      boxShadow: "0 0 min(1vw, 8px) rgba(116, 164, 212, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #74a4d4, #66839b)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1f4265",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(116, 164, 212, 0.6)",
    },
  },
  wraith: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(68, 124, 145, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(44, 75, 92, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(192, 225, 236, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #334552, #2c4b5c, #618499)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(68, 124, 145, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(97, 132, 153, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #447c91, #618499, #c0e1ec, #447c91, #2c4b5c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(68, 124, 145, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(68, 124, 145, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(192, 225, 236, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(68, 124, 145, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(44, 75, 92, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #334552, #2c4b5c, #618499)",
      border: "min(0.25vw, 2px) solid #447c91",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(68, 124, 145, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(68, 124, 145, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(97, 132, 153, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #447c91, #618499, #c0e1ec, #447c91, #2c4b5c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(68, 124, 145, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(68, 124, 145, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(97, 132, 153, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #334552, #2c4b5c)",
      color: "#8db8cb",
      accentColor: "#447c91",
      border: "min(0.25vw, 2px) solid #447c91",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2c4b5c, #334552)",
    },
    stat: {
      background: "rgba(44, 75, 92, 0.8)",
      border: "min(0.25vw, 2px) solid #447c91",
      color: "#c0e1ec",
      boxShadow: "0 0 min(1vw, 8px) rgba(68, 124, 145, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #447c91, #618499)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #2c4b5c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(68, 124, 145, 0.6)",
    },
  },
  wyvern: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(164, 100, 65, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(95, 69, 44, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(246, 238, 194, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #39474f, #5f452c, #ac9869)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(164, 100, 65, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(172, 152, 105, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #a46441, #ac9869, #f6eec2, #a46441, #5f452c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(164, 100, 65, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(164, 100, 65, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(246, 238, 194, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(164, 100, 65, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(95, 69, 44, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #39474f, #5f452c, #ac9869)",
      border: "min(0.25vw, 2px) solid #a46441",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(164, 100, 65, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(164, 100, 65, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(172, 152, 105, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #a46441, #ac9869, #f6eec2, #a46441, #5f452c)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(164, 100, 65, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(164, 100, 65, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(172, 152, 105, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #39474f, #5f452c)",
      color: "#accccd",
      accentColor: "#a46441",
      border: "min(0.25vw, 2px) solid #a46441",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #5f452c, #39474f)",
    },
    stat: {
      background: "rgba(95, 69, 44, 0.8)",
      border: "min(0.25vw, 2px) solid #a46441",
      color: "#f6eec2",
      boxShadow: "0 0 min(1vw, 8px) rgba(164, 100, 65, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #a46441, #ac9869)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #5f452c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(164, 100, 65, 0.6)",
    },
  },
  youngBlackDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(152, 196, 124, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(60, 91, 41, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(206, 233, 170, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3b4c34, #3c5b29, #7cac5c)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(152, 196, 124, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(124, 172, 92, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #98c47c, #7cac5c, #cee9aa, #98c47c, #3c5b29)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(152, 196, 124, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(152, 196, 124, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(206, 233, 170, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(152, 196, 124, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(60, 91, 41, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3b4c34, #3c5b29, #7cac5c)",
      border: "min(0.25vw, 2px) solid #98c47c",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(152, 196, 124, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(152, 196, 124, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(124, 172, 92, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #98c47c, #7cac5c, #cee9aa, #98c47c, #3c5b29)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(152, 196, 124, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(152, 196, 124, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(124, 172, 92, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3b4c34, #3c5b29)",
      color: "#c5d5b2",
      accentColor: "#98c47c",
      border: "min(0.25vw, 2px) solid #98c47c",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #3c5b29, #3b4c34)",
    },
    stat: {
      background: "rgba(60, 91, 41, 0.8)",
      border: "min(0.25vw, 2px) solid #98c47c",
      color: "#cee9aa",
      boxShadow: "0 0 min(1vw, 8px) rgba(152, 196, 124, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #98c47c, #7cac5c)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #3c5b29",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(152, 196, 124, 0.6)",
    },
  },
  youngBlackDragon2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(185, 124, 84, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(132, 92, 60, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(249, 242, 219, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #643c34, #845c3c, #a87155)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(185, 124, 84, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(168, 113, 85, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #b97c54, #a87155, #f9f2db, #b97c54, #845c3c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 124, 84, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(185, 124, 84, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(249, 242, 219, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(185, 124, 84, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(132, 92, 60, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #643c34, #845c3c, #a87155)",
      border: "min(0.25vw, 2px) solid #b97c54",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(185, 124, 84, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(185, 124, 84, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(168, 113, 85, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #b97c54, #a87155, #f9f2db, #b97c54, #845c3c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(185, 124, 84, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(185, 124, 84, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(168, 113, 85, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #643c34, #845c3c)",
      color: "#c8b7a7",
      accentColor: "#b97c54",
      border: "min(0.25vw, 2px) solid #b97c54",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #845c3c, #643c34)",
    },
    stat: {
      background: "rgba(132, 92, 60, 0.8)",
      border: "min(0.25vw, 2px) solid #b97c54",
      color: "#f9f2db",
      boxShadow: "0 0 min(1vw, 8px) rgba(185, 124, 84, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #b97c54, #a87155)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #845c3c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(185, 124, 84, 0.6)",
    },
  },
  youngBrassDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(187, 139, 80, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(105, 76, 28, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(245, 223, 143, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #624e30, #694c1c, #ab9459)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(187, 139, 80, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(171, 148, 89, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #bb8b50, #ab9459, #f5df8f, #bb8b50, #694c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(187, 139, 80, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(187, 139, 80, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(245, 223, 143, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(187, 139, 80, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(105, 76, 28, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #624e30, #694c1c, #ab9459)",
      border: "min(0.25vw, 2px) solid #bb8b50",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(187, 139, 80, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(187, 139, 80, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(171, 148, 89, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #bb8b50, #ab9459, #f5df8f, #bb8b50, #694c1c)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(187, 139, 80, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(187, 139, 80, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(171, 148, 89, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #624e30, #694c1c)",
      color: "#ccc6af",
      accentColor: "#bb8b50",
      border: "min(0.25vw, 2px) solid #bb8b50",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #694c1c, #624e30)",
    },
    stat: {
      background: "rgba(105, 76, 28, 0.8)",
      border: "min(0.25vw, 2px) solid #bb8b50",
      color: "#f5df8f",
      boxShadow: "0 0 min(1vw, 8px) rgba(187, 139, 80, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #bb8b50, #ab9459)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #694c1c",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(187, 139, 80, 0.6)",
    },
  },
  youngBrassDragon2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(210, 112, 61, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(121, 60, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(249, 218, 132, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #653c35, #793c14, #96534d)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(210, 112, 61, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(150, 83, 77, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #d2703d, #96534d, #f9da84, #d2703d, #793c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(210, 112, 61, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(210, 112, 61, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(249, 218, 132, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(210, 112, 61, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(121, 60, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #653c35, #793c14, #96534d)",
      border: "min(0.25vw, 2px) solid #d2703d",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(210, 112, 61, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(210, 112, 61, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(150, 83, 77, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #d2703d, #96534d, #f9da84, #d2703d, #793c14)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(210, 112, 61, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(210, 112, 61, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(150, 83, 77, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #653c35, #793c14)",
      color: "#ada38f",
      accentColor: "#d2703d",
      border: "min(0.25vw, 2px) solid #d2703d",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #793c14, #653c35)",
    },
    stat: {
      background: "rgba(121, 60, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #d2703d",
      color: "#f9da84",
      boxShadow: "0 0 min(1vw, 8px) rgba(210, 112, 61, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #d2703d, #96534d)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #793c14",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(210, 112, 61, 0.6)",
    },
  },
  youngCopperDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(203, 178, 129, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(101, 49, 31, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(216, 197, 161, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #554b38, #65311f, #9ea766)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(203, 178, 129, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(158, 167, 102, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #cbb281, #9ea766, #d8c5a1, #cbb281, #65311f)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(203, 178, 129, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(203, 178, 129, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(216, 197, 161, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(203, 178, 129, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(101, 49, 31, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #554b38, #65311f, #9ea766)",
      border: "min(0.25vw, 2px) solid #cbb281",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(203, 178, 129, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(203, 178, 129, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(158, 167, 102, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #cbb281, #9ea766, #d8c5a1, #cbb281, #65311f)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(203, 178, 129, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(203, 178, 129, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(158, 167, 102, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #554b38, #65311f)",
      color: "#9c9b94",
      accentColor: "#cbb281",
      border: "min(0.25vw, 2px) solid #cbb281",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #65311f, #554b38)",
    },
    stat: {
      background: "rgba(101, 49, 31, 0.8)",
      border: "min(0.25vw, 2px) solid #cbb281",
      color: "#d8c5a1",
      boxShadow: "0 0 min(1vw, 8px) rgba(203, 178, 129, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #cbb281, #9ea766)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #65311f",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(203, 178, 129, 0.6)",
    },
  },
  youngGreenDragon2: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(93, 162, 211, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(28, 72, 104, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(140, 200, 231, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #324c5e, #1c4868, #698ba3)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(93, 162, 211, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(105, 139, 163, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #5da2d3, #698ba3, #8cc8e7, #5da2d3, #1c4868)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(93, 162, 211, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(93, 162, 211, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(140, 200, 231, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(93, 162, 211, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(28, 72, 104, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #324c5e, #1c4868, #698ba3)",
      border: "min(0.25vw, 2px) solid #5da2d3",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(93, 162, 211, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(93, 162, 211, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(105, 139, 163, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #5da2d3, #698ba3, #8cc8e7, #5da2d3, #1c4868)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(93, 162, 211, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(93, 162, 211, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(105, 139, 163, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #324c5e, #1c4868)",
      color: "#c9c7aa",
      accentColor: "#5da2d3",
      border: "min(0.25vw, 2px) solid #5da2d3",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #1c4868, #324c5e)",
    },
    stat: {
      background: "rgba(28, 72, 104, 0.8)",
      border: "min(0.25vw, 2px) solid #5da2d3",
      color: "#8cc8e7",
      boxShadow: "0 0 min(1vw, 8px) rgba(93, 162, 211, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #5da2d3, #698ba3)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #1c4868",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(93, 162, 211, 0.6)",
    },
  },
  youngRedDragon3: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(201, 50, 41, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(111, 33, 26, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(235, 199, 145, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #31414f, #6f211a, #978776)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(201, 50, 41, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(151, 135, 118, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #c93229, #978776, #ebc791, #c93229, #6f211a)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(201, 50, 41, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(201, 50, 41, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(235, 199, 145, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(201, 50, 41, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(111, 33, 26, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #31414f, #6f211a, #978776)",
      border: "min(0.25vw, 2px) solid #c93229",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(201, 50, 41, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(201, 50, 41, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(151, 135, 118, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #c93229, #978776, #ebc791, #c93229, #6f211a)",
      color: "#ffffff",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(201, 50, 41, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(201, 50, 41, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(151, 135, 118, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #31414f, #6f211a)",
      color: "#d8cdbc",
      accentColor: "#c93229",
      border: "min(0.25vw, 2px) solid #c93229",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #6f211a, #31414f)",
    },
    stat: {
      background: "rgba(111, 33, 26, 0.8)",
      border: "min(0.25vw, 2px) solid #c93229",
      color: "#ebc791",
      boxShadow: "0 0 min(1vw, 8px) rgba(201, 50, 41, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #c93229, #978776)",
      color: "#ffffff",
      border: "min(0.25vw, 2px) solid #6f211a",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(201, 50, 41, 0.6)",
    },
  },
  youngWhiteDragon: {
    background:
      "radial-gradient(circle at 20% 30%, rgba(174, 145, 80, 0.4) 0%, transparent 50%),\n         radial-gradient(circle at 80% 70%, rgba(43, 36, 20, 0.5) 0%, transparent 40%),\n         radial-gradient(circle at 60% 10%, rgba(212, 198, 164, 0.3) 0%, transparent 45%),\n         linear-gradient(145deg, #3b4435, #2b2414, #788967)",
    header: {
      background:
        "radial-gradient(circle at 25% 50%, rgba(174, 145, 80, 0.4) 0%, transparent 60%),\n           radial-gradient(circle at 75% 50%, rgba(120, 137, 103, 0.4) 0%, transparent 60%),\n           linear-gradient(135deg, #ae9150, #788967, #d4c6a4, #ae9150, #2b2414)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(174, 145, 80, 0.6)",
      boxShadow:
        "0 min(0.5vw, 4px) min(1.8vw, 15px) rgba(174, 145, 80, 0.4), inset 0 min(0.25vw, 2px) 0 rgba(212, 198, 164, 0.3)",
    },
    imageArea: {
      background:
        "radial-gradient(circle at 30% 20%, rgba(174, 145, 80, 0.4) 0%, transparent 45%),\n           radial-gradient(circle at 70% 80%, rgba(43, 36, 20, 0.5) 0%, transparent 50%),\n           linear-gradient(145deg, #3b4435, #2b2414, #788967)",
      border: "min(0.25vw, 2px) solid #ae9150",
      boxShadow:
        "inset 0 min(0.5vw, 4px) min(1vw, 8px) rgba(0, 0, 0, 0.6), 0 0 min(2vw, 15px) rgba(174, 145, 80, 0.3)",
    },
    typeSection: {
      background:
        "radial-gradient(circle at 30% 60%, rgba(174, 145, 80, 0.4) 0%, transparent 55%),\n           radial-gradient(circle at 70% 60%, rgba(120, 137, 103, 0.4) 0%, transparent 55%),\n           linear-gradient(135deg, #ae9150, #788967, #d4c6a4, #ae9150, #2b2414)",
      color: "#1a1a1a",
      textShadow:
        "2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(174, 145, 80, 0.6)",
    },
    flavorText: {
      background:
        "radial-gradient(circle at 40% 30%, rgba(174, 145, 80, 0.4) 0%, transparent 50%),\n           radial-gradient(circle at 60% 70%, rgba(120, 137, 103, 0.4) 0%, transparent 50%),\n           linear-gradient(145deg, #3b4435, #2b2414)",
      color: "#b4c49c",
      accentColor: "#ae9150",
      border: "min(0.25vw, 2px) solid #ae9150",
    },
    bottomSection: {
      background: "linear-gradient(135deg, #2b2414, #3b4435)",
    },
    stat: {
      background: "rgba(43, 36, 20, 0.8)",
      border: "min(0.25vw, 2px) solid #ae9150",
      color: "#d4c6a4",
      boxShadow: "0 0 min(1vw, 8px) rgba(174, 145, 80, 0.5)",
    },
    rarity: {
      background: "linear-gradient(135deg, #ae9150, #788967)",
      color: "#1a1a1a",
      border: "min(0.25vw, 2px) solid #2b2414",
      boxShadow: "0 0 min(1.2vw, 10px) rgba(174, 145, 80, 0.6)",
    },
  },
};
